(() => {
	var e = {
		691: () => {
			/*! (c) Andrea Giammarchi @webreflection ISC */
			(function () {
				"use strict";
				var e = function e(t, r) {
					var a = function e(t) {
						for (var r = 0, a = t.length; r < a; r++) n(t[r]);
					};
					var n = function e(t) {
						var r = t.target,
							a = t.attributeName,
							n = t.oldValue;
						r.attributeChangedCallback(a, n, r.getAttribute(a));
					};
					return function (e, i) {
						var s = e.constructor.observedAttributes;
						if (s)
							t(i).then(function () {
								new r(a).observe(e, { attributes: true, attributeOldValue: true, attributeFilter: s });
								for (var t = 0, i = s.length; t < i; t++) if (e.hasAttribute(s[t])) n({ target: e, attributeName: s[t], oldValue: null });
							});
						return e;
					};
				};
				function t(e, t) {
					if (!e) return;
					if (typeof e === "string") return r(e, t);
					var a = Object.prototype.toString.call(e).slice(8, -1);
					if (a === "Object" && e.constructor) a = e.constructor.name;
					if (a === "Map" || a === "Set") return Array.from(e);
					if (a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)) return r(e, t);
				}
				function r(e, t) {
					if (t == null || t > e.length) t = e.length;
					for (var r = 0, a = new Array(t); r < t; r++) a[r] = e[r];
					return a;
				}
				function a(e, r) {
					var a = (typeof Symbol !== "undefined" && e[Symbol.iterator]) || e["@@iterator"];
					if (!a) {
						if (Array.isArray(e) || (a = t(e)) || (r && e && typeof e.length === "number")) {
							if (a) e = a;
							var n = 0;
							var i = function e() {};
							return {
								s: i,
								n: function t() {
									if (n >= e.length) return { done: true };
									return { done: false, value: e[n++] };
								},
								e: function e(t) {
									throw t;
								},
								f: i,
							};
						}
						throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
					}
					var s = true,
						o = false,
						l;
					return {
						s: function t() {
							a = a.call(e);
						},
						n: function e() {
							var t = a.next();
							s = t.done;
							return t;
						},
						e: function e(t) {
							o = true;
							l = t;
						},
						f: function e() {
							try {
								if (!s && a["return"] != null) a["return"]();
							} finally {
								if (o) throw l;
							}
						},
					};
				}
				/*! (c) Andrea Giammarchi - ISC */ var n = true,
					i = false,
					s = "querySelectorAll";
				var o = function e(t) {
					var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document;
					var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : MutationObserver;
					var l =
						arguments.length > 3 && arguments[3] !== void 0
							? arguments[3]
							: [
									"*",
								];
					var f = function e(r, i, o, l, f, u) {
						var c = a(r),
							d;
						try {
							for (c.s(); !(d = c.n()).done;) {
								var p = d.value;
								if (u || s in p) {
									if (f) {
										if (!o.has(p)) {
											o.add(p);
											l["delete"](p);
											t(p, f);
										}
									} else if (!l.has(p)) {
										l.add(p);
										o["delete"](p);
										t(p, f);
									}
									if (!u) e(p[s](i), i, o, l, f, n);
								}
							}
						} catch (e) {
							c.e(e);
						} finally {
							c.f();
						}
					};
					var u = new o(function (e) {
						if (l.length) {
							var t = l.join(",");
							var r = new Set(),
								s = new Set();
							var o = a(e),
								u;
							try {
								for (o.s(); !(u = o.n()).done;) {
									var c = u.value,
										d = c.addedNodes,
										p = c.removedNodes;
									f(p, t, r, s, i, i);
									f(d, t, r, s, n, i);
								}
							} catch (e) {
								o.e(e);
							} finally {
								o.f();
							}
						}
					});
					var c = u.observe;
					(u.observe = function (e) {
						return c.call(u, e, { subtree: n, childList: n });
					})(r);
					return u;
				};
				var l = "querySelectorAll";
				var f = self,
					u = f.document,
					c = f.Element,
					d = f.MutationObserver,
					p = f.Set,
					v = f.WeakMap;
				var h = function e(t) {
					return l in t;
				};
				var m = [].filter;
				var g = function e(t) {
					var r = new v();
					var a = function e(t) {
						for (var a = 0, n = t.length; a < n; a++) r["delete"](t[a]);
					};
					var n = function e() {
						var t = b.takeRecords();
						for (var r = 0, a = t.length; r < a; r++) {
							f(m.call(t[r].removedNodes, h), false);
							f(m.call(t[r].addedNodes, h), true);
						}
					};
					var i = function e(t) {
						return t.matches || t.webkitMatchesSelector || t.msMatchesSelector;
					};
					var s = function e(a, n) {
						var s;
						if (n) {
							for (var o, l = i(a), f = 0, u = g.length; f < u; f++)
								if (l.call(a, (o = g[f]))) {
									if (!r.has(a)) r.set(a, new p());
									s = r.get(a);
									if (!s.has(o)) {
										s.add(o);
										t.handle(a, n, o);
									}
								}
						} else if (r.has(a)) {
							s = r.get(a);
							r["delete"](a);
							s.forEach(function (e) {
								t.handle(a, n, e);
							});
						}
					};
					var f = function e(t) {
						var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
						for (var a = 0, n = t.length; a < n; a++) s(t[a], r);
					};
					var g = t.query;
					var y = t.root || u;
					var b = o(s, y, d, g);
					var w = c.prototype.attachShadow;
					if (w)
						c.prototype.attachShadow = function (e) {
							var t = w.call(this, e);
							b.observe(t);
							return t;
						};
					if (g.length) f(y[l](g));
					return { drop: a, flush: n, observer: b, parse: f };
				};
				var y = self,
					b = y.document,
					w = y.Map,
					S = y.MutationObserver,
					E = y.Object,
					x = y.Set,
					T = y.WeakMap,
					C = y.Element,
					M = y.HTMLElement,
					P = y.Node,
					O = y.Error,
					k = y.TypeError,
					$ = y.Reflect;
				var A = E.defineProperty,
					I = E.keys,
					z = E.getOwnPropertyNames,
					L = E.setPrototypeOf;
				var D = !self.customElements;
				var j = function e(t) {
					var r = I(t);
					var a = [];
					var n = new x();
					var i = r.length;
					for (var s = 0; s < i; s++) {
						a[s] = t[r[s]];
						try {
							delete t[r[s]];
						} catch (e) {
							n.add(s);
						}
					}
					return function () {
						for (var e = 0; e < i; e++) n.has(e) || (t[r[e]] = a[e]);
					};
				};
				if (D) {
					var _ = function e() {
						var t = this.constructor;
						if (!B.has(t)) throw new k("Illegal constructor");
						var r = B.get(t);
						if (F) return U(F, r);
						var a = N.call(b, r);
						return U(L(a, t.prototype), r);
					};
					var N = b.createElement;
					var B = new w();
					var H = new w();
					var W = new w();
					var R = new w();
					var G = [];
					var q = function e(t, r, a) {
						var n = W.get(a);
						if (r && !n.isPrototypeOf(t)) {
							var i = j(t);
							F = L(t, n);
							try {
								new n.constructor();
							} finally {
								F = null;
								i();
							}
						}
						var s = "".concat(r ? "" : "dis", "connectedCallback");
						if (s in n) t[s]();
					};
					var V = g({ query: G, handle: q }),
						X = V.parse;
					var F = null;
					var Y = function e(t) {
						if (!H.has(t)) {
							var r,
								a = new Promise(function (e) {
									r = e;
								});
							H.set(t, { $: a, _: r });
						}
						return H.get(t).$;
					};
					var U = e(Y, S);
					self.customElements = {
						define: function e(t, r) {
							if (R.has(t)) throw new O('the name "'.concat(t, '" has already been used with this registry'));
							B.set(r, t);
							W.set(t, r.prototype);
							R.set(t, r);
							G.push(t);
							Y(t).then(function () {
								X(b.querySelectorAll(t));
							});
							H.get(t)._(r);
						},
						get: function e(t) {
							return R.get(t);
						},
						whenDefined: Y,
					};
					A((_.prototype = M.prototype), "constructor", { value: _ });
					self.HTMLElement = _;
					b.createElement = function (e, t) {
						var r = t && t.is;
						var a = r ? R.get(r) : R.get(e);
						return a ? new a() : N.call(b, e);
					};
					if (!("isConnected" in P.prototype))
						A(P.prototype, "isConnected", {
							configurable: true,
							get: function e() {
								return !(this.ownerDocument.compareDocumentPosition(this) & this.DOCUMENT_POSITION_DISCONNECTED);
							},
						});
				} else {
					D = !self.customElements.get("extends-br");
					if (D)
						try {
							var K = function e() {
								return self.Reflect.construct(HTMLBRElement, [], e);
							};
							K.prototype = HTMLLIElement.prototype;
							var Z = "extends-br";
							self.customElements.define("extends-br", K, { extends: "br" });
							D = b.createElement("br", { is: Z }).outerHTML.indexOf(Z) < 0;
							var Q = self.customElements,
								J = Q.get,
								ee = Q.whenDefined;
							self.customElements.whenDefined = function (e) {
								var t = this;
								return ee.call(this, e).then(function (r) {
									return r || J.call(t, e);
								});
							};
						} catch (e) {}
				}
				if (D) {
					var te = function e(t) {
						var r = fe.get(t);
						we(r.querySelectorAll(this), t.isConnected);
					};
					var re = self.customElements;
					var ae = b.createElement;
					var ne = re.define,
						ie = re.get,
						se = re.upgrade;
					var oe = $ || {
							construct: function e(t) {
								return t.call(this);
							},
						},
						le = oe.construct;
					var fe = new T();
					var ue = new x();
					var ce = new w();
					var de = new w();
					var pe = new w();
					var ve = new w();
					var he = [];
					var me = [];
					var ge = function e(t) {
						return ve.get(t) || ie.call(re, t);
					};
					var ye = function e(t, r, a) {
						var n = pe.get(a);
						if (r && !n.isPrototypeOf(t)) {
							var i = j(t);
							Me = L(t, n);
							try {
								new n.constructor();
							} finally {
								Me = null;
								i();
							}
						}
						var s = "".concat(r ? "" : "dis", "connectedCallback");
						if (s in n) t[s]();
					};
					var be = g({ query: me, handle: ye }),
						we = be.parse;
					var Se = g({
							query: he,
							handle: function e(t, r) {
								if (fe.has(t)) {
									if (r) ue.add(t);
									else ue["delete"](t);
									if (me.length) te.call(me, t);
								}
							},
						}),
						Ee = Se.parse;
					var xe = C.prototype.attachShadow;
					if (xe)
						C.prototype.attachShadow = function (e) {
							var t = xe.call(this, e);
							fe.set(this, t);
							return t;
						};
					var Te = function e(t) {
						if (!de.has(t)) {
							var r,
								a = new Promise(function (e) {
									r = e;
								});
							de.set(t, { $: a, _: r });
						}
						return de.get(t).$;
					};
					var Ce = e(Te, S);
					var Me = null;
					z(self)
						.filter(function (e) {
							return /^HTML.*Element$/.test(e);
						})
						.forEach(function (e) {
							var t = self[e];
							function r() {
								var e = this.constructor;
								if (!ce.has(e)) throw new k("Illegal constructor");
								var r = ce.get(e),
									a = r.is,
									n = r.tag;
								if (a) {
									if (Me) return Ce(Me, a);
									var i = ae.call(b, n);
									i.setAttribute("is", a);
									return Ce(L(i, e.prototype), a);
								} else return le.call(this, t, [], e);
							}
							A((r.prototype = t.prototype), "constructor", { value: r });
							A(self, e, { value: r });
						});
					b.createElement = function (e, t) {
						var r = t && t.is;
						if (r) {
							var a = ve.get(r);
							if (a && ce.get(a).tag === e) return new a();
						}
						var n = ae.call(b, e);
						if (r) n.setAttribute("is", r);
						return n;
					};
					re.get = ge;
					re.whenDefined = Te;
					re.upgrade = function (e) {
						var t = e.getAttribute("is");
						if (t) {
							var r = ve.get(t);
							if (r) {
								Ce(L(e, r.prototype), t);
								return;
							}
						}
						se.call(re, e);
					};
					re.define = function (e, t, r) {
						if (ge(e)) throw new O("'".concat(e, "' has already been defined as a custom element"));
						var a;
						var n = r && r["extends"];
						ce.set(t, n ? { is: e, tag: n } : { is: "", tag: e });
						if (n) {
							a = "".concat(n, '[is="').concat(e, '"]');
							pe.set(a, t.prototype);
							ve.set(e, t);
							me.push(a);
						} else {
							ne.apply(re, arguments);
							he.push((a = e));
						}
						Te(e).then(function () {
							if (n) {
								we(b.querySelectorAll(a));
								ue.forEach(te, [
									a,
								]);
							} else Ee(b.querySelectorAll(a));
						});
						de.get(e)._(t);
					};
				}
			})();
		},
	};
	var t = {};
	function r(a) {
		var n = t[a];
		if (n !== void 0) return n.exports;
		var i = (t[a] = { exports: {} });
		e[a](i, i.exports, r);
		return i.exports;
	}
	(() => {
		"use strict";
		var e = r(691);
		var t = { duration: 0.3, delay: 0, endDelay: 0, repeat: 0, easing: "ease" };
		var a = {
			ms: function e(t) {
				return t * 1e3;
			},
			s: function e(t) {
				return t / 1e3;
			},
		};
		var n = function e() {};
		var i = function e(t) {
			return t;
		};
		function s(e) {
			var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
			if (!e || e.playState === "finished") return;
			try {
				if (e.stop) e.stop();
				else {
					t && e.commitStyles();
					e.cancel();
				}
			} catch (e) {}
		}
		var o = function e(t) {
			return t();
		};
		var l = function e(r, a) {
			var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : t.duration;
			return new Proxy({ animations: r.map(o).filter(Boolean), duration: n, options: a }, u);
		};
		var f = function e(t) {
			return t.animations[0];
		};
		var u = {
			get: function e(t, r) {
				var i = f(t);
				switch (r) {
					case "duration":
						return t.duration;
					case "currentTime":
						return a.s((i === null || i === void 0 ? void 0 : i[r]) || 0);
					case "playbackRate":
					case "playState":
						return i === null || i === void 0 ? void 0 : i[r];
					case "finished":
						if (!t.finished) t.finished = Promise.all(t.animations.map(c))["catch"](n);
						return t.finished;
					case "stop":
						return function () {
							t.animations.forEach(function (e) {
								return s(e);
							});
						};
					case "forEachNative":
						return function (e) {
							t.animations.forEach(function (r) {
								return e(r, t);
							});
						};
					default:
						return typeof (i === null || i === void 0 ? void 0 : i[r]) === "undefined"
							? void 0
							: function () {
									return t.animations.forEach(function (e) {
										return e[r]();
									});
								};
				}
			},
			set: function e(t, r, n) {
				switch (r) {
					case "currentTime":
						n = a.ms(n);
					case "playbackRate":
						for (var i = 0; i < t.animations.length; i++) t.animations[i][r] = n;
						return true;
				}
				return false;
			},
		};
		var c = function e(t) {
			return t.finished;
		};
		function d(e) {
			"@babel/helpers - typeof";
			return (
				(d =
					"function" == typeof Symbol && "symbol" == typeof Symbol.iterator
						? function (e) {
								return typeof e;
							}
						: function (e) {
								return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
							}),
				d(e)
			);
		}
		var p = function e(t) {
			return d(t) === "object" && Boolean(t.createAnimation);
		};
		var v = function e(t) {
			return typeof t === "number";
		};
		var h = function e(t) {
			return Array.isArray(t) && !v(t[0]);
		};
		var m = function e(t, r, a) {
			return -a * t + a * r + t;
		};
		var g = function e(t, r, a) {
			return r - t === 0 ? 1 : (a - t) / (r - t);
		};
		function y(e, t) {
			var r = e[e.length - 1];
			for (var a = 1; a <= t; a++) {
				var n = g(0, t, a);
				e.push(m(r, 1, n));
			}
		}
		function b(e) {
			var t = [
				0,
			];
			y(t, e - 1);
			return t;
		}
		var w = function e(t, r, a) {
			var n = r - t;
			return ((((a - t) % n) + n) % n) + t;
		};
		function S(e, t) {
			return h(e) ? e[w(0, e.length, t)] : e;
		}
		var E = function e(t, r, a) {
			return Math.min(Math.max(a, t), r);
		};
		function x(e) {
			var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : b(e.length);
			var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : i;
			var a = e.length;
			var n = a - t.length;
			n > 0 && y(t, n);
			return function (n) {
				var i = 0;
				for (; i < a - 2; i++) if (n < t[i + 1]) break;
				var s = E(0, 1, g(t[i], t[i + 1], n));
				var o = S(r, i);
				s = o(s);
				return m(e[i], e[i + 1], s);
			};
		}
		var T = function e(t, r, a) {
			return (((1 - 3 * a + 3 * r) * t + (3 * a - 6 * r)) * t + 3 * r) * t;
		};
		var C = 1e-7;
		var M = 12;
		function P(e, t, r, a, n) {
			var i;
			var s;
			var o = 0;
			do {
				s = t + (r - t) / 2;
				i = T(s, a, n) - e;
				if (i > 0) r = s;
				else t = s;
			} while (Math.abs(i) > C && ++o < M);
			return s;
		}
		function O(e, t, r, a) {
			if (e === t && r === a) return i;
			var n = function t(a) {
				return P(a, 0, 1, e, r);
			};
			return function (e) {
				return e === 0 || e === 1 ? e : T(n(e), t, a);
			};
		}
		var k = function e(t) {
			var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "end";
			return function (e) {
				e = r === "end" ? Math.min(e, 0.999) : Math.max(e, 0.001);
				var a = e * t;
				var n = r === "end" ? Math.floor(a) : Math.ceil(a);
				return E(0, 1, n / t);
			};
		};
		var A = function e(t) {
			return typeof t === "function";
		};
		var I = function e(t) {
			return Array.isArray(t) && v(t[0]);
		};
		function z(e) {
			return _(e) || j(e) || D(e) || L();
		}
		function L() {
			throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
		}
		function D(e, t) {
			if (e) {
				if ("string" == typeof e) return N(e, t);
				var r = {}.toString.call(e).slice(8, -1);
				return ("Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? N(e, t) : void 0);
			}
		}
		function j(e) {
			if (("undefined" != typeof Symbol && null != e[Symbol.iterator]) || null != e["@@iterator"]) return Array.from(e);
		}
		function _(e) {
			if (Array.isArray(e)) return N(e);
		}
		function N(e, t) {
			(null == t || t > e.length) && (t = e.length);
			for (var r = 0, a = Array(t); r < t; r++) a[r] = e[r];
			return a;
		}
		var B = { ease: O(0.25, 0.1, 0.25, 1), "ease-in": O(0.42, 0, 1, 1), "ease-in-out": O(0.42, 0, 0.58, 1), "ease-out": O(0, 0, 0.58, 1) };
		var H = /\((.*?)\)/;
		function W(e) {
			if (A(e)) return e;
			if (I(e)) return O.apply(void 0, z(e));
			var t = B[e];
			if (t) return t;
			if (e.startsWith("steps")) {
				var r = H.exec(e);
				if (r) {
					var a = r[1].split(",");
					return k(parseFloat(a[0]), a[1].trim());
				}
			}
			return i;
		}
		function R(e) {
			"@babel/helpers - typeof";
			return (
				(R =
					"function" == typeof Symbol && "symbol" == typeof Symbol.iterator
						? function (e) {
								return typeof e;
							}
						: function (e) {
								return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
							}),
				R(e)
			);
		}
		function G(e, t) {
			if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
		}
		function q(e, t) {
			for (var r = 0; r < t.length; r++) {
				var a = t[r];
				((a.enumerable = a.enumerable || !1), (a.configurable = !0), "value" in a && (a.writable = !0), Object.defineProperty(e, X(a.key), a));
			}
		}
		function V(e, t, r) {
			return (t && q(e.prototype, t), r && q(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e);
		}
		function X(e) {
			var t = F(e, "string");
			return "symbol" == R(t) ? t : t + "";
		}
		function F(e, t) {
			if ("object" != R(e) || !e) return e;
			var r = e[Symbol.toPrimitive];
			if (void 0 !== r) {
				var a = r.call(e, t || "default");
				if ("object" != R(a)) return a;
				throw new TypeError("@@toPrimitive must return a primitive value.");
			}
			return ("string" === t ? String : Number)(e);
		}
		var Y = (function () {
			function e(r) {
				var a = this;
				var n =
					arguments.length > 1 && arguments[1] !== void 0
						? arguments[1]
						: [
								0,
								1,
							];
				var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {},
					o = s.easing,
					l = s.duration,
					f = l === void 0 ? t.duration : l,
					u = s.delay,
					c = u === void 0 ? t.delay : u,
					d = s.endDelay,
					v = d === void 0 ? t.endDelay : d,
					m = s.repeat,
					g = m === void 0 ? t.repeat : m,
					y = s.offset,
					b = s.direction,
					w = b === void 0 ? "normal" : b,
					S = s.autoplay,
					E = S === void 0 ? true : S;
				G(this, e);
				this.startTime = null;
				this.rate = 1;
				this.t = 0;
				this.cancelTimestamp = null;
				this.easing = i;
				this.duration = 0;
				this.totalDuration = 0;
				this.repeat = 0;
				this.playState = "idle";
				this.finished = new Promise(function (e, t) {
					a.resolve = e;
					a.reject = t;
				});
				o = o || t.easing;
				if (p(o)) {
					var T = o.createAnimation(n);
					o = T.easing;
					n = T.keyframes || n;
					f = T.duration || f;
				}
				this.repeat = g;
				this.easing = h(o) ? i : W(o);
				this.updateDuration(f);
				var C = x(n, y, h(o) ? o.map(W) : i);
				this.tick = function (e) {
					var t;
					c;
					var n = 0;
					if (a.pauseTime !== void 0) n = a.pauseTime;
					else n = (e - a.startTime) * a.rate;
					a.t = n;
					n /= 1e3;
					n = Math.max(n - c, 0);
					if (a.playState === "finished" && a.pauseTime === void 0) n = a.totalDuration;
					var i = n / a.duration;
					var s = Math.floor(i);
					var o = i % 1;
					if (!o && i >= 1) o = 1;
					o === 1 && s--;
					var l = s % 2;
					if (w === "reverse" || (w === "alternate" && l) || (w === "alternate-reverse" && !l)) o = 1 - o;
					var f = n >= a.totalDuration ? 1 : Math.min(o, 1);
					var u = C(a.easing(f));
					r(u);
					var d = a.pauseTime === void 0 && (a.playState === "finished" || n >= a.totalDuration + v);
					if (d) {
						a.playState = "finished";
						(t = a.resolve) === null || t === void 0 ? void 0 : t.call(a, u);
					} else if (a.playState !== "idle") a.frameRequestId = requestAnimationFrame(a.tick);
				};
				if (E) this.play();
			}
			return V(e, [
				{
					key: "play",
					value: function e() {
						var t = performance.now();
						this.playState = "running";
						if (this.pauseTime !== void 0) this.startTime = t - this.pauseTime;
						else if (!this.startTime) this.startTime = t;
						this.cancelTimestamp = this.startTime;
						this.pauseTime = void 0;
						this.frameRequestId = requestAnimationFrame(this.tick);
					},
				},
				{
					key: "pause",
					value: function e() {
						this.playState = "paused";
						this.pauseTime = this.t;
					},
				},
				{
					key: "finish",
					value: function e() {
						this.playState = "finished";
						this.tick(0);
					},
				},
				{
					key: "stop",
					value: function e() {
						var t;
						this.playState = "idle";
						if (this.frameRequestId !== void 0) cancelAnimationFrame(this.frameRequestId);
						(t = this.reject) === null || t === void 0 ? void 0 : t.call(this, false);
					},
				},
				{
					key: "cancel",
					value: function e() {
						this.stop();
						this.tick(this.cancelTimestamp);
					},
				},
				{
					key: "reverse",
					value: function e() {
						this.rate *= -1;
					},
				},
				{ key: "commitStyles", value: function e() {} },
				{
					key: "updateDuration",
					value: function e(t) {
						this.duration = t;
						this.totalDuration = t * (this.repeat + 1);
					},
				},
				{
					key: "currentTime",
					get: function e() {
						return this.t;
					},
					set: function e(t) {
						if (this.pauseTime !== void 0 || this.rate === 0) this.pauseTime = t;
						else this.startTime = performance.now() - t / this.rate;
					},
				},
				{
					key: "playbackRate",
					get: function e() {
						return this.rate;
					},
					set: function e(t) {
						this.rate = t;
					},
				},
			]);
		})();
		var U = function e() {};
		var K = function e() {};
		if (false);
		function Z(e) {
			"@babel/helpers - typeof";
			return (
				(Z =
					"function" == typeof Symbol && "symbol" == typeof Symbol.iterator
						? function (e) {
								return typeof e;
							}
						: function (e) {
								return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
							}),
				Z(e)
			);
		}
		function Q(e, t) {
			if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
		}
		function J(e, t) {
			for (var r = 0; r < t.length; r++) {
				var a = t[r];
				((a.enumerable = a.enumerable || !1), (a.configurable = !0), "value" in a && (a.writable = !0), Object.defineProperty(e, te(a.key), a));
			}
		}
		function ee(e, t, r) {
			return (t && J(e.prototype, t), r && J(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e);
		}
		function te(e) {
			var t = re(e, "string");
			return "symbol" == Z(t) ? t : t + "";
		}
		function re(e, t) {
			if ("object" != Z(e) || !e) return e;
			var r = e[Symbol.toPrimitive];
			if (void 0 !== r) {
				var a = r.call(e, t || "default");
				if ("object" != Z(a)) return a;
				throw new TypeError("@@toPrimitive must return a primitive value.");
			}
			return ("string" === t ? String : Number)(e);
		}
		var ae = (function () {
			function e() {
				Q(this, e);
			}
			return ee(e, [
				{
					key: "setAnimation",
					value: function e(t) {
						var r = this;
						this.animation = t;
						t === null || t === void 0
							? void 0
							: t.finished
									.then(function () {
										return r.clearAnimation();
									})
									["catch"](function () {});
					},
				},
				{
					key: "clearAnimation",
					value: function e() {
						this.animation = this.generator = void 0;
					},
				},
			]);
		})();
		var ne = new WeakMap();
		function ie(e) {
			if (!ne.has(e)) ne.set(e, { transforms: [], values: new Map() });
			return ne.get(e);
		}
		function se(e, t) {
			if (!e.has(t)) e.set(t, new ae());
			return e.get(t);
		}
		function oe(e, t) {
			e.indexOf(t) === -1 && e.push(t);
		}
		function le(e, t) {
			var r = e.indexOf(t);
			r > -1 && e.splice(r, 1);
		}
		var fe = [
			"",
			"X",
			"Y",
			"Z",
		];
		var ue = [
			"translate",
			"scale",
			"rotate",
			"skew",
		];
		var ce = { x: "translateX", y: "translateY", z: "translateZ" };
		var de = {
			syntax: "<angle>",
			initialValue: "0deg",
			toDefaultUnit: function e(t) {
				return t + "deg";
			},
		};
		var pe = {
			translate: {
				syntax: "<length-percentage>",
				initialValue: "0px",
				toDefaultUnit: function e(t) {
					return t + "px";
				},
			},
			rotate: de,
			scale: { syntax: "<number>", initialValue: 1, toDefaultUnit: i },
			skew: de,
		};
		var ve = new Map();
		var he = function e(t) {
			return "--motion-".concat(t);
		};
		var me = [
			"x",
			"y",
			"z",
		];
		ue.forEach(function (e) {
			fe.forEach(function (t) {
				me.push(e + t);
				ve.set(he(e + t), pe[e]);
			});
		});
		var ge = function e(t, r) {
			return me.indexOf(t) - me.indexOf(r);
		};
		var ye = new Set(me);
		var be = function e(t) {
			return ye.has(t);
		};
		var we = function e(t, r) {
			if (ce[r]) r = ce[r];
			var a = ie(t),
				n = a.transforms;
			oe(n, r);
			t.style.transform = Se(n);
		};
		var Se = function e(t) {
			return t.sort(ge).reduce(Ee, "").trim();
		};
		var Ee = function e(t, r) {
			return "".concat(t, " ").concat(r, "(var(").concat(he(r), "))");
		};
		var xe = function e(t) {
			return t.startsWith("--");
		};
		var Te = new Set();
		function Ce(e) {
			if (Te.has(e)) return;
			Te.add(e);
			try {
				var t = ve.has(e) ? ve.get(e) : {},
					r = t.syntax,
					a = t.initialValue;
				CSS.registerProperty({ name: e, inherits: false, syntax: r, initialValue: a });
			} catch (e) {}
		}
		var Me = function e(t, r) {
			return document.createElement("div").animate(t, r);
		};
		var Pe = {
			cssRegisterProperty: function e() {
				return typeof CSS !== "undefined" && Object.hasOwnProperty.call(CSS, "registerProperty");
			},
			waapi: function e() {
				return Object.hasOwnProperty.call(Element.prototype, "animate");
			},
			partialKeyframes: function e() {
				try {
					Me({
						opacity: [
							1,
						],
					});
				} catch (e) {
					return false;
				}
				return true;
			},
			finished: function e() {
				return Boolean(
					Me(
						{
							opacity: [
								0,
								1,
							],
						},
						{ duration: 0.001 },
					).finished,
				);
			},
			linearEasing: function e() {
				try {
					Me({ opacity: 0 }, { easing: "linear(0, 1)" });
				} catch (e) {
					return false;
				}
				return true;
			},
		};
		var Oe = {};
		var ke = {};
		var $e = function e(t) {
			ke[t] = function () {
				if (Oe[t] === void 0) Oe[t] = Pe[t]();
				return Oe[t];
			};
		};
		for (var Ae in Pe) $e(Ae);
		function Ie(e, t) {
			return _e(e) || je(e, t) || Le(e, t) || ze();
		}
		function ze() {
			throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
		}
		function Le(e, t) {
			if (e) {
				if ("string" == typeof e) return De(e, t);
				var r = {}.toString.call(e).slice(8, -1);
				return ("Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? De(e, t) : void 0);
			}
		}
		function De(e, t) {
			(null == t || t > e.length) && (t = e.length);
			for (var r = 0, a = Array(t); r < t; r++) a[r] = e[r];
			return a;
		}
		function je(e, t) {
			var r = null == e ? null : ("undefined" != typeof Symbol && e[Symbol.iterator]) || e["@@iterator"];
			if (null != r) {
				var a,
					n,
					i,
					s,
					o = [],
					l = !0,
					f = !1;
				try {
					if (((i = (r = r.call(e)).next), 0 === t)) {
						if (Object(r) !== r) return;
						l = !1;
					} else for (; !(l = (a = i.call(r)).done) && (o.push(a.value), o.length !== t); l = !0);
				} catch (e) {
					((f = !0), (n = e));
				} finally {
					try {
						if (!l && null != r["return"] && ((s = r["return"]()), Object(s) !== s)) return;
					} finally {
						if (f) throw n;
					}
				}
				return o;
			}
		}
		function _e(e) {
			if (Array.isArray(e)) return e;
		}
		var Ne = 0.015;
		var Be = function e(t, r) {
			var a = "";
			var n = Math.round(r / Ne);
			for (var i = 0; i < n; i++) a += t(g(0, n - 1, i)) + ", ";
			return a.substring(0, a.length - 2);
		};
		var He = function e(r, a) {
			if (A(r)) return ke.linearEasing() ? "linear(".concat(Be(r, a), ")") : t.easing;
			else return I(r) ? We(r) : r;
		};
		var We = function e(t) {
			var r = Ie(t, 4),
				a = r[0],
				n = r[1],
				i = r[2],
				s = r[3];
			return "cubic-bezier(".concat(a, ", ").concat(n, ", ").concat(i, ", ").concat(s, ")");
		};
		function Re(e, t) {
			for (var r = 0; r < e.length; r++) if (e[r] === null) e[r] = r ? e[r - 1] : t();
			return e;
		}
		var Ge = function e(t) {
			return Array.isArray(t)
				? t
				: [
						t,
					];
		};
		function qe(e) {
			if (ce[e]) e = ce[e];
			return be(e) ? he(e) : e;
		}
		var Ve = {
			get: function e(t, r) {
				r = qe(r);
				var a = xe(r) ? t.style.getPropertyValue(r) : getComputedStyle(t)[r];
				if (!a && a !== 0) {
					var n = ve.get(r);
					if (n) a = n.initialValue;
				}
				return a;
			},
			set: function e(t, r, a) {
				r = qe(r);
				if (xe(r)) t.style.setProperty(r, a);
				else t.style[r] = a;
			},
		};
		var Xe = function e(t) {
			return typeof t === "string";
		};
		function Fe(e, t) {
			var r;
			var a = (t === null || t === void 0 ? void 0 : t.toDefaultUnit) || i;
			var n = e[e.length - 1];
			if (Xe(n)) {
				var s = ((r = n.match(/(-?[\d.]+)([a-z%]*)/)) === null || r === void 0 ? void 0 : r[2]) || "";
				if (s)
					a = function e(t) {
						return t + s;
					};
			}
			return a;
		}
		function Ye(e) {
			"@babel/helpers - typeof";
			return (
				(Ye =
					"function" == typeof Symbol && "symbol" == typeof Symbol.iterator
						? function (e) {
								return typeof e;
							}
						: function (e) {
								return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
							}),
				Ye(e)
			);
		}
		function Ue(e, t, r) {
			return ((t = Ke(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = r), e);
		}
		function Ke(e) {
			var t = Ze(e, "string");
			return "symbol" == Ye(t) ? t : t + "";
		}
		function Ze(e, t) {
			if ("object" != Ye(e) || !e) return e;
			var r = e[Symbol.toPrimitive];
			if (void 0 !== r) {
				var a = r.call(e, t || "default");
				if ("object" != Ye(a)) return a;
				throw new TypeError("@@toPrimitive must return a primitive value.");
			}
			return ("string" === t ? String : Number)(e);
		}
		function Qe() {
			return window.__MOTION_DEV_TOOLS_RECORD;
		}
		function Je(e, r, i) {
			var o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
			var l = arguments.length > 4 ? arguments[4] : void 0;
			var f = Qe();
			var u = o.record !== false && f;
			var c;
			var d = o.duration,
				m = d === void 0 ? t.duration : d,
				g = o.delay,
				y = g === void 0 ? t.delay : g,
				b = o.endDelay,
				w = b === void 0 ? t.endDelay : b,
				S = o.repeat,
				E = S === void 0 ? t.repeat : S,
				x = o.easing,
				T = x === void 0 ? t.easing : x,
				C = o.persist,
				M = C === void 0 ? false : C,
				P = o.direction,
				O = o.offset,
				k = o.allowWebkitAcceleration,
				$ = k === void 0 ? false : k,
				I = o.autoplay,
				z = I === void 0 ? true : I;
			var L = ie(e);
			var D = be(r);
			var j = ke.waapi();
			D && we(e, r);
			var _ = qe(r);
			var N = se(L.values, _);
			var B = ve.get(_);
			s(N.animation, !(p(T) && N.generator) && o.record !== false);
			return function () {
				var t = function t() {
					var r, a;
					return (a = (r = Ve.get(e, _)) !== null && r !== void 0 ? r : B === null || B === void 0 ? void 0 : B.initialValue) !== null && a !== void 0 ? a : 0;
				};
				var s = Re(Ge(i), t);
				var d = Fe(s, B);
				if (p(T)) {
					var g = T.createAnimation(s, r !== "opacity", t, _, N);
					T = g.easing;
					s = g.keyframes || s;
					m = g.duration || m;
				}
				if (xe(_))
					if (ke.cssRegisterProperty()) Ce(_);
					else j = false;
				if (D && !ke.linearEasing() && (A(T) || (h(T) && T.some(A)))) j = false;
				if (j) {
					if (B)
						s = s.map(function (e) {
							return v(e) ? B.toDefaultUnit(e) : e;
						});
					if (s.length === 1 && (!ke.partialKeyframes() || u)) s.unshift(t());
					var b = { delay: a.ms(y), duration: a.ms(m), endDelay: a.ms(w), easing: !h(T) ? He(T, m) : void 0, direction: P, iterations: E + 1, fill: "both" };
					c = e.animate(
						Ue(
							Ue(Ue({}, _, s), "offset", O),
							"easing",
							h(T)
								? T.map(function (e) {
										return He(e, m);
									})
								: void 0,
						),
						b,
					);
					if (!c.finished)
						c.finished = new Promise(function (e, t) {
							c.onfinish = e;
							c.oncancel = t;
						});
					var S = s[s.length - 1];
					c.finished
						.then(function () {
							if (M) return;
							Ve.set(e, _, S);
							c.cancel();
						})
						["catch"](n);
					if (!$) c.playbackRate = 1.000001;
				} else if (l && D) {
					s = s.map(function (e) {
						return typeof e === "string" ? parseFloat(e) : e;
					});
					if (s.length === 1) s.unshift(parseFloat(t()));
					c = new l(
						function (t) {
							Ve.set(e, _, d ? d(t) : t);
						},
						s,
						Object.assign(Object.assign({}, o), { duration: m, easing: T }),
					);
				} else {
					var x = s[s.length - 1];
					Ve.set(e, _, B && v(x) ? B.toDefaultUnit(x) : x);
				}
				if (u) f(e, r, s, { duration: m, delay: y, easing: T, repeat: E, offset: O }, "motion-one");
				N.setAnimation(c);
				if (c && !z) c.pause();
				return c;
			};
		}
		var et = function e(t, r) {
			return t[r] ? Object.assign(Object.assign({}, t), t[r]) : Object.assign({}, t);
		};
		function tt(e, t) {
			var r;
			if (typeof e === "string")
				if (t) {
					(r = t[e]) !== null && r !== void 0 ? r : (t[e] = document.querySelectorAll(e));
					e = t[e];
				} else e = document.querySelectorAll(e);
			else if (e instanceof Element)
				e = [
					e,
				];
			return Array.from(e || []);
		}
		function rt() {
			var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0.1;
			var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
				r = t.start,
				a = r === void 0 ? 0 : r,
				n = t.from,
				i = n === void 0 ? 0 : n,
				s = t.easing;
			return function (t, r) {
				var n = v(i) ? i : at(i, r);
				var o = Math.abs(n - t);
				var l = e * o;
				if (s) {
					var f = r * e;
					var u = W(s);
					l = u(l / f) * f;
				}
				return a + l;
			};
		}
		function at(e, t) {
			if (e === "first") return 0;
			else {
				var r = t - 1;
				return e === "last" ? r : r / 2;
			}
		}
		function nt(e, t, r) {
			return A(e) ? e(t, r) : e;
		}
		function it(e) {
			return function t(r, a) {
				var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
				r = tt(r);
				var i = r.length;
				K(Boolean(i), "No valid element provided.");
				K(Boolean(a), "No keyframes defined.");
				var s = [];
				for (var o = 0; o < i; o++) {
					var f = r[o];
					for (var u in a) {
						var c = et(n, u);
						c.delay = nt(c.delay, o, i);
						var d = Je(f, u, a[u], c, e);
						s.push(d);
					}
				}
				return l(s, n, n.duration);
			};
		}
		var st = it(Y);
		function ot(e) {
			var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
			return l(
				[
					function () {
						var r = new Y(
							e,
							[
								0,
								1,
							],
							t,
						);
						r.finished["catch"](function () {});
						return r;
					},
				],
				t,
				t.duration,
			);
		}
		function lt(e, t, r) {
			var a = A(e) ? ot : st;
			return a(e, t, r);
		}
		var ft = { any: 0, all: 1 };
		function ut(e, t) {
			var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {},
				a = r.root,
				n = r.margin,
				i = r.amount,
				s = i === void 0 ? "any" : i;
			if (typeof IntersectionObserver === "undefined") return function () {};
			var o = tt(e);
			var l = new WeakMap();
			var f = function e(r) {
				r.forEach(function (e) {
					var r = l.get(e.target);
					if (e.isIntersecting === Boolean(r)) return;
					if (e.isIntersecting) {
						var a = t(e);
						if (A(a)) l.set(e.target, a);
						else u.unobserve(e.target);
					} else if (r) {
						r(e);
						l["delete"](e.target);
					}
				});
			};
			var u = new IntersectionObserver(f, { root: a, rootMargin: n, threshold: typeof s === "number" ? s : ft[s] });
			o.forEach(function (e) {
				return u.observe(e);
			});
			return function () {
				return u.disconnect();
			};
		}
		function ct(e) {
			"@babel/helpers - typeof";
			return (
				(ct =
					"function" == typeof Symbol && "symbol" == typeof Symbol.iterator
						? function (e) {
								return typeof e;
							}
						: function (e) {
								return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
							}),
				ct(e)
			);
		}
		var dt = function e(t, r) {
			dt =
				Object.setPrototypeOf ||
				({ __proto__: [] } instanceof Array &&
					function (e, t) {
						e.__proto__ = t;
					}) ||
				function (e, t) {
					for (var r in t) if (Object.prototype.hasOwnProperty.call(t, r)) e[r] = t[r];
				};
			return dt(t, r);
		};
		function pt(e, t) {
			if (typeof t !== "function" && t !== null) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
			dt(e, t);
			function r() {
				this.constructor = e;
			}
			e.prototype = t === null ? Object.create(t) : ((r.prototype = t.prototype), new r());
		}
		var vt = function e() {
			vt =
				Object.assign ||
				function e(t) {
					for (var r, a = 1, n = arguments.length; a < n; a++) {
						r = arguments[a];
						for (var i in r) if (Object.prototype.hasOwnProperty.call(r, i)) t[i] = r[i];
					}
					return t;
				};
			return vt.apply(this, arguments);
		};
		function ht(e, t) {
			var r = {};
			for (var a in e) if (Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0) r[a] = e[a];
			if (e != null && typeof Object.getOwnPropertySymbols === "function") for (var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++) if (t.indexOf(a[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[n])) r[a[n]] = e[a[n]];
			return r;
		}
		function mt(e, t, r, a) {
			var n = arguments.length,
				i = n < 3 ? t : a === null ? (a = Object.getOwnPropertyDescriptor(t, r)) : a,
				s;
			if ((typeof Reflect === "undefined" ? "undefined" : ct(Reflect)) === "object" && typeof Reflect.decorate === "function") i = Reflect.decorate(e, t, r, a);
			else for (var o = e.length - 1; o >= 0; o--) if ((s = e[o])) i = (n < 3 ? s(i) : n > 3 ? s(t, r, i) : s(t, r)) || i;
			return (n > 3 && i && Object.defineProperty(t, r, i), i);
		}
		function gt(e, t) {
			return function (r, a) {
				t(r, a, e);
			};
		}
		function yt(e, t, r, a, n, i) {
			function s(e) {
				if (e !== void 0 && typeof e !== "function") throw new TypeError("Function expected");
				return e;
			}
			var o = a.kind,
				l = o === "getter" ? "get" : o === "setter" ? "set" : "value";
			var f = !t && e ? (a["static"] ? e : e.prototype) : null;
			var u = t || (f ? Object.getOwnPropertyDescriptor(f, a.name) : {});
			var c,
				d = false;
			for (var p = r.length - 1; p >= 0; p--) {
				var v = {};
				for (var h in a) v[h] = h === "access" ? {} : a[h];
				for (var h in a.access) v.access[h] = a.access[h];
				v.addInitializer = function (e) {
					if (d) throw new TypeError("Cannot add initializers after decoration has completed");
					i.push(s(e || null));
				};
				var m = (0, r[p])(o === "accessor" ? { get: u.get, set: u.set } : u[l], v);
				if (o === "accessor") {
					if (m === void 0) continue;
					if (m === null || ct(m) !== "object") throw new TypeError("Object expected");
					if ((c = s(m.get))) u.get = c;
					if ((c = s(m.set))) u.set = c;
					if ((c = s(m.init))) n.unshift(c);
				} else if ((c = s(m)))
					if (o === "field") n.unshift(c);
					else u[l] = c;
			}
			if (f) Object.defineProperty(f, a.name, u);
			d = true;
		}
		function bt(e, t, r) {
			var a = arguments.length > 2;
			for (var n = 0; n < t.length; n++) r = a ? t[n].call(e, r) : t[n].call(e);
			return a ? r : void 0;
		}
		function wt(e) {
			return ct(e) === "symbol" ? e : "".concat(e);
		}
		function St(e, t, r) {
			if (ct(t) === "symbol") t = t.description ? "[".concat(t.description, "]") : "";
			return Object.defineProperty(e, "name", { configurable: true, value: r ? "".concat(r, " ", t) : t });
		}
		function Et(e, t) {
			if ((typeof Reflect === "undefined" ? "undefined" : ct(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(e, t);
		}
		function xt(e, t, r, a) {
			function n(e) {
				return e instanceof r
					? e
					: new r(function (t) {
							t(e);
						});
			}
			return new (r || (r = Promise))(function (r, i) {
				function s(e) {
					try {
						l(a.next(e));
					} catch (e) {
						i(e);
					}
				}
				function o(e) {
					try {
						l(a["throw"](e));
					} catch (e) {
						i(e);
					}
				}
				function l(e) {
					e.done ? r(e.value) : n(e.value).then(s, o);
				}
				l((a = a.apply(e, t || [])).next());
			});
		}
		function Tt(e, t) {
			var r = {
					label: 0,
					sent: function e() {
						if (i[0] & 1) throw i[1];
						return i[1];
					},
					trys: [],
					ops: [],
				},
				a,
				n,
				i,
				s = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
			return (
				(s.next = o(0)),
				(s["throw"] = o(1)),
				(s["return"] = o(2)),
				typeof Symbol === "function" &&
					(s[Symbol.iterator] = function () {
						return this;
					}),
				s
			);
			function o(e) {
				return function (t) {
					return l([
						e,
						t,
					]);
				};
			}
			function l(o) {
				if (a) throw new TypeError("Generator is already executing.");
				while ((s && ((s = 0), o[0] && (r = 0)), r))
					try {
						if (((a = 1), n && (i = o[0] & 2 ? n["return"] : o[0] ? n["throw"] || ((i = n["return"]) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done)) return i;
						if (((n = 0), i))
							o = [
								o[0] & 2,
								i.value,
							];
						switch (o[0]) {
							case 0:
							case 1:
								i = o;
								break;
							case 4:
								r.label++;
								return { value: o[1], done: false };
							case 5:
								r.label++;
								n = o[1];
								o = [
									0,
								];
								continue;
							case 7:
								o = r.ops.pop();
								r.trys.pop();
								continue;
							default:
								if (!((i = r.trys), (i = i.length > 0 && i[i.length - 1])) && (o[0] === 6 || o[0] === 2)) {
									r = 0;
									continue;
								}
								if (o[0] === 3 && (!i || (o[1] > i[0] && o[1] < i[3]))) {
									r.label = o[1];
									break;
								}
								if (o[0] === 6 && r.label < i[1]) {
									r.label = i[1];
									i = o;
									break;
								}
								if (i && r.label < i[2]) {
									r.label = i[2];
									r.ops.push(o);
									break;
								}
								if (i[2]) r.ops.pop();
								r.trys.pop();
								continue;
						}
						o = t.call(e, r);
					} catch (e) {
						o = [
							6,
							e,
						];
						n = 0;
					} finally {
						a = i = 0;
					}
				if (o[0] & 5) throw o[1];
				return { value: o[0] ? o[1] : void 0, done: true };
			}
		}
		var Ct = Object.create
			? function (e, t, r, a) {
					if (a === void 0) a = r;
					var n = Object.getOwnPropertyDescriptor(t, r);
					if (!n || ("get" in n ? !t.__esModule : n.writable || n.configurable))
						n = {
							enumerable: true,
							get: function e() {
								return t[r];
							},
						};
					Object.defineProperty(e, a, n);
				}
			: function (e, t, r, a) {
					if (a === void 0) a = r;
					e[a] = t[r];
				};
		function Mt(e, t) {
			for (var r in e) if (r !== "default" && !Object.prototype.hasOwnProperty.call(t, r)) Ct(t, e, r);
		}
		function Pt(e) {
			var t = typeof Symbol === "function" && Symbol.iterator,
				r = t && e[t],
				a = 0;
			if (r) return r.call(e);
			if (e && typeof e.length === "number")
				return {
					next: function t() {
						if (e && a >= e.length) e = void 0;
						return { value: e && e[a++], done: !e };
					},
				};
			throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
		}
		function Ot(e, t) {
			var r = typeof Symbol === "function" && e[Symbol.iterator];
			if (!r) return e;
			var a = r.call(e),
				n,
				i = [],
				s;
			try {
				while ((t === void 0 || t-- > 0) && !(n = a.next()).done) i.push(n.value);
			} catch (e) {
				s = { error: e };
			} finally {
				try {
					if (n && !n.done && (r = a["return"])) r.call(a);
				} finally {
					if (s) throw s.error;
				}
			}
			return i;
		}
		function kt() {
			for (var e = [], t = 0; t < arguments.length; t++) e = e.concat(Ot(arguments[t]));
			return e;
		}
		function $t() {
			for (var e = 0, t = 0, r = arguments.length; t < r; t++) e += arguments[t].length;
			for (var a = Array(e), n = 0, t = 0; t < r; t++) for (var i = arguments[t], s = 0, o = i.length; s < o; s++, n++) a[n] = i[s];
			return a;
		}
		function At(e, t, r) {
			if (r || arguments.length === 2)
				for (var a = 0, n = t.length, i; a < n; a++)
					if (i || !(a in t)) {
						if (!i) i = Array.prototype.slice.call(t, 0, a);
						i[a] = t[a];
					}
			return e.concat(i || Array.prototype.slice.call(t));
		}
		function It(e) {
			return this instanceof It ? ((this.v = e), this) : new It(e);
		}
		function zt(e, t, r) {
			if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
			var a = r.apply(e, t || []),
				n,
				i = [];
			return (
				(n = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype)),
				o("next"),
				o("throw"),
				o("return", s),
				(n[Symbol.asyncIterator] = function () {
					return this;
				}),
				n
			);
			function s(e) {
				return function (t) {
					return Promise.resolve(t).then(e, c);
				};
			}
			function o(e, t) {
				if (a[e]) {
					n[e] = function (t) {
						return new Promise(function (r, a) {
							i.push([
								e,
								t,
								r,
								a,
							]) > 1 || l(e, t);
						});
					};
					if (t) n[e] = t(n[e]);
				}
			}
			function l(e, t) {
				try {
					f(a[e](t));
				} catch (e) {
					d(i[0][3], e);
				}
			}
			function f(e) {
				e.value instanceof It ? Promise.resolve(e.value.v).then(u, c) : d(i[0][2], e);
			}
			function u(e) {
				l("next", e);
			}
			function c(e) {
				l("throw", e);
			}
			function d(e, t) {
				if ((e(t), i.shift(), i.length)) l(i[0][0], i[0][1]);
			}
		}
		function Lt(e) {
			var t, r;
			return (
				(t = {}),
				a("next"),
				a("throw", function (e) {
					throw e;
				}),
				a("return"),
				(t[Symbol.iterator] = function () {
					return this;
				}),
				t
			);
			function a(a, n) {
				t[a] = e[a]
					? function (t) {
							return (r = !r) ? { value: It(e[a](t)), done: false } : n ? n(t) : t;
						}
					: n;
			}
		}
		function Dt(e) {
			if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
			var t = e[Symbol.asyncIterator],
				r;
			return t
				? t.call(e)
				: ((e = typeof Pt === "function" ? Pt(e) : e[Symbol.iterator]()),
					(r = {}),
					a("next"),
					a("throw"),
					a("return"),
					(r[Symbol.asyncIterator] = function () {
						return this;
					}),
					r);
			function a(t) {
				r[t] =
					e[t] &&
					function (r) {
						return new Promise(function (a, i) {
							((r = e[t](r)), n(a, i, r.done, r.value));
						});
					};
			}
			function n(e, t, r, a) {
				Promise.resolve(a).then(function (t) {
					e({ value: t, done: r });
				}, t);
			}
		}
		function jt(e, t) {
			if (Object.defineProperty) Object.defineProperty(e, "raw", { value: t });
			else e.raw = t;
			return e;
		}
		var _t = Object.create
			? function (e, t) {
					Object.defineProperty(e, "default", { enumerable: true, value: t });
				}
			: function (e, t) {
					e["default"] = t;
				};
		function Nt(e) {
			if (e && e.__esModule) return e;
			var t = {};
			if (e != null) for (var r in e) if (r !== "default" && Object.prototype.hasOwnProperty.call(e, r)) Ct(t, e, r);
			_t(t, e);
			return t;
		}
		function Bt(e) {
			return e && e.__esModule ? e : { default: e };
		}
		function Ht(e, t, r, a) {
			if (r === "a" && !a) throw new TypeError("Private accessor was defined without a getter");
			if (typeof t === "function" ? e !== t || !a : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
			return r === "m" ? a : r === "a" ? a.call(e) : a ? a.value : t.get(e);
		}
		function Wt(e, t, r, a, n) {
			if (a === "m") throw new TypeError("Private method is not writable");
			if (a === "a" && !n) throw new TypeError("Private accessor was defined without a setter");
			if (typeof t === "function" ? e !== t || !n : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
			return (a === "a" ? n.call(e, r) : n ? (n.value = r) : t.set(e, r), r);
		}
		function Rt(e, t) {
			if (t === null || (ct(t) !== "object" && typeof t !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
			return typeof e === "function" ? t === e : e.has(t);
		}
		function Gt(e, t, r) {
			if (t !== null && t !== void 0) {
				if (ct(t) !== "object" && typeof t !== "function") throw new TypeError("Object expected.");
				var a, n;
				if (r) {
					if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
					a = t[Symbol.asyncDispose];
				}
				if (a === void 0) {
					if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
					a = t[Symbol.dispose];
					if (r) n = a;
				}
				if (typeof a !== "function") throw new TypeError("Object not disposable.");
				if (n)
					a = function e() {
						try {
							n.call(this);
						} catch (e) {
							return Promise.reject(e);
						}
					};
				e.stack.push({ value: t, dispose: a, async: r });
			} else if (r) e.stack.push({ async: true });
			return t;
		}
		var qt =
			typeof SuppressedError === "function"
				? SuppressedError
				: function (e, t, r) {
						var a = new Error(r);
						return ((a.name = "SuppressedError"), (a.error = e), (a.suppressed = t), a);
					};
		function Vt(e) {
			function t(t) {
				e.error = e.hasError ? new qt(t, e.error, "An error was suppressed during disposal.") : t;
				e.hasError = true;
			}
			var r,
				a = 0;
			function n() {
				while ((r = e.stack.pop()))
					try {
						if (!r.async && a === 1) return ((a = 0), e.stack.push(r), Promise.resolve().then(n));
						if (r.dispose) {
							var i = r.dispose.call(r.value);
							if (r.async)
								return (
									(a |= 2),
									Promise.resolve(i).then(n, function (e) {
										t(e);
										return n();
									})
								);
						} else a |= 1;
					} catch (e) {
						t(e);
					}
				if (a === 1) return e.hasError ? Promise.reject(e.error) : Promise.resolve();
				if (e.hasError) throw e.error;
			}
			return n();
		}
		const Xt = {
			__extends: pt,
			__assign: vt,
			__rest: ht,
			__decorate: mt,
			__param: gt,
			__metadata: Et,
			__awaiter: xt,
			__generator: Tt,
			__createBinding: Ct,
			__exportStar: Mt,
			__values: Pt,
			__read: Ot,
			__spread: kt,
			__spreadArrays: $t,
			__spreadArray: At,
			__await: It,
			__asyncGenerator: zt,
			__asyncDelegator: Lt,
			__asyncValues: Dt,
			__makeTemplateObject: jt,
			__importStar: Nt,
			__importDefault: Bt,
			__classPrivateFieldGet: Ht,
			__classPrivateFieldSet: Wt,
			__classPrivateFieldIn: Rt,
			__addDisposableResource: Gt,
			__disposeResources: Vt,
		};
		function Ft(e, t, r, a) {
			var n;
			if (v(t)) return t;
			else if (t.startsWith("-") || t.startsWith("+")) return Math.max(0, e + parseFloat(t));
			else if (t === "<") return r;
			else return (n = a.get(t)) !== null && n !== void 0 ? n : e;
		}
		function Yt(e, t, r) {
			for (var a = 0; a < e.length; a++) {
				var n = e[a];
				if (n.at > t && n.at < r) {
					le(e, n);
					a--;
				}
			}
		}
		function Ut(e, t, r, a, n, i) {
			Yt(e, n, i);
			for (var s = 0; s < t.length; s++) e.push({ value: t[s], at: m(n, i, a[s]), easing: S(r, s) });
		}
		function Kt(e, t) {
			if (e.at === t.at) return e.value === null ? 1 : -1;
			else return e.at - t.at;
		}
		function Zt(e, t) {
			return er(e) || Jt(e, t) || ar(e, t) || Qt();
		}
		function Qt() {
			throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
		}
		function Jt(e, t) {
			var r = null == e ? null : ("undefined" != typeof Symbol && e[Symbol.iterator]) || e["@@iterator"];
			if (null != r) {
				var a,
					n,
					i,
					s,
					o = [],
					l = !0,
					f = !1;
				try {
					if (((i = (r = r.call(e)).next), 0 === t)) {
						if (Object(r) !== r) return;
						l = !1;
					} else for (; !(l = (a = i.call(r)).done) && (o.push(a.value), o.length !== t); l = !0);
				} catch (e) {
					((f = !0), (n = e));
				} finally {
					try {
						if (!l && null != r["return"] && ((s = r["return"]()), Object(s) !== s)) return;
					} finally {
						if (f) throw n;
					}
				}
				return o;
			}
		}
		function er(e) {
			if (Array.isArray(e)) return e;
		}
		function tr(e) {
			return ir(e) || nr(e) || ar(e) || rr();
		}
		function rr() {
			throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
		}
		function ar(e, t) {
			if (e) {
				if ("string" == typeof e) return sr(e, t);
				var r = {}.toString.call(e).slice(8, -1);
				return ("Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? sr(e, t) : void 0);
			}
		}
		function nr(e) {
			if (("undefined" != typeof Symbol && null != e[Symbol.iterator]) || null != e["@@iterator"]) return Array.from(e);
		}
		function ir(e) {
			if (Array.isArray(e)) return sr(e);
		}
		function sr(e, t) {
			(null == t || t > e.length) && (t = e.length);
			for (var r = 0, a = Array(t); r < t; r++) a[r] = e[r];
			return a;
		}
		function or(e) {
			var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
			var r;
			var a = lr(e, t);
			var n = a
				.map(function (e) {
					return Je.apply(
						void 0,
						tr(e).concat([
							Y,
						]),
					);
				})
				.filter(Boolean);
			return l(n, t, (r = a[0]) === null || r === void 0 ? void 0 : r[3].duration);
		}
		function lr(e) {
			var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
			var a = r.defaultOptions,
				n = a === void 0 ? {} : a,
				i = ht(r, [
					"defaultOptions",
				]);
			var s = [];
			var o = new Map();
			var l = {};
			var f = new Map();
			var u = 0;
			var c = 0;
			var d = 0;
			for (var v = 0; v < e.length; v++) {
				var h = e[v];
				if (Xe(h)) {
					f.set(h, c);
					continue;
				} else if (!Array.isArray(h)) {
					f.set(h.name, Ft(c, h.at, u, f));
					continue;
				}
				var m = Zt(h, 3),
					w = m[0],
					S = m[1],
					E = m[2],
					x = E === void 0 ? {} : E;
				if (x.at !== void 0) c = Ft(c, x.at, u, f);
				var T = 0;
				var C = tt(w, l);
				var M = C.length;
				for (var P = 0; P < M; P++) {
					var O = C[P];
					var k = fr(O, o);
					for (var $ in S) {
						var A = ur($, k);
						var I = Ge(S[$]);
						var z = et(x, $);
						var L = z.duration,
							D = L === void 0 ? n.duration || t.duration : L,
							j = z.easing,
							_ = j === void 0 ? n.easing || t.easing : j;
						if (p(_)) {
							K($ === "opacity" || I.length > 1, "spring must be provided 2 keyframes within timeline()");
							var N = _.createAnimation(
								I,
								$ !== "opacity",
								function () {
									return 0;
								},
								$,
							);
							_ = N.easing;
							I = N.keyframes || I;
							D = N.duration || D;
						}
						var B = nt(x.delay, P, M) || 0;
						var H = c + B;
						var W = H + D;
						var R = z.offset,
							G = R === void 0 ? b(I.length) : R;
						if (G.length === 1 && G[0] === 0) G[1] = 1;
						var q = G.length - I.length;
						q > 0 && y(G, q);
						I.length === 1 && I.unshift(null);
						Ut(A, I, _, G, H, W);
						T = Math.max(B + D, T);
						d = Math.max(W, d);
					}
				}
				u = c;
				c += T;
			}
			o.forEach(function (e, r) {
				for (var a in e) {
					var o = e[a];
					o.sort(Kt);
					var l = [];
					var f = [];
					var u = [];
					for (var c = 0; c < o.length; c++) {
						var p = o[c],
							v = p.at,
							h = p.value,
							m = p.easing;
						l.push(h);
						f.push(g(0, d, v));
						u.push(m || t.easing);
					}
					if (f[0] !== 0) {
						f.unshift(0);
						l.unshift(l[0]);
						u.unshift("linear");
					}
					if (f[f.length - 1] !== 1) {
						f.push(1);
						l.push(null);
					}
					s.push([
						r,
						a,
						l,
						Object.assign(Object.assign(Object.assign({}, n), { duration: d, easing: u, offset: f }), i),
					]);
				}
			});
			return s;
		}
		function fr(e, t) {
			!t.has(e) && t.set(e, {});
			return t.get(e);
		}
		function ur(e, t) {
			if (!t[e]) t[e] = [];
			return t[e];
		}
		var cr = new WeakMap();
		var dr;
		function pr(e, t) {
			if (t) {
				var r = t[0],
					a = r.inlineSize,
					n = r.blockSize;
				return { width: a, height: n };
			} else if (e instanceof SVGElement && "getBBox" in e) return e.getBBox();
			else return { width: e.offsetWidth, height: e.offsetHeight };
		}
		function vr(e) {
			var t = e.target,
				r = e.contentRect,
				a = e.borderBoxSize;
			var n;
			(n = cr.get(t)) === null || n === void 0
				? void 0
				: n.forEach(function (e) {
						e({
							target: t,
							contentSize: r,
							get size() {
								return pr(t, a);
							},
						});
					});
		}
		function hr(e) {
			e.forEach(vr);
		}
		function mr() {
			if (typeof ResizeObserver === "undefined") return;
			dr = new ResizeObserver(hr);
		}
		function gr(e, t) {
			if (!dr) mr();
			var r = tt(e);
			r.forEach(function (e) {
				var r = cr.get(e);
				if (!r) {
					r = new Set();
					cr.set(e, r);
				}
				r.add(t);
				dr === null || dr === void 0 ? void 0 : dr.observe(e);
			});
			return function () {
				r.forEach(function (e) {
					var r = cr.get(e);
					r === null || r === void 0 ? void 0 : r["delete"](t);
					if (!(r === null || r === void 0 ? void 0 : r.size)) dr === null || dr === void 0 ? void 0 : dr.unobserve(e);
				});
			};
		}
		var yr = new Set();
		var br;
		function wr() {
			br = function e() {
				var t = { width: window.innerWidth, height: window.innerHeight };
				var r = { target: window, size: t, contentSize: t };
				yr.forEach(function (e) {
					return e(r);
				});
			};
			window.addEventListener("resize", br);
		}
		function Sr(e) {
			yr.add(e);
			if (!br) wr();
			return function () {
				yr["delete"](e);
				if (!yr.size && br) br = void 0;
			};
		}
		function Er(e, t) {
			return A(e) ? Sr(e) : gr(e, t);
		}
		function xr(e, t) {
			return t ? e * (1e3 / t) : 0;
		}
		var Tr = 50;
		var Cr = function e() {
			return { current: 0, offset: [], progress: 0, scrollLength: 0, targetOffset: 0, targetLength: 0, containerLength: 0, velocity: 0 };
		};
		var Mr = function e() {
			return { time: 0, x: Cr(), y: Cr() };
		};
		var Pr = { x: { length: "Width", position: "Left" }, y: { length: "Height", position: "Top" } };
		function Or(e, t, r, a) {
			var n = r[t];
			var i = Pr[t],
				s = i.length,
				o = i.position;
			var l = n.current;
			var f = r.time;
			n.current = e["scroll".concat(o)];
			n.scrollLength = e["scroll".concat(s)] - e["client".concat(s)];
			n.offset.length = 0;
			n.offset[0] = 0;
			n.offset[1] = n.scrollLength;
			n.progress = g(0, n.scrollLength, n.current);
			var u = a - f;
			n.velocity = u > Tr ? 0 : xr(n.current - l, u);
		}
		function kr(e, t, r) {
			Or(e, "x", t, r);
			Or(e, "y", t, r);
			t.time = r;
		}
		function $r(e, t) {
			var r = { x: 0, y: 0 };
			var a = e;
			while (a && a !== t)
				if (a instanceof HTMLElement) {
					r.x += a.offsetLeft;
					r.y += a.offsetTop;
					a = a.offsetParent;
				} else if (a instanceof SVGGraphicsElement && "getBBox" in a) {
					var n = a.getBBox(),
						i = n.top,
						s = n.left;
					r.x += s;
					r.y += i;
					while (a && a.tagName !== "svg") a = a.parentNode;
				}
			return r;
		}
		var Ar = {
			Enter: [
				[
					0,
					1,
				],
				[
					1,
					1,
				],
			],
			Exit: [
				[
					0,
					0,
				],
				[
					1,
					0,
				],
			],
			Any: [
				[
					1,
					0,
				],
				[
					0,
					1,
				],
			],
			All: [
				[
					0,
					0,
				],
				[
					1,
					1,
				],
			],
		};
		var Ir = { start: 0, center: 0.5, end: 1 };
		function zr(e, t) {
			var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
			var a = 0;
			if (Ir[e] !== void 0) e = Ir[e];
			if (Xe(e)) {
				var n = parseFloat(e);
				if (e.endsWith("px")) a = n;
				else if (e.endsWith("%")) e = n / 100;
				else if (e.endsWith("vw")) a = (n / 100) * document.documentElement.clientWidth;
				else if (e.endsWith("vh")) a = (n / 100) * document.documentElement.clientHeight;
				else e = n;
			}
			if (v(e)) a = t * e;
			return r + a;
		}
		var Lr = [
			0,
			0,
		];
		function Dr(e, t, r, a) {
			var n = Array.isArray(e) ? e : Lr;
			var i = 0;
			var s = 0;
			if (v(e))
				n = [
					e,
					e,
				];
			else if (Xe(e)) {
				e = e.trim();
				if (e.includes(" ")) n = e.split(" ");
				else
					n = [
						e,
						Ir[e] ? e : "0",
					];
			}
			i = zr(n[0], r, a);
			s = zr(n[1], t);
			return i - s;
		}
		function jr(e) {
			return Hr(e) || Br(e) || Nr(e) || _r();
		}
		function _r() {
			throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
		}
		function Nr(e, t) {
			if (e) {
				if ("string" == typeof e) return Wr(e, t);
				var r = {}.toString.call(e).slice(8, -1);
				return ("Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Wr(e, t) : void 0);
			}
		}
		function Br(e) {
			if (("undefined" != typeof Symbol && null != e[Symbol.iterator]) || null != e["@@iterator"]) return Array.from(e);
		}
		function Hr(e) {
			if (Array.isArray(e)) return Wr(e);
		}
		function Wr(e, t) {
			(null == t || t > e.length) && (t = e.length);
			for (var r = 0, a = Array(t); r < t; r++) a[r] = e[r];
			return a;
		}
		var Rr = { x: 0, y: 0 };
		function Gr(e, t, r) {
			var a = r.offset,
				n = a === void 0 ? Ar.All : a;
			var i = r.target,
				s = i === void 0 ? e : i,
				o = r.axis,
				l = o === void 0 ? "y" : o;
			var f = l === "y" ? "height" : "width";
			var u = s !== e ? $r(s, e) : Rr;
			var c = s === e ? { width: e.scrollWidth, height: e.scrollHeight } : { width: s.clientWidth, height: s.clientHeight };
			var d = { width: e.clientWidth, height: e.clientHeight };
			t[l].offset.length = 0;
			var p = !t[l].interpolate;
			var v = n.length;
			for (var h = 0; h < v; h++) {
				var m = Dr(n[h], d[f], c[f], u[l]);
				if (!p && m !== t[l].interpolatorOffsets[h]) p = true;
				t[l].offset[h] = m;
			}
			if (p) {
				t[l].interpolate = x(b(v), t[l].offset);
				t[l].interpolatorOffsets = jr(t[l].offset);
			}
			t[l].progress = t[l].interpolate(t[l].current);
		}
		function qr(e) {
			var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e;
			var r = arguments.length > 2 ? arguments[2] : void 0;
			r.x.targetOffset = 0;
			r.y.targetOffset = 0;
			if (t !== e) {
				var a = t;
				while (a && a != e) {
					r.x.targetOffset += a.offsetLeft;
					r.y.targetOffset += a.offsetTop;
					a = a.offsetParent;
				}
			}
			r.x.targetLength = t === e ? t.scrollWidth : t.clientWidth;
			r.y.targetLength = t === e ? t.scrollHeight : t.clientHeight;
			r.x.containerLength = e.clientWidth;
			r.y.containerLength = e.clientHeight;
		}
		function Vr(e, t, r) {
			var a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
			var n = a.axis || "y";
			return {
				measure: function t() {
					return qr(e, a.target, r);
				},
				update: function t(n) {
					kr(e, r, n);
					if (a.offset || a.target) Gr(e, r, a);
				},
				notify: A(t)
					? function () {
							return t(r);
						}
					: Xr(t, r[n]),
			};
		}
		function Xr(e, t) {
			e.pause();
			e.forEachNative(function (e, t) {
				var r = t.easing;
				var a, n;
				if (e.updateDuration) {
					if (!r) e.easing = i;
					e.updateDuration(1);
				} else {
					var s = { duration: 1e3 };
					if (!r) s.easing = "linear";
					(n = (a = e.effect) === null || a === void 0 ? void 0 : a.updateTiming) === null || n === void 0 ? void 0 : n.call(a, s);
				}
			});
			return function () {
				e.currentTime = t.progress;
			};
		}
		function Fr(e, t) {
			var r = ("undefined" != typeof Symbol && e[Symbol.iterator]) || e["@@iterator"];
			if (!r) {
				if (Array.isArray(e) || (r = Yr(e)) || (t && e && "number" == typeof e.length)) {
					r && (e = r);
					var a = 0,
						n = function e() {};
					return {
						s: n,
						n: function t() {
							return a >= e.length ? { done: !0 } : { done: !1, value: e[a++] };
						},
						e: function e(t) {
							throw t;
						},
						f: n,
					};
				}
				throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
			}
			var i,
				s = !0,
				o = !1;
			return {
				s: function t() {
					r = r.call(e);
				},
				n: function e() {
					var t = r.next();
					return ((s = t.done), t);
				},
				e: function e(t) {
					((o = !0), (i = t));
				},
				f: function e() {
					try {
						s || null == r["return"] || r["return"]();
					} finally {
						if (o) throw i;
					}
				},
			};
		}
		function Yr(e, t) {
			if (e) {
				if ("string" == typeof e) return Ur(e, t);
				var r = {}.toString.call(e).slice(8, -1);
				return ("Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Ur(e, t) : void 0);
			}
		}
		function Ur(e, t) {
			(null == t || t > e.length) && (t = e.length);
			for (var r = 0, a = Array(t); r < t; r++) a[r] = e[r];
			return a;
		}
		var Kr = new WeakMap();
		var Zr = new WeakMap();
		var Qr = new WeakMap();
		var Jr = function e(t) {
			return t === document.documentElement ? window : t;
		};
		function ea(e) {
			var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
			var r = t.container,
				a = r === void 0 ? document.documentElement : r,
				n = ht(t, [
					"container",
				]);
			var i = Qr.get(a);
			if (!i) {
				i = new Set();
				Qr.set(a, i);
			}
			var s = Mr();
			var o = Vr(a, e, s, n);
			i.add(o);
			if (!Kr.has(a)) {
				var l = function e() {
					var t = performance.now();
					var r = Fr(i),
						a;
					try {
						for (r.s(); !(a = r.n()).done;) {
							var n = a.value;
							n.measure();
						}
					} catch (e) {
						r.e(e);
					} finally {
						r.f();
					}
					var s = Fr(i),
						o;
					try {
						for (s.s(); !(o = s.n()).done;) {
							var l = o.value;
							l.update(t);
						}
					} catch (e) {
						s.e(e);
					} finally {
						s.f();
					}
					var f = Fr(i),
						u;
					try {
						for (f.s(); !(u = f.n()).done;) {
							var c = u.value;
							c.notify();
						}
					} catch (e) {
						f.e(e);
					} finally {
						f.f();
					}
				};
				Kr.set(a, l);
				var f = Jr(a);
				window.addEventListener("resize", l, { passive: true });
				if (a !== document.documentElement) Zr.set(a, Er(a, l));
				f.addEventListener("scroll", l, { passive: true });
			}
			var u = Kr.get(a);
			var c = requestAnimationFrame(u);
			return function () {
				var t;
				if (typeof e !== "function") e.stop();
				cancelAnimationFrame(c);
				var r = Qr.get(a);
				if (!r) return;
				r["delete"](o);
				if (r.size) return;
				var n = Kr.get(a);
				Kr["delete"](a);
				if (n) {
					Jr(a).removeEventListener("scroll", n);
					(t = Zr.get(a)) === null || t === void 0 ? void 0 : t();
					window.removeEventListener("resize", n);
				}
			};
		}
		function ta(e) {
			"@babel/helpers - typeof";
			return (
				(ta =
					"function" == typeof Symbol && "symbol" == typeof Symbol.iterator
						? function (e) {
								return typeof e;
							}
						: function (e) {
								return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
							}),
				ta(e)
			);
		}
		function ra(e) {
			return e !== null && ta(e) === "object" && "constructor" in e && e.constructor === Object;
		}
		function aa() {
			var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
			var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
			Object.keys(t).forEach(function (r) {
				if (typeof e[r] === "undefined") e[r] = t[r];
				else if (ra(t[r]) && ra(e[r]) && Object.keys(t[r]).length > 0) aa(e[r], t[r]);
			});
		}
		var na = {
			body: {},
			addEventListener: function e() {},
			removeEventListener: function e() {},
			activeElement: { blur: function e() {}, nodeName: "" },
			querySelector: function e() {
				return null;
			},
			querySelectorAll: function e() {
				return [];
			},
			getElementById: function e() {
				return null;
			},
			createEvent: function e() {
				return { initEvent: function e() {} };
			},
			createElement: function e() {
				return {
					children: [],
					childNodes: [],
					style: {},
					setAttribute: function e() {},
					getElementsByTagName: function e() {
						return [];
					},
				};
			},
			createElementNS: function e() {
				return {};
			},
			importNode: function e() {
				return null;
			},
			location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" },
		};
		function ia() {
			var e = typeof document !== "undefined" ? document : {};
			aa(e, na);
			return e;
		}
		var sa = {
			document: na,
			navigator: { userAgent: "" },
			location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" },
			history: { replaceState: function e() {}, pushState: function e() {}, go: function e() {}, back: function e() {} },
			CustomEvent: function e() {
				return this;
			},
			addEventListener: function e() {},
			removeEventListener: function e() {},
			getComputedStyle: function e() {
				return {
					getPropertyValue: function e() {
						return "";
					},
				};
			},
			Image: function e() {},
			Date: function e() {},
			screen: {},
			setTimeout: function e() {},
			clearTimeout: function e() {},
			matchMedia: function e() {
				return {};
			},
			requestAnimationFrame: function e(t) {
				if (typeof setTimeout === "undefined") {
					t();
					return null;
				}
				return setTimeout(t, 0);
			},
			cancelAnimationFrame: function e(t) {
				if (typeof setTimeout === "undefined") return;
				clearTimeout(t);
			},
		};
		function oa() {
			var e = typeof window !== "undefined" ? window : {};
			aa(e, sa);
			return e;
		}
		function la(e) {
			"@babel/helpers - typeof";
			return (
				(la =
					"function" == typeof Symbol && "symbol" == typeof Symbol.iterator
						? function (e) {
								return typeof e;
							}
						: function (e) {
								return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
							}),
				la(e)
			);
		}
		function fa(e) {
			return pa(e) || da(e) || ca(e) || ua();
		}
		function ua() {
			throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
		}
		function ca(e, t) {
			if (e) {
				if ("string" == typeof e) return va(e, t);
				var r = {}.toString.call(e).slice(8, -1);
				return ("Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? va(e, t) : void 0);
			}
		}
		function da(e) {
			if (("undefined" != typeof Symbol && null != e[Symbol.iterator]) || null != e["@@iterator"]) return Array.from(e);
		}
		function pa(e) {
			if (Array.isArray(e)) return va(e);
		}
		function va(e, t) {
			(null == t || t > e.length) && (t = e.length);
			for (var r = 0, a = Array(t); r < t; r++) a[r] = e[r];
			return a;
		}
		function ha(e, t) {
			for (var r = 0; r < t.length; r++) {
				var a = t[r];
				((a.enumerable = a.enumerable || !1), (a.configurable = !0), "value" in a && (a.writable = !0), Object.defineProperty(e, ga(a.key), a));
			}
		}
		function ma(e, t, r) {
			return (t && ha(e.prototype, t), r && ha(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e);
		}
		function ga(e) {
			var t = ya(e, "string");
			return "symbol" == la(t) ? t : t + "";
		}
		function ya(e, t) {
			if ("object" != la(e) || !e) return e;
			var r = e[Symbol.toPrimitive];
			if (void 0 !== r) {
				var a = r.call(e, t || "default");
				if ("object" != la(a)) return a;
				throw new TypeError("@@toPrimitive must return a primitive value.");
			}
			return ("string" === t ? String : Number)(e);
		}
		function ba(e, t) {
			if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
		}
		function wa(e, t, r) {
			return ((t = ka(t)), Sa(e, Ma() ? Reflect.construct(t, r || [], ka(e).constructor) : t.apply(e, r)));
		}
		function Sa(e, t) {
			if (t && ("object" == la(t) || "function" == typeof t)) return t;
			if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
			return Ea(e);
		}
		function Ea(e) {
			if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
			return e;
		}
		function xa(e, t) {
			if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
			((e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } })), Object.defineProperty(e, "prototype", { writable: !1 }), t && Oa(e, t));
		}
		function Ta(e) {
			var t = "function" == typeof Map ? new Map() : void 0;
			return (
				(Ta = function e(r) {
					if (null === r || !Pa(r)) return r;
					if ("function" != typeof r) throw new TypeError("Super expression must either be null or a function");
					if (void 0 !== t) {
						if (t.has(r)) return t.get(r);
						t.set(r, a);
					}
					function a() {
						return Ca(r, arguments, ka(this).constructor);
					}
					return ((a.prototype = Object.create(r.prototype, { constructor: { value: a, enumerable: !1, writable: !0, configurable: !0 } })), Oa(a, r));
				}),
				Ta(e)
			);
		}
		function Ca(e, t, r) {
			if (Ma()) return Reflect.construct.apply(null, arguments);
			var a = [
				null,
			];
			a.push.apply(a, t);
			var n = new (e.bind.apply(e, a))();
			return (r && Oa(n, r.prototype), n);
		}
		function Ma() {
			try {
				var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
			} catch (e) {}
			return (Ma = function t() {
				return !!e;
			})();
		}
		function Pa(e) {
			try {
				return -1 !== Function.toString.call(e).indexOf("[native code]");
			} catch (t) {
				return "function" == typeof e;
			}
		}
		function Oa(e, t) {
			return (
				(Oa = Object.setPrototypeOf
					? Object.setPrototypeOf.bind()
					: function (e, t) {
							return ((e.__proto__ = t), e);
						}),
				Oa(e, t)
			);
		}
		function ka(e) {
			return (
				(ka = Object.setPrototypeOf
					? Object.getPrototypeOf.bind()
					: function (e) {
							return e.__proto__ || Object.getPrototypeOf(e);
						}),
				ka(e)
			);
		}
		function $a(e) {
			var t = e.__proto__;
			Object.defineProperty(e, "__proto__", {
				get: function e() {
					return t;
				},
				set: function e(r) {
					t.__proto__ = r;
				},
			});
		}
		var Aa = (function (e) {
			function t(e) {
				var r;
				ba(this, t);
				if (typeof e === "number")
					r = wa(this, t, [
						e,
					]);
				else {
					r = wa(this, t, fa(e || []));
					$a(Ea(r));
				}
				return Ea(r);
			}
			xa(t, e);
			return ma(t);
		})(Ta(Array));
		function Ia() {
			var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
			var t = [];
			e.forEach(function (e) {
				if (Array.isArray(e)) t.push.apply(t, fa(Ia(e)));
				else t.push(e);
			});
			return t;
		}
		function za(e, t) {
			return Array.prototype.filter.call(e, t);
		}
		function La(e) {
			var t = [];
			for (var r = 0; r < e.length; r += 1) if (t.indexOf(e[r]) === -1) t.push(e[r]);
			return t;
		}
		function Da(e) {
			return e.toLowerCase().replace(/-(.)/g, function (e, t) {
				return t.toUpperCase();
			});
		}
		function ja(e, t) {
			if (typeof e !== "string")
				return [
					e,
				];
			var r = [];
			var a = t.querySelectorAll(e);
			for (var n = 0; n < a.length; n += 1) r.push(a[n]);
			return r;
		}
		function _a(e, t) {
			var r = oa();
			var a = ia();
			var n = [];
			if (!t && e instanceof Aa) return e;
			if (!e) return new Aa(n);
			if (typeof e === "string") {
				var i = e.trim();
				if (i.indexOf("<") >= 0 && i.indexOf(">") >= 0) {
					var s = "div";
					if (i.indexOf("<li") === 0) s = "ul";
					if (i.indexOf("<tr") === 0) s = "tbody";
					if (i.indexOf("<td") === 0 || i.indexOf("<th") === 0) s = "tr";
					if (i.indexOf("<tbody") === 0) s = "table";
					if (i.indexOf("<option") === 0) s = "select";
					var o = a.createElement(s);
					o.innerHTML = i;
					for (var l = 0; l < o.childNodes.length; l += 1) n.push(o.childNodes[l]);
				} else n = ja(e.trim(), t || a);
			} else if (e.nodeType || e === r || e === a) n.push(e);
			else if (Array.isArray(e)) {
				if (e instanceof Aa) return e;
				n = e;
			}
			return new Aa(La(n));
		}
		_a.fn = Aa.prototype;
		function Na() {
			for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
			var a = Ia(
				t.map(function (e) {
					return e.split(" ");
				}),
			);
			this.forEach(function (e) {
				var t;
				(t = e.classList).add.apply(t, fa(a));
			});
			return this;
		}
		function Ba() {
			for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
			var a = Ia(
				t.map(function (e) {
					return e.split(" ");
				}),
			);
			this.forEach(function (e) {
				var t;
				(t = e.classList).remove.apply(t, fa(a));
			});
			return this;
		}
		function Ha() {
			for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
			var a = Ia(
				t.map(function (e) {
					return e.split(" ");
				}),
			);
			this.forEach(function (e) {
				a.forEach(function (t) {
					e.classList.toggle(t);
				});
			});
		}
		function Wa() {
			for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
			var a = Ia(
				t.map(function (e) {
					return e.split(" ");
				}),
			);
			return (
				za(this, function (e) {
					return (
						a.filter(function (t) {
							return e.classList.contains(t);
						}).length > 0
					);
				}).length > 0
			);
		}
		function Ra(e, t) {
			if (arguments.length === 1 && typeof e === "string") {
				if (this[0]) return this[0].getAttribute(e);
				return;
			}
			for (var r = 0; r < this.length; r += 1)
				if (arguments.length === 2) this[r].setAttribute(e, t);
				else
					for (var a in e) {
						this[r][a] = e[a];
						this[r].setAttribute(a, e[a]);
					}
			return this;
		}
		function Ga(e) {
			for (var t = 0; t < this.length; t += 1) this[t].removeAttribute(e);
			return this;
		}
		function qa(e, t) {
			if (arguments.length === 1 && typeof e === "string") {
				if (this[0]) return this[0][e];
			} else {
				for (var r = 0; r < this.length; r += 1)
					if (arguments.length === 2) this[r][e] = t;
					else for (var a in e) this[r][a] = e[a];
				return this;
			}
			return this;
		}
		function Va(e, t) {
			var r;
			if (typeof t === "undefined") {
				r = this[0];
				if (!r) return;
				if (r.dom7ElementDataStorage && e in r.dom7ElementDataStorage) return r.dom7ElementDataStorage[e];
				var a = r.getAttribute("data-".concat(e));
				if (a) return a;
				return;
			}
			for (var n = 0; n < this.length; n += 1) {
				r = this[n];
				if (!r.dom7ElementDataStorage) r.dom7ElementDataStorage = {};
				r.dom7ElementDataStorage[e] = t;
			}
			return this;
		}
		function Xa(e) {
			for (var t = 0; t < this.length; t += 1) {
				var r = this[t];
				if (r.dom7ElementDataStorage && r.dom7ElementDataStorage[e]) {
					r.dom7ElementDataStorage[e] = null;
					delete r.dom7ElementDataStorage[e];
				}
			}
		}
		function Fa() {
			var e = this[0];
			if (!e) return;
			var t = {};
			if (e.dataset) for (var r in e.dataset) t[r] = e.dataset[r];
			else
				for (var a = 0; a < e.attributes.length; a += 1) {
					var n = e.attributes[a];
					if (n.name.indexOf("data-") >= 0) t[Da(n.name.split("data-")[1])] = n.value;
				}
			for (var i in t)
				if (t[i] === "false") t[i] = false;
				else if (t[i] === "true") t[i] = true;
				else if (parseFloat(t[i]) === t[i] * 1) t[i] *= 1;
			return t;
		}
		function Ya(e) {
			if (typeof e === "undefined") {
				var t = this[0];
				if (!t) return;
				if (t.multiple && t.nodeName.toLowerCase() === "select") {
					var r = [];
					for (var a = 0; a < t.selectedOptions.length; a += 1) r.push(t.selectedOptions[a].value);
					return r;
				}
				return t.value;
			}
			for (var n = 0; n < this.length; n += 1) {
				var i = this[n];
				if (Array.isArray(e) && i.multiple && i.nodeName.toLowerCase() === "select") for (var s = 0; s < i.options.length; s += 1) i.options[s].selected = e.indexOf(i.options[s].value) >= 0;
				else i.value = e;
			}
			return this;
		}
		function Ua(e) {
			return this.val(e);
		}
		function Ka(e) {
			for (var t = 0; t < this.length; t += 1) this[t].style.transform = e;
			return this;
		}
		function Za(e) {
			for (var t = 0; t < this.length; t += 1) this[t].style.transitionDuration = typeof e !== "string" ? "".concat(e, "ms") : e;
			return this;
		}
		function Qa() {
			for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
			var a = t[0],
				n = t[1],
				i = t[2],
				s = t[3];
			if (typeof t[1] === "function") {
				a = t[0];
				i = t[1];
				s = t[2];
				n = void 0;
			}
			if (!s) s = false;
			function o(e) {
				var t = e.target;
				if (!t) return;
				var r = e.target.dom7EventData || [];
				if (r.indexOf(e) < 0) r.unshift(e);
				if (_a(t).is(n)) i.apply(t, r);
				else {
					var a = _a(t).parents();
					for (var s = 0; s < a.length; s += 1) if (_a(a[s]).is(n)) i.apply(a[s], r);
				}
			}
			function l(e) {
				var t = e && e.target ? e.target.dom7EventData || [] : [];
				if (t.indexOf(e) < 0) t.unshift(e);
				i.apply(this, t);
			}
			var f = a.split(" ");
			var u;
			for (var c = 0; c < this.length; c += 1) {
				var d = this[c];
				if (!n)
					for (u = 0; u < f.length; u += 1) {
						var p = f[u];
						if (!d.dom7Listeners) d.dom7Listeners = {};
						if (!d.dom7Listeners[p]) d.dom7Listeners[p] = [];
						d.dom7Listeners[p].push({ listener: i, proxyListener: l });
						d.addEventListener(p, l, s);
					}
				else
					for (u = 0; u < f.length; u += 1) {
						var v = f[u];
						if (!d.dom7LiveListeners) d.dom7LiveListeners = {};
						if (!d.dom7LiveListeners[v]) d.dom7LiveListeners[v] = [];
						d.dom7LiveListeners[v].push({ listener: i, proxyListener: o });
						d.addEventListener(v, o, s);
					}
			}
			return this;
		}
		function Ja() {
			for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
			var a = t[0],
				n = t[1],
				i = t[2],
				s = t[3];
			if (typeof t[1] === "function") {
				a = t[0];
				i = t[1];
				s = t[2];
				n = void 0;
			}
			if (!s) s = false;
			var o = a.split(" ");
			for (var l = 0; l < o.length; l += 1) {
				var f = o[l];
				for (var u = 0; u < this.length; u += 1) {
					var c = this[u];
					var d = void 0;
					if (!n && c.dom7Listeners) d = c.dom7Listeners[f];
					else if (n && c.dom7LiveListeners) d = c.dom7LiveListeners[f];
					if (d && d.length)
						for (var p = d.length - 1; p >= 0; p -= 1) {
							var v = d[p];
							if (i && v.listener === i) {
								c.removeEventListener(f, v.proxyListener, s);
								d.splice(p, 1);
							} else if (i && v.listener && v.listener.dom7proxy && v.listener.dom7proxy === i) {
								c.removeEventListener(f, v.proxyListener, s);
								d.splice(p, 1);
							} else if (!i) {
								c.removeEventListener(f, v.proxyListener, s);
								d.splice(p, 1);
							}
						}
				}
			}
			return this;
		}
		function en() {
			var e = this;
			for (var t = arguments.length, r = new Array(t), a = 0; a < t; a++) r[a] = arguments[a];
			var n = r[0],
				i = r[1],
				s = r[2],
				o = r[3];
			if (typeof r[1] === "function") {
				n = r[0];
				s = r[1];
				o = r[2];
				i = void 0;
			}
			function l() {
				for (var t = arguments.length, r = new Array(t), a = 0; a < t; a++) r[a] = arguments[a];
				s.apply(this, r);
				e.off(n, i, l, o);
				if (l.dom7proxy) delete l.dom7proxy;
			}
			l.dom7proxy = s;
			return e.on(n, i, l, o);
		}
		function tn() {
			var e = oa();
			for (var t = arguments.length, r = new Array(t), a = 0; a < t; a++) r[a] = arguments[a];
			var n = r[0].split(" ");
			var i = r[1];
			for (var s = 0; s < n.length; s += 1) {
				var o = n[s];
				for (var l = 0; l < this.length; l += 1) {
					var f = this[l];
					if (e.CustomEvent) {
						var u = new e.CustomEvent(o, { detail: i, bubbles: true, cancelable: true });
						f.dom7EventData = r.filter(function (e, t) {
							return t > 0;
						});
						f.dispatchEvent(u);
						f.dom7EventData = [];
						delete f.dom7EventData;
					}
				}
			}
			return this;
		}
		function rn(e) {
			var t = this;
			function r(a) {
				if (a.target !== this) return;
				e.call(this, a);
				t.off("transitionstart", r);
			}
			if (e) t.on("transitionstart", r);
			return this;
		}
		function an(e) {
			var t = this;
			function r(a) {
				if (a.target !== this) return;
				e.call(this, a);
				t.off("transitionend", r);
			}
			if (e) t.on("transitionend", r);
			return this;
		}
		function nn(e) {
			var t = this;
			function r(a) {
				if (a.target !== this) return;
				e.call(this, a);
				t.off("animationend", r);
			}
			if (e) t.on("animationend", r);
			return this;
		}
		function sn() {
			var e = getWindow();
			if (this[0] === e) return e.innerWidth;
			if (this.length > 0) return parseFloat(this.css("width"));
			return null;
		}
		function on(e) {
			if (this.length > 0) {
				if (e) {
					var t = this.styles();
					return this[0].offsetWidth + parseFloat(t.getPropertyValue("margin-right")) + parseFloat(t.getPropertyValue("margin-left"));
				}
				return this[0].offsetWidth;
			}
			return null;
		}
		function ln() {
			var e = getWindow();
			if (this[0] === e) return e.innerHeight;
			if (this.length > 0) return parseFloat(this.css("height"));
			return null;
		}
		function fn(e) {
			if (this.length > 0) {
				if (e) {
					var t = this.styles();
					return this[0].offsetHeight + parseFloat(t.getPropertyValue("margin-top")) + parseFloat(t.getPropertyValue("margin-bottom"));
				}
				return this[0].offsetHeight;
			}
			return null;
		}
		function un() {
			if (this.length > 0) {
				var e = oa();
				var t = ia();
				var r = this[0];
				var a = r.getBoundingClientRect();
				var n = t.body;
				var i = r.clientTop || n.clientTop || 0;
				var s = r.clientLeft || n.clientLeft || 0;
				var o = r === e ? e.scrollY : r.scrollTop;
				var l = r === e ? e.scrollX : r.scrollLeft;
				return { top: a.top + o - i, left: a.left + l - s };
			}
			return null;
		}
		function cn() {
			for (var e = 0; e < this.length; e += 1) this[e].style.display = "none";
			return this;
		}
		function dn() {
			var e = getWindow();
			for (var t = 0; t < this.length; t += 1) {
				var r = this[t];
				if (r.style.display === "none") r.style.display = "";
				if (e.getComputedStyle(r, null).getPropertyValue("display") === "none") r.style.display = "block";
			}
			return this;
		}
		function pn() {
			var e = oa();
			if (this[0]) return e.getComputedStyle(this[0], null);
			return {};
		}
		function vn(e, t) {
			var r = oa();
			var a;
			if (arguments.length === 1)
				if (typeof e === "string") {
					if (this[0]) return r.getComputedStyle(this[0], null).getPropertyValue(e);
				} else {
					for (a = 0; a < this.length; a += 1) for (var n in e) this[a].style[n] = e[n];
					return this;
				}
			if (arguments.length === 2 && typeof e === "string") {
				for (a = 0; a < this.length; a += 1) this[a].style[e] = t;
				return this;
			}
			return this;
		}
		function hn(e) {
			if (!e) return this;
			this.forEach(function (t, r) {
				e.apply(t, [
					t,
					r,
				]);
			});
			return this;
		}
		function mn(e) {
			var t = za(this, e);
			return _a(t);
		}
		function gn(e) {
			if (typeof e === "undefined") return this[0] ? this[0].innerHTML : null;
			for (var t = 0; t < this.length; t += 1) this[t].innerHTML = e;
			return this;
		}
		function yn(e) {
			if (typeof e === "undefined") return this[0] ? this[0].textContent.trim() : null;
			for (var t = 0; t < this.length; t += 1) this[t].textContent = e;
			return this;
		}
		function bn(e) {
			var t = oa();
			var r = ia();
			var a = this[0];
			var n;
			var i;
			if (!a || typeof e === "undefined") return false;
			if (typeof e === "string") {
				if (a.matches) return a.matches(e);
				if (a.webkitMatchesSelector) return a.webkitMatchesSelector(e);
				if (a.msMatchesSelector) return a.msMatchesSelector(e);
				n = _a(e);
				for (i = 0; i < n.length; i += 1) if (n[i] === a) return true;
				return false;
			}
			if (e === r) return a === r;
			if (e === t) return a === t;
			if (e.nodeType || e instanceof Aa) {
				n = e.nodeType
					? [
							e,
						]
					: e;
				for (i = 0; i < n.length; i += 1) if (n[i] === a) return true;
				return false;
			}
			return false;
		}
		function wn() {
			var e = this[0];
			var t;
			if (e) {
				t = 0;
				while ((e = e.previousSibling) !== null) if (e.nodeType === 1) t += 1;
				return t;
			}
			return;
		}
		function Sn(e) {
			if (typeof e === "undefined") return this;
			var t = this.length;
			if (e > t - 1) return _a([]);
			if (e < 0) {
				var r = t + e;
				if (r < 0) return _a([]);
				return _a([
					this[r],
				]);
			}
			return _a([
				this[e],
			]);
		}
		function En() {
			var e;
			var t = ia();
			for (var r = 0; r < arguments.length; r += 1) {
				e = r < 0 || arguments.length <= r ? void 0 : arguments[r];
				for (var a = 0; a < this.length; a += 1)
					if (typeof e === "string") {
						var n = t.createElement("div");
						n.innerHTML = e;
						while (n.firstChild) this[a].appendChild(n.firstChild);
					} else if (e instanceof Aa) for (var i = 0; i < e.length; i += 1) this[a].appendChild(e[i]);
					else this[a].appendChild(e);
			}
			return this;
		}
		function xn(e) {
			_a(e).append(this);
			return this;
		}
		function Tn(e) {
			var t = ia();
			var r;
			var a;
			for (r = 0; r < this.length; r += 1)
				if (typeof e === "string") {
					var n = t.createElement("div");
					n.innerHTML = e;
					for (a = n.childNodes.length - 1; a >= 0; a -= 1) this[r].insertBefore(n.childNodes[a], this[r].childNodes[0]);
				} else if (e instanceof Aa) for (a = 0; a < e.length; a += 1) this[r].insertBefore(e[a], this[r].childNodes[0]);
				else this[r].insertBefore(e, this[r].childNodes[0]);
			return this;
		}
		function Cn(e) {
			_a(e).prepend(this);
			return this;
		}
		function Mn(e) {
			var t = _a(e);
			for (var r = 0; r < this.length; r += 1)
				if (t.length === 1) t[0].parentNode.insertBefore(this[r], t[0]);
				else if (t.length > 1) for (var a = 0; a < t.length; a += 1) t[a].parentNode.insertBefore(this[r].cloneNode(true), t[a]);
		}
		function Pn(e) {
			var t = _a(e);
			for (var r = 0; r < this.length; r += 1)
				if (t.length === 1) t[0].parentNode.insertBefore(this[r], t[0].nextSibling);
				else if (t.length > 1) for (var a = 0; a < t.length; a += 1) t[a].parentNode.insertBefore(this[r].cloneNode(true), t[a].nextSibling);
		}
		function On(e) {
			if (this.length > 0) {
				if (e) {
					if (this[0].nextElementSibling && _a(this[0].nextElementSibling).is(e))
						return _a([
							this[0].nextElementSibling,
						]);
					return _a([]);
				}
				if (this[0].nextElementSibling)
					return _a([
						this[0].nextElementSibling,
					]);
				return _a([]);
			}
			return _a([]);
		}
		function kn(e) {
			var t = [];
			var r = this[0];
			if (!r) return _a([]);
			while (r.nextElementSibling) {
				var a = r.nextElementSibling;
				if (e) {
					if (_a(a).is(e)) t.push(a);
				} else t.push(a);
				r = a;
			}
			return _a(t);
		}
		function $n(e) {
			if (this.length > 0) {
				var t = this[0];
				if (e) {
					if (t.previousElementSibling && _a(t.previousElementSibling).is(e))
						return _a([
							t.previousElementSibling,
						]);
					return _a([]);
				}
				if (t.previousElementSibling)
					return _a([
						t.previousElementSibling,
					]);
				return _a([]);
			}
			return _a([]);
		}
		function An(e) {
			var t = [];
			var r = this[0];
			if (!r) return _a([]);
			while (r.previousElementSibling) {
				var a = r.previousElementSibling;
				if (e) {
					if (_a(a).is(e)) t.push(a);
				} else t.push(a);
				r = a;
			}
			return _a(t);
		}
		function In(e) {
			return this.nextAll(e).add(this.prevAll(e));
		}
		function zn(e) {
			var t = [];
			for (var r = 0; r < this.length; r += 1)
				if (this[r].parentNode !== null)
					if (e) {
						if (_a(this[r].parentNode).is(e)) t.push(this[r].parentNode);
					} else t.push(this[r].parentNode);
			return _a(t);
		}
		function Ln(e) {
			var t = [];
			for (var r = 0; r < this.length; r += 1) {
				var a = this[r].parentNode;
				while (a) {
					if (e) {
						if (_a(a).is(e)) t.push(a);
					} else t.push(a);
					a = a.parentNode;
				}
			}
			return _a(t);
		}
		function Dn(e) {
			var t = this;
			if (typeof e === "undefined") return _a([]);
			if (!t.is(e)) t = t.parents(e).eq(0);
			return t;
		}
		function jn(e) {
			var t = [];
			for (var r = 0; r < this.length; r += 1) {
				var a = this[r].querySelectorAll(e);
				for (var n = 0; n < a.length; n += 1) t.push(a[n]);
			}
			return _a(t);
		}
		function _n(e) {
			var t = [];
			for (var r = 0; r < this.length; r += 1) {
				var a = this[r].children;
				for (var n = 0; n < a.length; n += 1) if (!e || _a(a[n]).is(e)) t.push(a[n]);
			}
			return _a(t);
		}
		function Nn() {
			for (var e = 0; e < this.length; e += 1) if (this[e].parentNode) this[e].parentNode.removeChild(this[e]);
			return this;
		}
		function Bn() {
			return this.remove();
		}
		function Hn() {
			var e = this;
			var t;
			var r;
			for (var a = arguments.length, n = new Array(a), i = 0; i < a; i++) n[i] = arguments[i];
			for (t = 0; t < n.length; t += 1) {
				var s = _a(n[t]);
				for (r = 0; r < s.length; r += 1) e.push(s[r]);
			}
			return e;
		}
		function Wn() {
			for (var e = 0; e < this.length; e += 1) {
				var t = this[e];
				if (t.nodeType === 1) {
					for (var r = 0; r < t.childNodes.length; r += 1) if (t.childNodes[r].parentNode) t.childNodes[r].parentNode.removeChild(t.childNodes[r]);
					t.textContent = "";
				}
			}
			return this;
		}
		function Rn() {
			var e = getWindow();
			for (var t = arguments.length, r = new Array(t), a = 0; a < t; a++) r[a] = arguments[a];
			var n = r[0],
				i = r[1],
				s = r[2],
				o = r[3],
				l = r[4];
			if (r.length === 4 && typeof o === "function") {
				l = o;
				n = r[0];
				i = r[1];
				s = r[2];
				l = r[3];
				o = r[4];
			}
			if (typeof o === "undefined") o = "swing";
			return this.each(function t() {
				var r = this;
				var a;
				var f;
				var u;
				var c;
				var d;
				var p;
				var v;
				var h;
				var m = i > 0 || i === 0;
				var g = n > 0 || n === 0;
				if (typeof o === "undefined") o = "swing";
				if (m) {
					a = r.scrollTop;
					if (!s) r.scrollTop = i;
				}
				if (g) {
					f = r.scrollLeft;
					if (!s) r.scrollLeft = n;
				}
				if (!s) return;
				if (m) {
					u = r.scrollHeight - r.offsetHeight;
					d = Math.max(Math.min(i, u), 0);
				}
				if (g) {
					c = r.scrollWidth - r.offsetWidth;
					p = Math.max(Math.min(n, c), 0);
				}
				var y = null;
				if (m && d === a) m = false;
				if (g && p === f) g = false;
				function b() {
					var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Date().getTime();
					if (y === null) y = t;
					var n = Math.max(Math.min((t - y) / s, 1), 0);
					var i = o === "linear" ? n : 0.5 - Math.cos(n * Math.PI) / 2;
					var u;
					if (m) v = a + i * (d - a);
					if (g) h = f + i * (p - f);
					if (m && d > a && v >= d) {
						r.scrollTop = d;
						u = true;
					}
					if (m && d < a && v <= d) {
						r.scrollTop = d;
						u = true;
					}
					if (g && p > f && h >= p) {
						r.scrollLeft = p;
						u = true;
					}
					if (g && p < f && h <= p) {
						r.scrollLeft = p;
						u = true;
					}
					if (u) {
						if (l) l();
						return;
					}
					if (m) r.scrollTop = v;
					if (g) r.scrollLeft = h;
					e.requestAnimationFrame(b);
				}
				e.requestAnimationFrame(b);
			});
		}
		function Gn() {
			for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
			var a = t[0],
				n = t[1],
				i = t[2],
				s = t[3];
			if (t.length === 3 && typeof i === "function") {
				a = t[0];
				n = t[1];
				s = t[2];
				i = t[3];
			}
			var o = this;
			if (typeof a === "undefined") {
				if (o.length > 0) return o[0].scrollTop;
				return null;
			}
			return o.scrollTo(void 0, a, n, i, s);
		}
		function qn() {
			for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
			var a = t[0],
				n = t[1],
				i = t[2],
				s = t[3];
			if (t.length === 3 && typeof i === "function") {
				a = t[0];
				n = t[1];
				s = t[2];
				i = t[3];
			}
			var o = this;
			if (typeof a === "undefined") {
				if (o.length > 0) return o[0].scrollLeft;
				return null;
			}
			return o.scrollTo(a, void 0, n, i, s);
		}
		function Vn(e, t) {
			var r = getWindow();
			var a = this;
			var n = {
				props: Object.assign({}, e),
				params: Object.assign({ duration: 300, easing: "swing" }, t),
				elements: a,
				animating: false,
				que: [],
				easingProgress: function e(t, r) {
					if (t === "swing") return 0.5 - Math.cos(r * Math.PI) / 2;
					if (typeof t === "function") return t(r);
					return r;
				},
				stop: function e() {
					if (n.frameId) r.cancelAnimationFrame(n.frameId);
					n.animating = false;
					n.elements.each(function (e) {
						var t = e;
						delete t.dom7AnimateInstance;
					});
					n.que = [];
				},
				done: function e(t) {
					n.animating = false;
					n.elements.each(function (e) {
						var t = e;
						delete t.dom7AnimateInstance;
					});
					if (t) t(a);
					if (n.que.length > 0) {
						var r = n.que.shift();
						n.animate(r[0], r[1]);
					}
				},
				animate: function e(t, i) {
					if (n.animating) {
						n.que.push([
							t,
							i,
						]);
						return n;
					}
					var s = [];
					n.elements.each(function (e, a) {
						var i;
						var o;
						var l;
						var f;
						var u;
						if (!e.dom7AnimateInstance) n.elements[a].dom7AnimateInstance = n;
						s[a] = { container: e };
						Object.keys(t).forEach(function (n) {
							i = r.getComputedStyle(e, null).getPropertyValue(n).replace(",", ".");
							o = parseFloat(i);
							l = i.replace(o, "");
							f = parseFloat(t[n]);
							u = t[n] + l;
							s[a][n] = { initialFullValue: i, initialValue: o, unit: l, finalValue: f, finalFullValue: u, currentValue: o };
						});
					});
					var o = null;
					var l;
					var f = 0;
					var u = 0;
					var c;
					var d = false;
					n.animating = true;
					function p() {
						l = new Date().getTime();
						var e;
						var v;
						if (!d) {
							d = true;
							if (i.begin) i.begin(a);
						}
						if (o === null) o = l;
						if (i.progress) i.progress(a, Math.max(Math.min((l - o) / i.duration, 1), 0), o + i.duration - l < 0 ? 0 : o + i.duration - l, o);
						s.forEach(function (r) {
							var a = r;
							if (c || a.done) return;
							Object.keys(t).forEach(function (r) {
								if (c || a.done) return;
								e = Math.max(Math.min((l - o) / i.duration, 1), 0);
								v = n.easingProgress(i.easing, e);
								var d = a[r],
									p = d.initialValue,
									h = d.finalValue,
									m = d.unit;
								a[r].currentValue = p + v * (h - p);
								var g = a[r].currentValue;
								if ((h > p && g >= h) || (h < p && g <= h)) {
									a.container.style[r] = h + m;
									u += 1;
									if (u === Object.keys(t).length) {
										a.done = true;
										f += 1;
									}
									if (f === s.length) c = true;
								}
								if (c) {
									n.done(i.complete);
									return;
								}
								a.container.style[r] = g + m;
							});
						});
						if (c) return;
						n.frameId = r.requestAnimationFrame(p);
					}
					n.frameId = r.requestAnimationFrame(p);
					return n;
				},
			};
			if (n.elements.length === 0) return a;
			var i;
			for (var s = 0; s < n.elements.length; s += 1)
				if (n.elements[s].dom7AnimateInstance) i = n.elements[s].dom7AnimateInstance;
				else n.elements[s].dom7AnimateInstance = n;
			if (!i) i = n;
			if (e === "stop") i.stop();
			else i.animate(n.props, n.params);
			return a;
		}
		function Xn() {
			var e = this;
			for (var t = 0; t < e.length; t += 1) if (e[t].dom7AnimateInstance) e[t].dom7AnimateInstance.stop();
		}
		var Fn = "resize scroll".split(" ");
		function Yn(e) {
			function t() {
				for (var t = arguments.length, r = new Array(t), a = 0; a < t; a++) r[a] = arguments[a];
				if (typeof r[0] === "undefined") {
					for (var n = 0; n < this.length; n += 1)
						if (Fn.indexOf(e) < 0)
							if (e in this[n]) this[n][e]();
							else _a(this[n]).trigger(e);
					return this;
				}
				return this.on.apply(
					this,
					[
						e,
					].concat(r),
				);
			}
			return t;
		}
		var Un = Yn("click");
		var Kn = Yn("blur");
		var Zn = Yn("focus");
		var Qn = Yn("focusin");
		var Jn = Yn("focusout");
		var ei = Yn("keyup");
		var ti = Yn("keydown");
		var ri = Yn("keypress");
		var ai = Yn("submit");
		var ni = Yn("change");
		var ii = Yn("mousedown");
		var si = Yn("mousemove");
		var oi = Yn("mouseup");
		var li = Yn("mouseenter");
		var fi = Yn("mouseleave");
		var ui = Yn("mouseout");
		var ci = Yn("mouseover");
		var di = Yn("touchstart");
		var pi = Yn("touchend");
		var vi = Yn("touchmove");
		var hi = Yn("resize");
		var mi = Yn("scroll");
		const gi = null && _a;
		var yi = {
			addClass: Na,
			removeClass: Ba,
			hasClass: Wa,
			toggleClass: Ha,
			attr: Ra,
			removeAttr: Ga,
			transform: Ka,
			transition: Za,
			on: Qa,
			off: Ja,
			trigger: tn,
			transitionEnd: an,
			outerWidth: on,
			outerHeight: fn,
			styles: pn,
			offset: un,
			css: vn,
			each: hn,
			html: gn,
			text: yn,
			is: bn,
			index: wn,
			eq: Sn,
			append: En,
			prepend: Tn,
			next: On,
			nextAll: kn,
			prev: $n,
			prevAll: An,
			parent: zn,
			parents: Ln,
			closest: Dn,
			find: jn,
			children: _n,
			filter: mn,
			remove: Nn,
		};
		Object.keys(yi).forEach(function (e) {
			Object.defineProperty(_a.fn, e, { value: yi[e], writable: true });
		});
		const bi = _a;
		function wi(e, t, r) {
			return ((t = Si(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = r), e);
		}
		function Si(e) {
			var t = Ei(e, "string");
			return "symbol" == xi(t) ? t : t + "";
		}
		function Ei(e, t) {
			if ("object" != xi(e) || !e) return e;
			var r = e[Symbol.toPrimitive];
			if (void 0 !== r) {
				var a = r.call(e, t || "default");
				if ("object" != xi(a)) return a;
				throw new TypeError("@@toPrimitive must return a primitive value.");
			}
			return ("string" === t ? String : Number)(e);
		}
		function xi(e) {
			"@babel/helpers - typeof";
			return (
				(xi =
					"function" == typeof Symbol && "symbol" == typeof Symbol.iterator
						? function (e) {
								return typeof e;
							}
						: function (e) {
								return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
							}),
				xi(e)
			);
		}
		function Ti(e) {
			var t = e;
			Object.keys(t).forEach(function (e) {
				try {
					t[e] = null;
				} catch (e) {}
				try {
					delete t[e];
				} catch (e) {}
			});
		}
		function Ci(e) {
			var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
			return setTimeout(e, t);
		}
		function Mi() {
			return Date.now();
		}
		function Pi(e) {
			var t = oa();
			var r;
			if (t.getComputedStyle) r = t.getComputedStyle(e, null);
			if (!r && e.currentStyle) r = e.currentStyle;
			if (!r) r = e.style;
			return r;
		}
		function Oi(e) {
			var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "x";
			var r = oa();
			var a;
			var n;
			var i;
			var s = Pi(e, null);
			if (r.WebKitCSSMatrix) {
				n = s.transform || s.webkitTransform;
				if (n.split(",").length > 6)
					n = n
						.split(", ")
						.map(function (e) {
							return e.replace(",", ".");
						})
						.join(", ");
				i = new r.WebKitCSSMatrix(n === "none" ? "" : n);
			} else {
				i = s.MozTransform || s.OTransform || s.MsTransform || s.msTransform || s.transform || s.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
				a = i.toString().split(",");
			}
			if (t === "x")
				if (r.WebKitCSSMatrix) n = i.m41;
				else if (a.length === 16) n = parseFloat(a[12]);
				else n = parseFloat(a[4]);
			if (t === "y")
				if (r.WebKitCSSMatrix) n = i.m42;
				else if (a.length === 16) n = parseFloat(a[13]);
				else n = parseFloat(a[5]);
			return n || 0;
		}
		function ki(e) {
			return xi(e) === "object" && e !== null && e.constructor && Object.prototype.toString.call(e).slice(8, -1) === "Object";
		}
		function $i(e) {
			if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") return e instanceof HTMLElement;
			return e && (e.nodeType === 1 || e.nodeType === 11);
		}
		function Ai() {
			var e = Object(arguments.length <= 0 ? void 0 : arguments[0]);
			var t = [
				"__proto__",
				"constructor",
				"prototype",
			];
			for (var r = 1; r < arguments.length; r += 1) {
				var a = r < 0 || arguments.length <= r ? void 0 : arguments[r];
				if (a !== void 0 && a !== null && !$i(a)) {
					var n = Object.keys(Object(a)).filter(function (e) {
						return t.indexOf(e) < 0;
					});
					for (var i = 0, s = n.length; i < s; i += 1) {
						var o = n[i];
						var l = Object.getOwnPropertyDescriptor(a, o);
						if (l !== void 0 && l.enumerable)
							if (ki(e[o]) && ki(a[o]))
								if (a[o].__swiper__) e[o] = a[o];
								else Ai(e[o], a[o]);
							else if (!ki(e[o]) && ki(a[o])) {
								e[o] = {};
								if (a[o].__swiper__) e[o] = a[o];
								else Ai(e[o], a[o]);
							} else e[o] = a[o];
					}
				}
			}
			return e;
		}
		function Ii(e, t, r) {
			e.style.setProperty(t, r);
		}
		function zi(e) {
			var t = e.swiper,
				r = e.targetPosition,
				a = e.side;
			var n = oa();
			var i = -t.translate;
			var s = null;
			var o;
			var l = t.params.speed;
			t.wrapperEl.style.scrollSnapType = "none";
			n.cancelAnimationFrame(t.cssModeFrameID);
			var f = r > i ? "next" : "prev";
			var u = function e(t, r) {
				return (f === "next" && t >= r) || (f === "prev" && t <= r);
			};
			var c = function e() {
				o = new Date().getTime();
				if (s === null) s = o;
				var f = Math.max(Math.min((o - s) / l, 1), 0);
				var d = 0.5 - Math.cos(f * Math.PI) / 2;
				var p = i + d * (r - i);
				if (u(p, r)) p = r;
				t.wrapperEl.scrollTo(wi({}, a, p));
				if (u(p, r)) {
					t.wrapperEl.style.overflow = "hidden";
					t.wrapperEl.style.scrollSnapType = "";
					setTimeout(function () {
						t.wrapperEl.style.overflow = "";
						t.wrapperEl.scrollTo(wi({}, a, p));
					});
					n.cancelAnimationFrame(t.cssModeFrameID);
					return;
				}
				t.cssModeFrameID = n.requestAnimationFrame(c);
			};
			c();
		}
		var Li;
		function Di() {
			var e = oa();
			var t = ia();
			return {
				smoothScroll: t.documentElement && "scrollBehavior" in t.documentElement.style,
				touch: !!("ontouchstart" in e || (e.DocumentTouch && t instanceof e.DocumentTouch)),
				passiveListener: (function t() {
					var r = false;
					try {
						var a = Object.defineProperty({}, "passive", {
							get: function e() {
								r = true;
							},
						});
						e.addEventListener("testPassiveListener", null, a);
					} catch (e) {}
					return r;
				})(),
				gestures: (function t() {
					return "ongesturestart" in e;
				})(),
			};
		}
		function ji() {
			if (!Li) Li = Di();
			return Li;
		}
		var _i;
		function Ni() {
			var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
				t = e.userAgent;
			var r = ji();
			var a = oa();
			var n = a.navigator.platform;
			var i = t || a.navigator.userAgent;
			var s = { ios: false, android: false };
			var o = a.screen.width;
			var l = a.screen.height;
			var f = i.match(/(Android);?[\s\/]+([\d.]+)?/);
			var u = i.match(/(iPad).*OS\s([\d_]+)/);
			var c = i.match(/(iPod)(.*OS\s([\d_]+))?/);
			var d = !u && i.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
			var p = n === "Win32";
			var v = n === "MacIntel";
			var h = [
				"1024x1366",
				"1366x1024",
				"834x1194",
				"1194x834",
				"834x1112",
				"1112x834",
				"768x1024",
				"1024x768",
				"820x1180",
				"1180x820",
				"810x1080",
				"1080x810",
			];
			if (!u && v && r.touch && h.indexOf("".concat(o, "x").concat(l)) >= 0) {
				u = i.match(/(Version)\/([\d.]+)/);
				if (!u)
					u = [
						0,
						1,
						"13_0_0",
					];
				v = false;
			}
			if (f && !p) {
				s.os = "android";
				s.android = true;
			}
			if (u || d || c) {
				s.os = "ios";
				s.ios = true;
			}
			return s;
		}
		function Bi() {
			var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
			if (!_i) _i = Ni(e);
			return _i;
		}
		var Hi;
		function Wi() {
			var e = oa();
			function t() {
				var t = e.navigator.userAgent.toLowerCase();
				return t.indexOf("safari") >= 0 && t.indexOf("chrome") < 0 && t.indexOf("android") < 0;
			}
			return { isSafari: t(), isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent) };
		}
		function Ri() {
			if (!Hi) Hi = Wi();
			return Hi;
		}
		function Gi(e) {
			var t = e.swiper,
				r = e.on,
				a = e.emit;
			var n = oa();
			var i = null;
			var s = null;
			var o = function e() {
				if (!t || t.destroyed || !t.initialized) return;
				a("beforeResize");
				a("resize");
			};
			var l = function e() {
				if (!t || t.destroyed || !t.initialized) return;
				i = new ResizeObserver(function (e) {
					s = n.requestAnimationFrame(function () {
						var r = t.width,
							a = t.height;
						var n = r;
						var i = a;
						e.forEach(function (e) {
							var r = e.contentBoxSize,
								a = e.contentRect,
								s = e.target;
							if (s && s !== t.el) return;
							n = a ? a.width : (r[0] || r).inlineSize;
							i = a ? a.height : (r[0] || r).blockSize;
						});
						if (n !== r || i !== a) o();
					});
				});
				i.observe(t.el);
			};
			var f = function e() {
				if (s) n.cancelAnimationFrame(s);
				if (i && i.unobserve && t.el) {
					i.unobserve(t.el);
					i = null;
				}
			};
			var u = function e() {
				if (!t || t.destroyed || !t.initialized) return;
				a("orientationchange");
			};
			r("init", function () {
				if (t.params.resizeObserver && typeof n.ResizeObserver !== "undefined") {
					l();
					return;
				}
				n.addEventListener("resize", o);
				n.addEventListener("orientationchange", u);
			});
			r("destroy", function () {
				f();
				n.removeEventListener("resize", o);
				n.removeEventListener("orientationchange", u);
			});
		}
		function qi(e) {
			var t = e.swiper,
				r = e.extendParams,
				a = e.on,
				n = e.emit;
			var i = [];
			var s = oa();
			var o = function e(t) {
				var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
				var a = s.MutationObserver || s.WebkitMutationObserver;
				var o = new a(function (e) {
					if (e.length === 1) {
						n("observerUpdate", e[0]);
						return;
					}
					var t = function t() {
						n("observerUpdate", e[0]);
					};
					if (s.requestAnimationFrame) s.requestAnimationFrame(t);
					else s.setTimeout(t, 0);
				});
				o.observe(t, { attributes: typeof r.attributes === "undefined" ? true : r.attributes, childList: typeof r.childList === "undefined" ? true : r.childList, characterData: typeof r.characterData === "undefined" ? true : r.characterData });
				i.push(o);
			};
			var l = function e() {
				if (!t.params.observer) return;
				if (t.params.observeParents) {
					var r = t.$el.parents();
					for (var a = 0; a < r.length; a += 1) o(r[a]);
				}
				o(t.$el[0], { childList: t.params.observeSlideChildren });
				o(t.$wrapperEl[0], { attributes: false });
			};
			var f = function e() {
				i.forEach(function (e) {
					e.disconnect();
				});
				i.splice(0, i.length);
			};
			r({ observer: false, observeParents: false, observeSlideChildren: false });
			a("init", l);
			a("destroy", f);
		}
		function Vi(e) {
			return Ui(e) || Yi(e) || Fi(e) || Xi();
		}
		function Xi() {
			throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
		}
		function Fi(e, t) {
			if (e) {
				if ("string" == typeof e) return Ki(e, t);
				var r = {}.toString.call(e).slice(8, -1);
				return ("Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Ki(e, t) : void 0);
			}
		}
		function Yi(e) {
			if (("undefined" != typeof Symbol && null != e[Symbol.iterator]) || null != e["@@iterator"]) return Array.from(e);
		}
		function Ui(e) {
			if (Array.isArray(e)) return Ki(e);
		}
		function Ki(e, t) {
			(null == t || t > e.length) && (t = e.length);
			for (var r = 0, a = Array(t); r < t; r++) a[r] = e[r];
			return a;
		}
		const Zi = {
			on: function e(t, r, a) {
				var n = this;
				if (!n.eventsListeners || n.destroyed) return n;
				if (typeof r !== "function") return n;
				var i = a ? "unshift" : "push";
				t.split(" ").forEach(function (e) {
					if (!n.eventsListeners[e]) n.eventsListeners[e] = [];
					n.eventsListeners[e][i](r);
				});
				return n;
			},
			once: function e(t, r, a) {
				var n = this;
				if (!n.eventsListeners || n.destroyed) return n;
				if (typeof r !== "function") return n;
				function i() {
					n.off(t, i);
					if (i.__emitterProxy) delete i.__emitterProxy;
					for (var e = arguments.length, a = new Array(e), s = 0; s < e; s++) a[s] = arguments[s];
					r.apply(n, a);
				}
				i.__emitterProxy = r;
				return n.on(t, i, a);
			},
			onAny: function e(t, r) {
				var a = this;
				if (!a.eventsListeners || a.destroyed) return a;
				if (typeof t !== "function") return a;
				var n = r ? "unshift" : "push";
				if (a.eventsAnyListeners.indexOf(t) < 0) a.eventsAnyListeners[n](t);
				return a;
			},
			offAny: function e(t) {
				var r = this;
				if (!r.eventsListeners || r.destroyed) return r;
				if (!r.eventsAnyListeners) return r;
				var a = r.eventsAnyListeners.indexOf(t);
				if (a >= 0) r.eventsAnyListeners.splice(a, 1);
				return r;
			},
			off: function e(t, r) {
				var a = this;
				if (!a.eventsListeners || a.destroyed) return a;
				if (!a.eventsListeners) return a;
				t.split(" ").forEach(function (e) {
					if (typeof r === "undefined") a.eventsListeners[e] = [];
					else if (a.eventsListeners[e])
						a.eventsListeners[e].forEach(function (t, n) {
							if (t === r || (t.__emitterProxy && t.__emitterProxy === r)) a.eventsListeners[e].splice(n, 1);
						});
				});
				return a;
			},
			emit: function e() {
				var t = this;
				if (!t.eventsListeners || t.destroyed) return t;
				if (!t.eventsListeners) return t;
				var r;
				var a;
				var n;
				for (var i = arguments.length, s = new Array(i), o = 0; o < i; o++) s[o] = arguments[o];
				if (typeof s[0] === "string" || Array.isArray(s[0])) {
					r = s[0];
					a = s.slice(1, s.length);
					n = t;
				} else {
					r = s[0].events;
					a = s[0].data;
					n = s[0].context || t;
				}
				a.unshift(n);
				var l = Array.isArray(r) ? r : r.split(" ");
				l.forEach(function (e) {
					if (t.eventsAnyListeners && t.eventsAnyListeners.length)
						t.eventsAnyListeners.forEach(function (t) {
							t.apply(
								n,
								[
									e,
								].concat(Vi(a)),
							);
						});
					if (t.eventsListeners && t.eventsListeners[e])
						t.eventsListeners[e].forEach(function (e) {
							e.apply(n, a);
						});
				});
				return t;
			},
		};
		function Qi() {
			var e = this;
			var t;
			var r;
			var a = e.$el;
			if (typeof e.params.width !== "undefined" && e.params.width !== null) t = e.params.width;
			else t = a[0].clientWidth;
			if (typeof e.params.height !== "undefined" && e.params.height !== null) r = e.params.height;
			else r = a[0].clientHeight;
			if ((t === 0 && e.isHorizontal()) || (r === 0 && e.isVertical())) return;
			t = t - parseInt(a.css("padding-left") || 0, 10) - parseInt(a.css("padding-right") || 0, 10);
			r = r - parseInt(a.css("padding-top") || 0, 10) - parseInt(a.css("padding-bottom") || 0, 10);
			if (Number.isNaN(t)) t = 0;
			if (Number.isNaN(r)) r = 0;
			Object.assign(e, { width: t, height: r, size: e.isHorizontal() ? t : r });
		}
		function Ji(e) {
			"@babel/helpers - typeof";
			return (
				(Ji =
					"function" == typeof Symbol && "symbol" == typeof Symbol.iterator
						? function (e) {
								return typeof e;
							}
						: function (e) {
								return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
							}),
				Ji(e)
			);
		}
		function es(e, t, r) {
			return ((t = ts(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = r), e);
		}
		function ts(e) {
			var t = rs(e, "string");
			return "symbol" == Ji(t) ? t : t + "";
		}
		function rs(e, t) {
			if ("object" != Ji(e) || !e) return e;
			var r = e[Symbol.toPrimitive];
			if (void 0 !== r) {
				var a = r.call(e, t || "default");
				if ("object" != Ji(a)) return a;
				throw new TypeError("@@toPrimitive must return a primitive value.");
			}
			return ("string" === t ? String : Number)(e);
		}
		function as() {
			var e = this;
			function t(t) {
				if (e.isHorizontal()) return t;
				return { width: "height", "margin-top": "margin-left", "margin-bottom ": "margin-right", "margin-left": "margin-top", "margin-right": "margin-bottom", "padding-left": "padding-top", "padding-right": "padding-bottom", marginRight: "marginBottom" }[t];
			}
			function r(e, r) {
				return parseFloat(e.getPropertyValue(t(r)) || 0);
			}
			var a = e.params;
			var n = e.$wrapperEl,
				i = e.size,
				s = e.rtlTranslate,
				o = e.wrongRTL;
			var l = e.virtual && a.virtual.enabled;
			var f = l ? e.virtual.slides.length : e.slides.length;
			var u = n.children(".".concat(e.params.slideClass));
			var c = l ? e.virtual.slides.length : u.length;
			var d = [];
			var p = [];
			var v = [];
			var h = a.slidesOffsetBefore;
			if (typeof h === "function") h = a.slidesOffsetBefore.call(e);
			var m = a.slidesOffsetAfter;
			if (typeof m === "function") m = a.slidesOffsetAfter.call(e);
			var g = e.snapGrid.length;
			var y = e.slidesGrid.length;
			var b = a.spaceBetween;
			var w = -h;
			var S = 0;
			var E = 0;
			if (typeof i === "undefined") return;
			if (typeof b === "string" && b.indexOf("%") >= 0) b = (parseFloat(b.replace("%", "")) / 100) * i;
			e.virtualSize = -b;
			if (s) u.css({ marginLeft: "", marginBottom: "", marginTop: "" });
			else u.css({ marginRight: "", marginBottom: "", marginTop: "" });
			if (a.centeredSlides && a.cssMode) {
				Ii(e.wrapperEl, "--swiper-centered-offset-before", "");
				Ii(e.wrapperEl, "--swiper-centered-offset-after", "");
			}
			var x = a.grid && a.grid.rows > 1 && e.grid;
			if (x) e.grid.initSlides(c);
			var T;
			var C =
				a.slidesPerView === "auto" &&
				a.breakpoints &&
				Object.keys(a.breakpoints).filter(function (e) {
					return typeof a.breakpoints[e].slidesPerView !== "undefined";
				}).length > 0;
			for (var M = 0; M < c; M += 1) {
				T = 0;
				var P = u.eq(M);
				if (x) e.grid.updateSlide(M, P, c, t);
				if (P.css("display") === "none") continue;
				if (a.slidesPerView === "auto") {
					if (C) u[M].style[t("width")] = "";
					var O = getComputedStyle(P[0]);
					var k = P[0].style.transform;
					var $ = P[0].style.webkitTransform;
					if (k) P[0].style.transform = "none";
					if ($) P[0].style.webkitTransform = "none";
					if (a.roundLengths) T = e.isHorizontal() ? P.outerWidth(true) : P.outerHeight(true);
					else {
						var A = r(O, "width");
						var I = r(O, "padding-left");
						var z = r(O, "padding-right");
						var L = r(O, "margin-left");
						var D = r(O, "margin-right");
						var j = O.getPropertyValue("box-sizing");
						if (j && j === "border-box") T = A + L + D;
						else {
							var _ = P[0],
								N = _.clientWidth,
								B = _.offsetWidth;
							T = A + I + z + L + D + (B - N);
						}
					}
					if (k) P[0].style.transform = k;
					if ($) P[0].style.webkitTransform = $;
					if (a.roundLengths) T = Math.floor(T);
				} else {
					T = (i - (a.slidesPerView - 1) * b) / a.slidesPerView;
					if (a.roundLengths) T = Math.floor(T);
					if (u[M]) u[M].style[t("width")] = "".concat(T, "px");
				}
				if (u[M]) u[M].swiperSlideSize = T;
				v.push(T);
				if (a.centeredSlides) {
					w = w + T / 2 + S / 2 + b;
					if (S === 0 && M !== 0) w = w - i / 2 - b;
					if (M === 0) w = w - i / 2 - b;
					if (Math.abs(w) < 1 / 1e3) w = 0;
					if (a.roundLengths) w = Math.floor(w);
					if (E % a.slidesPerGroup === 0) d.push(w);
					p.push(w);
				} else {
					if (a.roundLengths) w = Math.floor(w);
					if ((E - Math.min(e.params.slidesPerGroupSkip, E)) % e.params.slidesPerGroup === 0) d.push(w);
					p.push(w);
					w = w + T + b;
				}
				e.virtualSize += T + b;
				S = T;
				E += 1;
			}
			e.virtualSize = Math.max(e.virtualSize, i) + m;
			if (s && o && (a.effect === "slide" || a.effect === "coverflow")) n.css({ width: "".concat(e.virtualSize + a.spaceBetween, "px") });
			if (a.setWrapperSize) n.css(es({}, t("width"), "".concat(e.virtualSize + a.spaceBetween, "px")));
			if (x) e.grid.updateWrapperSize(T, d, t);
			if (!a.centeredSlides) {
				var H = [];
				for (var W = 0; W < d.length; W += 1) {
					var R = d[W];
					if (a.roundLengths) R = Math.floor(R);
					if (d[W] <= e.virtualSize - i) H.push(R);
				}
				d = H;
				if (Math.floor(e.virtualSize - i) - Math.floor(d[d.length - 1]) > 1) d.push(e.virtualSize - i);
			}
			if (d.length === 0)
				d = [
					0,
				];
			if (a.spaceBetween !== 0) {
				var G = e.isHorizontal() && s ? "marginLeft" : t("marginRight");
				u.filter(function (e, t) {
					if (!a.cssMode) return true;
					if (t === u.length - 1) return false;
					return true;
				}).css(es({}, G, "".concat(b, "px")));
			}
			if (a.centeredSlides && a.centeredSlidesBounds) {
				var q = 0;
				v.forEach(function (e) {
					q += e + (a.spaceBetween ? a.spaceBetween : 0);
				});
				q -= a.spaceBetween;
				var V = q - i;
				d = d.map(function (e) {
					if (e < 0) return -h;
					if (e > V) return V + m;
					return e;
				});
			}
			if (a.centerInsufficientSlides) {
				var X = 0;
				v.forEach(function (e) {
					X += e + (a.spaceBetween ? a.spaceBetween : 0);
				});
				X -= a.spaceBetween;
				if (X < i) {
					var F = (i - X) / 2;
					d.forEach(function (e, t) {
						d[t] = e - F;
					});
					p.forEach(function (e, t) {
						p[t] = e + F;
					});
				}
			}
			Object.assign(e, { slides: u, snapGrid: d, slidesGrid: p, slidesSizesGrid: v });
			if (a.centeredSlides && a.cssMode && !a.centeredSlidesBounds) {
				Ii(e.wrapperEl, "--swiper-centered-offset-before", "".concat(-d[0], "px"));
				Ii(e.wrapperEl, "--swiper-centered-offset-after", "".concat(e.size / 2 - v[v.length - 1] / 2, "px"));
				var Y = -e.snapGrid[0];
				var U = -e.slidesGrid[0];
				e.snapGrid = e.snapGrid.map(function (e) {
					return e + Y;
				});
				e.slidesGrid = e.slidesGrid.map(function (e) {
					return e + U;
				});
			}
			if (c !== f) e.emit("slidesLengthChange");
			if (d.length !== g) {
				if (e.params.watchOverflow) e.checkOverflow();
				e.emit("snapGridLengthChange");
			}
			if (p.length !== y) e.emit("slidesGridLengthChange");
			if (a.watchSlidesProgress) e.updateSlidesOffset();
			if (!l && !a.cssMode && (a.effect === "slide" || a.effect === "fade")) {
				var K = "".concat(a.containerModifierClass, "backface-hidden");
				var Z = e.$el.hasClass(K);
				if (c <= a.maxBackfaceHiddenSlides) {
					if (!Z) e.$el.addClass(K);
				} else if (Z) e.$el.removeClass(K);
			}
		}
		function ns(e) {
			var t = this;
			var r = [];
			var a = t.virtual && t.params.virtual.enabled;
			var n = 0;
			var i;
			if (typeof e === "number") t.setTransition(e);
			else if (e === true) t.setTransition(t.params.speed);
			var s = function e(r) {
				if (a)
					return t.slides.filter(function (e) {
						return parseInt(e.getAttribute("data-swiper-slide-index"), 10) === r;
					})[0];
				return t.slides.eq(r)[0];
			};
			if (t.params.slidesPerView !== "auto" && t.params.slidesPerView > 1)
				if (t.params.centeredSlides)
					(t.visibleSlides || bi([])).each(function (e) {
						r.push(e);
					});
				else
					for (i = 0; i < Math.ceil(t.params.slidesPerView); i += 1) {
						var o = t.activeIndex + i;
						if (o > t.slides.length && !a) break;
						r.push(s(o));
					}
			else r.push(s(t.activeIndex));
			for (i = 0; i < r.length; i += 1)
				if (typeof r[i] !== "undefined") {
					var l = r[i].offsetHeight;
					n = l > n ? l : n;
				}
			if (n || n === 0) t.$wrapperEl.css("height", "".concat(n, "px"));
		}
		function is() {
			var e = this;
			var t = e.slides;
			for (var r = 0; r < t.length; r += 1) t[r].swiperSlideOffset = e.isHorizontal() ? t[r].offsetLeft : t[r].offsetTop;
		}
		function ss() {
			var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (this && this.translate) || 0;
			var t = this;
			var r = t.params;
			var a = t.slides,
				n = t.rtlTranslate,
				i = t.snapGrid;
			if (a.length === 0) return;
			if (typeof a[0].swiperSlideOffset === "undefined") t.updateSlidesOffset();
			var s = -e;
			if (n) s = e;
			a.removeClass(r.slideVisibleClass);
			t.visibleSlidesIndexes = [];
			t.visibleSlides = [];
			for (var o = 0; o < a.length; o += 1) {
				var l = a[o];
				var f = l.swiperSlideOffset;
				if (r.cssMode && r.centeredSlides) f -= a[0].swiperSlideOffset;
				var u = (s + (r.centeredSlides ? t.minTranslate() : 0) - f) / (l.swiperSlideSize + r.spaceBetween);
				var c = (s - i[0] + (r.centeredSlides ? t.minTranslate() : 0) - f) / (l.swiperSlideSize + r.spaceBetween);
				var d = -(s - f);
				var p = d + t.slidesSizesGrid[o];
				var v = (d >= 0 && d < t.size - 1) || (p > 1 && p <= t.size) || (d <= 0 && p >= t.size);
				if (v) {
					t.visibleSlides.push(l);
					t.visibleSlidesIndexes.push(o);
					a.eq(o).addClass(r.slideVisibleClass);
				}
				l.progress = n ? -u : u;
				l.originalProgress = n ? -c : c;
			}
			t.visibleSlides = bi(t.visibleSlides);
		}
		function os(e) {
			var t = this;
			if (typeof e === "undefined") {
				var r = t.rtlTranslate ? -1 : 1;
				e = (t && t.translate && t.translate * r) || 0;
			}
			var a = t.params;
			var n = t.maxTranslate() - t.minTranslate();
			var i = t.progress,
				s = t.isBeginning,
				o = t.isEnd;
			var l = s;
			var f = o;
			if (n === 0) {
				i = 0;
				s = true;
				o = true;
			} else {
				i = (e - t.minTranslate()) / n;
				s = i <= 0;
				o = i >= 1;
			}
			Object.assign(t, { progress: i, isBeginning: s, isEnd: o });
			if (a.watchSlidesProgress || (a.centeredSlides && a.autoHeight)) t.updateSlidesProgress(e);
			if (s && !l) t.emit("reachBeginning toEdge");
			if (o && !f) t.emit("reachEnd toEdge");
			if ((l && !s) || (f && !o)) t.emit("fromEdge");
			t.emit("progress", i);
		}
		function ls() {
			var e = this;
			var t = e.slides,
				r = e.params,
				a = e.$wrapperEl,
				n = e.activeIndex,
				i = e.realIndex;
			var s = e.virtual && r.virtual.enabled;
			t.removeClass("".concat(r.slideActiveClass, " ").concat(r.slideNextClass, " ").concat(r.slidePrevClass, " ").concat(r.slideDuplicateActiveClass, " ").concat(r.slideDuplicateNextClass, " ").concat(r.slideDuplicatePrevClass));
			var o;
			if (s) o = e.$wrapperEl.find(".".concat(r.slideClass, '[data-swiper-slide-index="').concat(n, '"]'));
			else o = t.eq(n);
			o.addClass(r.slideActiveClass);
			if (r.loop)
				if (o.hasClass(r.slideDuplicateClass)) a.children(".".concat(r.slideClass, ":not(.").concat(r.slideDuplicateClass, ')[data-swiper-slide-index="').concat(i, '"]')).addClass(r.slideDuplicateActiveClass);
				else a.children(".".concat(r.slideClass, ".").concat(r.slideDuplicateClass, '[data-swiper-slide-index="').concat(i, '"]')).addClass(r.slideDuplicateActiveClass);
			var l = o.nextAll(".".concat(r.slideClass)).eq(0).addClass(r.slideNextClass);
			if (r.loop && l.length === 0) {
				l = t.eq(0);
				l.addClass(r.slideNextClass);
			}
			var f = o.prevAll(".".concat(r.slideClass)).eq(0).addClass(r.slidePrevClass);
			if (r.loop && f.length === 0) {
				f = t.eq(-1);
				f.addClass(r.slidePrevClass);
			}
			if (r.loop) {
				if (l.hasClass(r.slideDuplicateClass)) a.children(".".concat(r.slideClass, ":not(.").concat(r.slideDuplicateClass, ')[data-swiper-slide-index="').concat(l.attr("data-swiper-slide-index"), '"]')).addClass(r.slideDuplicateNextClass);
				else a.children(".".concat(r.slideClass, ".").concat(r.slideDuplicateClass, '[data-swiper-slide-index="').concat(l.attr("data-swiper-slide-index"), '"]')).addClass(r.slideDuplicateNextClass);
				if (f.hasClass(r.slideDuplicateClass)) a.children(".".concat(r.slideClass, ":not(.").concat(r.slideDuplicateClass, ')[data-swiper-slide-index="').concat(f.attr("data-swiper-slide-index"), '"]')).addClass(r.slideDuplicatePrevClass);
				else a.children(".".concat(r.slideClass, ".").concat(r.slideDuplicateClass, '[data-swiper-slide-index="').concat(f.attr("data-swiper-slide-index"), '"]')).addClass(r.slideDuplicatePrevClass);
			}
			e.emitSlidesClasses();
		}
		function fs(e) {
			var t = this;
			var r = t.rtlTranslate ? t.translate : -t.translate;
			var a = t.slidesGrid,
				n = t.snapGrid,
				i = t.params,
				s = t.activeIndex,
				o = t.realIndex,
				l = t.snapIndex;
			var f = e;
			var u;
			if (typeof f === "undefined") {
				for (var c = 0; c < a.length; c += 1)
					if (typeof a[c + 1] !== "undefined") {
						if (r >= a[c] && r < a[c + 1] - (a[c + 1] - a[c]) / 2) f = c;
						else if (r >= a[c] && r < a[c + 1]) f = c + 1;
					} else if (r >= a[c]) f = c;
				if (i.normalizeSlideIndex) if (f < 0 || typeof f === "undefined") f = 0;
			}
			if (n.indexOf(r) >= 0) u = n.indexOf(r);
			else {
				var d = Math.min(i.slidesPerGroupSkip, f);
				u = d + Math.floor((f - d) / i.slidesPerGroup);
			}
			if (u >= n.length) u = n.length - 1;
			if (f === s) {
				if (u !== l) {
					t.snapIndex = u;
					t.emit("snapIndexChange");
				}
				return;
			}
			var p = parseInt(t.slides.eq(f).attr("data-swiper-slide-index") || f, 10);
			Object.assign(t, { snapIndex: u, realIndex: p, previousIndex: s, activeIndex: f });
			t.emit("activeIndexChange");
			t.emit("snapIndexChange");
			if (o !== p) t.emit("realIndexChange");
			if (t.initialized || t.params.runCallbacksOnInit) t.emit("slideChange");
		}
		function us(e) {
			var t = this;
			var r = t.params;
			var a = bi(e).closest(".".concat(r.slideClass))[0];
			var n = false;
			var i;
			if (a)
				for (var s = 0; s < t.slides.length; s += 1)
					if (t.slides[s] === a) {
						n = true;
						i = s;
						break;
					}
			if (a && n) {
				t.clickedSlide = a;
				if (t.virtual && t.params.virtual.enabled) t.clickedIndex = parseInt(bi(a).attr("data-swiper-slide-index"), 10);
				else t.clickedIndex = i;
			} else {
				t.clickedSlide = void 0;
				t.clickedIndex = void 0;
				return;
			}
			if (r.slideToClickedSlide && t.clickedIndex !== void 0 && t.clickedIndex !== t.activeIndex) t.slideToClickedSlide();
		}
		const cs = { updateSize: Qi, updateSlides: as, updateAutoHeight: ns, updateSlidesOffset: is, updateSlidesProgress: ss, updateProgress: os, updateSlidesClasses: ls, updateActiveIndex: fs, updateClickedSlide: us };
		function ds() {
			var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.isHorizontal() ? "x" : "y";
			var t = this;
			var r = t.params,
				a = t.rtlTranslate,
				n = t.translate,
				i = t.$wrapperEl;
			if (r.virtualTranslate) return a ? -n : n;
			if (r.cssMode) return n;
			var s = Oi(i[0], e);
			if (a) s = -s;
			return s || 0;
		}
		function ps(e, t) {
			var r = this;
			var a = r.rtlTranslate,
				n = r.params,
				i = r.$wrapperEl,
				s = r.wrapperEl,
				o = r.progress;
			var l = 0;
			var f = 0;
			var u = 0;
			if (r.isHorizontal()) l = a ? -e : e;
			else f = e;
			if (n.roundLengths) {
				l = Math.floor(l);
				f = Math.floor(f);
			}
			if (n.cssMode) s[r.isHorizontal() ? "scrollLeft" : "scrollTop"] = r.isHorizontal() ? -l : -f;
			else if (!n.virtualTranslate) i.transform("translate3d(".concat(l, "px, ").concat(f, "px, ").concat(u, "px)"));
			r.previousTranslate = r.translate;
			r.translate = r.isHorizontal() ? l : f;
			var c;
			var d = r.maxTranslate() - r.minTranslate();
			if (d === 0) c = 0;
			else c = (e - r.minTranslate()) / d;
			if (c !== o) r.updateProgress(e);
			r.emit("setTranslate", r.translate, t);
		}
		function vs() {
			return -this.snapGrid[0];
		}
		function hs() {
			return -this.snapGrid[this.snapGrid.length - 1];
		}
		function ms(e) {
			"@babel/helpers - typeof";
			return (
				(ms =
					"function" == typeof Symbol && "symbol" == typeof Symbol.iterator
						? function (e) {
								return typeof e;
							}
						: function (e) {
								return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
							}),
				ms(e)
			);
		}
		function gs(e, t, r) {
			return ((t = ys(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = r), e);
		}
		function ys(e) {
			var t = bs(e, "string");
			return "symbol" == ms(t) ? t : t + "";
		}
		function bs(e, t) {
			if ("object" != ms(e) || !e) return e;
			var r = e[Symbol.toPrimitive];
			if (void 0 !== r) {
				var a = r.call(e, t || "default");
				if ("object" != ms(a)) return a;
				throw new TypeError("@@toPrimitive must return a primitive value.");
			}
			return ("string" === t ? String : Number)(e);
		}
		function ws() {
			var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
			var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.params.speed;
			var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
			var a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
			var n = arguments.length > 4 ? arguments[4] : void 0;
			var i = this;
			var s = i.params,
				o = i.wrapperEl;
			if (i.animating && s.preventInteractionOnTransition) return false;
			var l = i.minTranslate();
			var f = i.maxTranslate();
			var u;
			if (a && e > l) u = l;
			else if (a && e < f) u = f;
			else u = e;
			i.updateProgress(u);
			if (s.cssMode) {
				var c = i.isHorizontal();
				if (t === 0) o[c ? "scrollLeft" : "scrollTop"] = -u;
				else {
					if (!i.support.smoothScroll) {
						zi({ swiper: i, targetPosition: -u, side: c ? "left" : "top" });
						return true;
					}
					o.scrollTo(gs(gs({}, c ? "left" : "top", -u), "behavior", "smooth"));
				}
				return true;
			}
			if (t === 0) {
				i.setTransition(0);
				i.setTranslate(u);
				if (r) {
					i.emit("beforeTransitionStart", t, n);
					i.emit("transitionEnd");
				}
			} else {
				i.setTransition(t);
				i.setTranslate(u);
				if (r) {
					i.emit("beforeTransitionStart", t, n);
					i.emit("transitionStart");
				}
				if (!i.animating) {
					i.animating = true;
					if (!i.onTranslateToWrapperTransitionEnd)
						i.onTranslateToWrapperTransitionEnd = function e(t) {
							if (!i || i.destroyed) return;
							if (t.target !== this) return;
							i.$wrapperEl[0].removeEventListener("transitionend", i.onTranslateToWrapperTransitionEnd);
							i.$wrapperEl[0].removeEventListener("webkitTransitionEnd", i.onTranslateToWrapperTransitionEnd);
							i.onTranslateToWrapperTransitionEnd = null;
							delete i.onTranslateToWrapperTransitionEnd;
							if (r) i.emit("transitionEnd");
						};
					i.$wrapperEl[0].addEventListener("transitionend", i.onTranslateToWrapperTransitionEnd);
					i.$wrapperEl[0].addEventListener("webkitTransitionEnd", i.onTranslateToWrapperTransitionEnd);
				}
			}
			return true;
		}
		const Ss = { getTranslate: ds, setTranslate: ps, minTranslate: vs, maxTranslate: hs, translateTo: ws };
		function Es(e, t) {
			var r = this;
			if (!r.params.cssMode) r.$wrapperEl.transition(e);
			r.emit("setTransition", e, t);
		}
		function xs(e) {
			var t = e.swiper,
				r = e.runCallbacks,
				a = e.direction,
				n = e.step;
			var i = t.activeIndex,
				s = t.previousIndex;
			var o = a;
			if (!o)
				if (i > s) o = "next";
				else if (i < s) o = "prev";
				else o = "reset";
			t.emit("transition".concat(n));
			if (r && i !== s) {
				if (o === "reset") {
					t.emit("slideResetTransition".concat(n));
					return;
				}
				t.emit("slideChangeTransition".concat(n));
				if (o === "next") t.emit("slideNextTransition".concat(n));
				else t.emit("slidePrevTransition".concat(n));
			}
		}
		function Ts() {
			var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
			var t = arguments.length > 1 ? arguments[1] : void 0;
			var r = this;
			var a = r.params;
			if (a.cssMode) return;
			if (a.autoHeight) r.updateAutoHeight();
			xs({ swiper: r, runCallbacks: e, direction: t, step: "Start" });
		}
		function Cs() {
			var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
			var t = arguments.length > 1 ? arguments[1] : void 0;
			var r = this;
			var a = r.params;
			r.animating = false;
			if (a.cssMode) return;
			r.setTransition(0);
			xs({ swiper: r, runCallbacks: e, direction: t, step: "End" });
		}
		const Ms = { setTransition: Es, transitionStart: Ts, transitionEnd: Cs };
		function Ps(e, t, r) {
			return ((t = Os(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = r), e);
		}
		function Os(e) {
			var t = ks(e, "string");
			return "symbol" == $s(t) ? t : t + "";
		}
		function ks(e, t) {
			if ("object" != $s(e) || !e) return e;
			var r = e[Symbol.toPrimitive];
			if (void 0 !== r) {
				var a = r.call(e, t || "default");
				if ("object" != $s(a)) return a;
				throw new TypeError("@@toPrimitive must return a primitive value.");
			}
			return ("string" === t ? String : Number)(e);
		}
		function $s(e) {
			"@babel/helpers - typeof";
			return (
				($s =
					"function" == typeof Symbol && "symbol" == typeof Symbol.iterator
						? function (e) {
								return typeof e;
							}
						: function (e) {
								return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
							}),
				$s(e)
			);
		}
		function As() {
			var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
			var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.params.speed;
			var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
			var a = arguments.length > 3 ? arguments[3] : void 0;
			var n = arguments.length > 4 ? arguments[4] : void 0;
			if (typeof e !== "number" && typeof e !== "string") throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. [".concat($s(e), "] given."));
			if (typeof e === "string") {
				var i = parseInt(e, 10);
				var s = isFinite(i);
				if (!s) throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [".concat(e, "] given."));
				e = i;
			}
			var o = this;
			var l = e;
			if (l < 0) l = 0;
			var f = o.params,
				u = o.snapGrid,
				c = o.slidesGrid,
				d = o.previousIndex,
				p = o.activeIndex,
				v = o.rtlTranslate,
				h = o.wrapperEl,
				m = o.enabled;
			if ((o.animating && f.preventInteractionOnTransition) || (!m && !a && !n)) return false;
			var g = Math.min(o.params.slidesPerGroupSkip, l);
			var y = g + Math.floor((l - g) / o.params.slidesPerGroup);
			if (y >= u.length) y = u.length - 1;
			var b = -u[y];
			if (f.normalizeSlideIndex)
				for (var w = 0; w < c.length; w += 1) {
					var S = -Math.floor(b * 100);
					var E = Math.floor(c[w] * 100);
					var x = Math.floor(c[w + 1] * 100);
					if (typeof c[w + 1] !== "undefined") {
						if (S >= E && S < x - (x - E) / 2) l = w;
						else if (S >= E && S < x) l = w + 1;
					} else if (S >= E) l = w;
				}
			if (o.initialized && l !== p) {
				if (!o.allowSlideNext && b < o.translate && b < o.minTranslate()) return false;
				if (!o.allowSlidePrev && b > o.translate && b > o.maxTranslate()) if ((p || 0) !== l) return false;
			}
			if (l !== (d || 0) && r) o.emit("beforeSlideChangeStart");
			o.updateProgress(b);
			var T;
			if (l > p) T = "next";
			else if (l < p) T = "prev";
			else T = "reset";
			if ((v && -b === o.translate) || (!v && b === o.translate)) {
				o.updateActiveIndex(l);
				if (f.autoHeight) o.updateAutoHeight();
				o.updateSlidesClasses();
				if (f.effect !== "slide") o.setTranslate(b);
				if (T !== "reset") {
					o.transitionStart(r, T);
					o.transitionEnd(r, T);
				}
				return false;
			}
			if (f.cssMode) {
				var C = o.isHorizontal();
				var M = v ? b : -b;
				if (t === 0) {
					var P = o.virtual && o.params.virtual.enabled;
					if (P) {
						o.wrapperEl.style.scrollSnapType = "none";
						o._immediateVirtual = true;
					}
					h[C ? "scrollLeft" : "scrollTop"] = M;
					if (P)
						requestAnimationFrame(function () {
							o.wrapperEl.style.scrollSnapType = "";
							o._swiperImmediateVirtual = false;
						});
				} else {
					if (!o.support.smoothScroll) {
						zi({ swiper: o, targetPosition: M, side: C ? "left" : "top" });
						return true;
					}
					h.scrollTo(Ps(Ps({}, C ? "left" : "top", M), "behavior", "smooth"));
				}
				return true;
			}
			o.setTransition(t);
			o.setTranslate(b);
			o.updateActiveIndex(l);
			o.updateSlidesClasses();
			o.emit("beforeTransitionStart", t, a);
			o.transitionStart(r, T);
			if (t === 0) o.transitionEnd(r, T);
			else if (!o.animating) {
				o.animating = true;
				if (!o.onSlideToWrapperTransitionEnd)
					o.onSlideToWrapperTransitionEnd = function e(t) {
						if (!o || o.destroyed) return;
						if (t.target !== this) return;
						o.$wrapperEl[0].removeEventListener("transitionend", o.onSlideToWrapperTransitionEnd);
						o.$wrapperEl[0].removeEventListener("webkitTransitionEnd", o.onSlideToWrapperTransitionEnd);
						o.onSlideToWrapperTransitionEnd = null;
						delete o.onSlideToWrapperTransitionEnd;
						o.transitionEnd(r, T);
					};
				o.$wrapperEl[0].addEventListener("transitionend", o.onSlideToWrapperTransitionEnd);
				o.$wrapperEl[0].addEventListener("webkitTransitionEnd", o.onSlideToWrapperTransitionEnd);
			}
			return true;
		}
		function Is() {
			var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
			var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.params.speed;
			var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
			var a = arguments.length > 3 ? arguments[3] : void 0;
			if (typeof e === "string") {
				var n = parseInt(e, 10);
				var i = isFinite(n);
				if (!i) throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [".concat(e, "] given."));
				e = n;
			}
			var s = this;
			var o = e;
			if (s.params.loop) o += s.loopedSlides;
			return s.slideTo(o, t, r, a);
		}
		function zs() {
			var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.params.speed;
			var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
			var r = arguments.length > 2 ? arguments[2] : void 0;
			var a = this;
			var n = a.animating,
				i = a.enabled,
				s = a.params;
			if (!i) return a;
			var o = s.slidesPerGroup;
			if (s.slidesPerView === "auto" && s.slidesPerGroup === 1 && s.slidesPerGroupAuto) o = Math.max(a.slidesPerViewDynamic("current", true), 1);
			var l = a.activeIndex < s.slidesPerGroupSkip ? 1 : o;
			if (s.loop) {
				if (n && s.loopPreventsSlide) return false;
				a.loopFix();
				a._clientLeft = a.$wrapperEl[0].clientLeft;
			}
			if (s.rewind && a.isEnd) return a.slideTo(0, e, t, r);
			return a.slideTo(a.activeIndex + l, e, t, r);
		}
		function Ls() {
			var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.params.speed;
			var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
			var r = arguments.length > 2 ? arguments[2] : void 0;
			var a = this;
			var n = a.params,
				i = a.animating,
				s = a.snapGrid,
				o = a.slidesGrid,
				l = a.rtlTranslate,
				f = a.enabled;
			if (!f) return a;
			if (n.loop) {
				if (i && n.loopPreventsSlide) return false;
				a.loopFix();
				a._clientLeft = a.$wrapperEl[0].clientLeft;
			}
			var u = l ? a.translate : -a.translate;
			function c(e) {
				if (e < 0) return -Math.floor(Math.abs(e));
				return Math.floor(e);
			}
			var d = c(u);
			var p = s.map(function (e) {
				return c(e);
			});
			var v = s[p.indexOf(d) - 1];
			if (typeof v === "undefined" && n.cssMode) {
				var h;
				s.forEach(function (e, t) {
					if (d >= e) h = t;
				});
				if (typeof h !== "undefined") v = s[h > 0 ? h - 1 : h];
			}
			var m = 0;
			if (typeof v !== "undefined") {
				m = o.indexOf(v);
				if (m < 0) m = a.activeIndex - 1;
				if (n.slidesPerView === "auto" && n.slidesPerGroup === 1 && n.slidesPerGroupAuto) {
					m = m - a.slidesPerViewDynamic("previous", true) + 1;
					m = Math.max(m, 0);
				}
			}
			if (n.rewind && a.isBeginning) {
				var g = a.params.virtual && a.params.virtual.enabled && a.virtual ? a.virtual.slides.length - 1 : a.slides.length - 1;
				return a.slideTo(g, e, t, r);
			}
			return a.slideTo(m, e, t, r);
		}
		function Ds() {
			var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.params.speed;
			var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
			var r = arguments.length > 2 ? arguments[2] : void 0;
			var a = this;
			return a.slideTo(a.activeIndex, e, t, r);
		}
		function js() {
			var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.params.speed;
			var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
			var r = arguments.length > 2 ? arguments[2] : void 0;
			var a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0.5;
			var n = this;
			var i = n.activeIndex;
			var s = Math.min(n.params.slidesPerGroupSkip, i);
			var o = s + Math.floor((i - s) / n.params.slidesPerGroup);
			var l = n.rtlTranslate ? n.translate : -n.translate;
			if (l >= n.snapGrid[o]) {
				var f = n.snapGrid[o];
				var u = n.snapGrid[o + 1];
				if (l - f > (u - f) * a) i += n.params.slidesPerGroup;
			} else {
				var c = n.snapGrid[o - 1];
				var d = n.snapGrid[o];
				if (l - c <= (d - c) * a) i -= n.params.slidesPerGroup;
			}
			i = Math.max(i, 0);
			i = Math.min(i, n.slidesGrid.length - 1);
			return n.slideTo(i, e, t, r);
		}
		function _s() {
			var e = this;
			var t = e.params,
				r = e.$wrapperEl;
			var a = t.slidesPerView === "auto" ? e.slidesPerViewDynamic() : t.slidesPerView;
			var n = e.clickedIndex;
			var i;
			if (t.loop) {
				if (e.animating) return;
				i = parseInt(bi(e.clickedSlide).attr("data-swiper-slide-index"), 10);
				if (t.centeredSlides)
					if (n < e.loopedSlides - a / 2 || n > e.slides.length - e.loopedSlides + a / 2) {
						e.loopFix();
						n = r.children(".".concat(t.slideClass, '[data-swiper-slide-index="').concat(i, '"]:not(.').concat(t.slideDuplicateClass, ")")).eq(0).index();
						Ci(function () {
							e.slideTo(n);
						});
					} else e.slideTo(n);
				else if (n > e.slides.length - a) {
					e.loopFix();
					n = r.children(".".concat(t.slideClass, '[data-swiper-slide-index="').concat(i, '"]:not(.').concat(t.slideDuplicateClass, ")")).eq(0).index();
					Ci(function () {
						e.slideTo(n);
					});
				} else e.slideTo(n);
			} else e.slideTo(n);
		}
		const Ns = { slideTo: As, slideToLoop: Is, slideNext: zs, slidePrev: Ls, slideReset: Ds, slideToClosest: js, slideToClickedSlide: _s };
		function Bs() {
			var e = this;
			var t = ia();
			var r = e.params,
				a = e.$wrapperEl;
			var n = a.children().length > 0 ? bi(a.children()[0].parentNode) : a;
			n.children(".".concat(r.slideClass, ".").concat(r.slideDuplicateClass)).remove();
			var i = n.children(".".concat(r.slideClass));
			if (r.loopFillGroupWithBlank) {
				var s = r.slidesPerGroup - (i.length % r.slidesPerGroup);
				if (s !== r.slidesPerGroup) {
					for (var o = 0; o < s; o += 1) {
						var l = bi(t.createElement("div")).addClass("".concat(r.slideClass, " ").concat(r.slideBlankClass));
						n.append(l);
					}
					i = n.children(".".concat(r.slideClass));
				}
			}
			if (r.slidesPerView === "auto" && !r.loopedSlides) r.loopedSlides = i.length;
			e.loopedSlides = Math.ceil(parseFloat(r.loopedSlides || r.slidesPerView, 10));
			e.loopedSlides += r.loopAdditionalSlides;
			if (e.loopedSlides > i.length && e.params.loopedSlidesLimit) e.loopedSlides = i.length;
			var f = [];
			var u = [];
			i.each(function (e, t) {
				var r = bi(e);
				r.attr("data-swiper-slide-index", t);
			});
			for (var c = 0; c < e.loopedSlides; c += 1) {
				var d = c - Math.floor(c / i.length) * i.length;
				u.push(i.eq(d)[0]);
				f.unshift(i.eq(i.length - d - 1)[0]);
			}
			for (var p = 0; p < u.length; p += 1) n.append(bi(u[p].cloneNode(true)).addClass(r.slideDuplicateClass));
			for (var v = f.length - 1; v >= 0; v -= 1) n.prepend(bi(f[v].cloneNode(true)).addClass(r.slideDuplicateClass));
		}
		function Hs() {
			var e = this;
			e.emit("beforeLoopFix");
			var t = e.activeIndex,
				r = e.slides,
				a = e.loopedSlides,
				n = e.allowSlidePrev,
				i = e.allowSlideNext,
				s = e.snapGrid,
				o = e.rtlTranslate;
			var l;
			e.allowSlidePrev = true;
			e.allowSlideNext = true;
			var f = -s[t];
			var u = f - e.getTranslate();
			if (t < a) {
				l = r.length - a * 3 + t;
				l += a;
				var c = e.slideTo(l, 0, false, true);
				if (c && u !== 0) e.setTranslate((o ? -e.translate : e.translate) - u);
			} else if (t >= r.length - a) {
				l = -r.length + t + a;
				l += a;
				var d = e.slideTo(l, 0, false, true);
				if (d && u !== 0) e.setTranslate((o ? -e.translate : e.translate) - u);
			}
			e.allowSlidePrev = n;
			e.allowSlideNext = i;
			e.emit("loopFix");
		}
		function Ws() {
			var e = this;
			var t = e.$wrapperEl,
				r = e.params,
				a = e.slides;
			t.children(".".concat(r.slideClass, ".").concat(r.slideDuplicateClass, ",.").concat(r.slideClass, ".").concat(r.slideBlankClass)).remove();
			a.removeAttr("data-swiper-slide-index");
		}
		const Rs = { loopCreate: Bs, loopFix: Hs, loopDestroy: Ws };
		function Gs(e) {
			var t = this;
			if (t.support.touch || !t.params.simulateTouch || (t.params.watchOverflow && t.isLocked) || t.params.cssMode) return;
			var r = t.params.touchEventsTarget === "container" ? t.el : t.wrapperEl;
			r.style.cursor = "move";
			r.style.cursor = e ? "grabbing" : "grab";
		}
		function qs() {
			var e = this;
			if (e.support.touch || (e.params.watchOverflow && e.isLocked) || e.params.cssMode) return;
			e[e.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
		}
		const Vs = { setGrabCursor: Gs, unsetGrabCursor: qs };
		function Xs(e) {
			var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this;
			function r(t) {
				if (!t || t === ia() || t === oa()) return null;
				if (t.assignedSlot) t = t.assignedSlot;
				var a = t.closest(e);
				if (!a && !t.getRootNode) return null;
				return a || r(t.getRootNode().host);
			}
			return r(t);
		}
		function Fs(e) {
			var t = this;
			var r = ia();
			var a = oa();
			var n = t.touchEventsData;
			var i = t.params,
				s = t.touches,
				o = t.enabled;
			if (!o) return;
			if (t.animating && i.preventInteractionOnTransition) return;
			if (!t.animating && i.cssMode && i.loop) t.loopFix();
			var l = e;
			if (l.originalEvent) l = l.originalEvent;
			var f = bi(l.target);
			if (i.touchEventsTarget === "wrapper") if (!f.closest(t.wrapperEl).length) return;
			n.isTouchEvent = l.type === "touchstart";
			if (!n.isTouchEvent && "which" in l && l.which === 3) return;
			if (!n.isTouchEvent && "button" in l && l.button > 0) return;
			if (n.isTouched && n.isMoved) return;
			var u = !!i.noSwipingClass && i.noSwipingClass !== "";
			var c = e.composedPath ? e.composedPath() : e.path;
			if (u && l.target && l.target.shadowRoot && c) f = bi(c[0]);
			var d = i.noSwipingSelector ? i.noSwipingSelector : ".".concat(i.noSwipingClass);
			var p = !!(l.target && l.target.shadowRoot);
			if (i.noSwiping && (p ? Xs(d, f[0]) : f.closest(d)[0])) {
				t.allowClick = true;
				return;
			}
			if (i.swipeHandler) if (!f.closest(i.swipeHandler)[0]) return;
			s.currentX = l.type === "touchstart" ? l.targetTouches[0].pageX : l.pageX;
			s.currentY = l.type === "touchstart" ? l.targetTouches[0].pageY : l.pageY;
			var v = s.currentX;
			var h = s.currentY;
			var m = i.edgeSwipeDetection || i.iOSEdgeSwipeDetection;
			var g = i.edgeSwipeThreshold || i.iOSEdgeSwipeThreshold;
			if (m && (v <= g || v >= a.innerWidth - g))
				if (m === "prevent") e.preventDefault();
				else return;
			Object.assign(n, { isTouched: true, isMoved: false, allowTouchCallbacks: true, isScrolling: void 0, startMoving: void 0 });
			s.startX = v;
			s.startY = h;
			n.touchStartTime = Mi();
			t.allowClick = true;
			t.updateSize();
			t.swipeDirection = void 0;
			if (i.threshold > 0) n.allowThresholdMove = false;
			if (l.type !== "touchstart") {
				var y = true;
				if (f.is(n.focusableElements)) {
					y = false;
					if (f[0].nodeName === "SELECT") n.isTouched = false;
				}
				if (r.activeElement && bi(r.activeElement).is(n.focusableElements) && r.activeElement !== f[0]) r.activeElement.blur();
				var b = y && t.allowTouchMove && i.touchStartPreventDefault;
				if ((i.touchStartForcePreventDefault || b) && !f[0].isContentEditable) l.preventDefault();
			}
			if (t.params.freeMode && t.params.freeMode.enabled && t.freeMode && t.animating && !i.cssMode) t.freeMode.onTouchStart();
			t.emit("touchStart", l);
		}
		function Ys(e) {
			var t = ia();
			var r = this;
			var a = r.touchEventsData;
			var n = r.params,
				i = r.touches,
				s = r.rtlTranslate,
				o = r.enabled;
			if (!o) return;
			var l = e;
			if (l.originalEvent) l = l.originalEvent;
			if (!a.isTouched) {
				if (a.startMoving && a.isScrolling) r.emit("touchMoveOpposite", l);
				return;
			}
			if (a.isTouchEvent && l.type !== "touchmove") return;
			var f = l.type === "touchmove" && l.targetTouches && (l.targetTouches[0] || l.changedTouches[0]);
			var u = l.type === "touchmove" ? f.pageX : l.pageX;
			var c = l.type === "touchmove" ? f.pageY : l.pageY;
			if (l.preventedByNestedSwiper) {
				i.startX = u;
				i.startY = c;
				return;
			}
			if (!r.allowTouchMove) {
				if (!bi(l.target).is(a.focusableElements)) r.allowClick = false;
				if (a.isTouched) {
					Object.assign(i, { startX: u, startY: c, currentX: u, currentY: c });
					a.touchStartTime = Mi();
				}
				return;
			}
			if (a.isTouchEvent && n.touchReleaseOnEdges && !n.loop)
				if (r.isVertical()) {
					if ((c < i.startY && r.translate <= r.maxTranslate()) || (c > i.startY && r.translate >= r.minTranslate())) {
						a.isTouched = false;
						a.isMoved = false;
						return;
					}
				} else if ((u < i.startX && r.translate <= r.maxTranslate()) || (u > i.startX && r.translate >= r.minTranslate())) return;
			if (a.isTouchEvent && t.activeElement)
				if (l.target === t.activeElement && bi(l.target).is(a.focusableElements)) {
					a.isMoved = true;
					r.allowClick = false;
					return;
				}
			if (a.allowTouchCallbacks) r.emit("touchMove", l);
			if (l.targetTouches && l.targetTouches.length > 1) return;
			i.currentX = u;
			i.currentY = c;
			var d = i.currentX - i.startX;
			var p = i.currentY - i.startY;
			if (r.params.threshold && Math.sqrt(Math.pow(d, 2) + Math.pow(p, 2)) < r.params.threshold) return;
			if (typeof a.isScrolling === "undefined") {
				var v;
				if ((r.isHorizontal() && i.currentY === i.startY) || (r.isVertical() && i.currentX === i.startX)) a.isScrolling = false;
				else if (d * d + p * p >= 25) {
					v = (Math.atan2(Math.abs(p), Math.abs(d)) * 180) / Math.PI;
					a.isScrolling = r.isHorizontal() ? v > n.touchAngle : 90 - v > n.touchAngle;
				}
			}
			if (a.isScrolling) r.emit("touchMoveOpposite", l);
			if (typeof a.startMoving === "undefined") if (i.currentX !== i.startX || i.currentY !== i.startY) a.startMoving = true;
			if (a.isScrolling) {
				a.isTouched = false;
				return;
			}
			if (!a.startMoving) return;
			r.allowClick = false;
			if (!n.cssMode && l.cancelable) l.preventDefault();
			if (n.touchMoveStopPropagation && !n.nested) l.stopPropagation();
			if (!a.isMoved) {
				if (n.loop && !n.cssMode) r.loopFix();
				a.startTranslate = r.getTranslate();
				r.setTransition(0);
				if (r.animating) r.$wrapperEl.trigger("webkitTransitionEnd transitionend");
				a.allowMomentumBounce = false;
				if (n.grabCursor && (r.allowSlideNext === true || r.allowSlidePrev === true)) r.setGrabCursor(true);
				r.emit("sliderFirstMove", l);
			}
			r.emit("sliderMove", l);
			a.isMoved = true;
			var h = r.isHorizontal() ? d : p;
			i.diff = h;
			h *= n.touchRatio;
			if (s) h = -h;
			r.swipeDirection = h > 0 ? "prev" : "next";
			a.currentTranslate = h + a.startTranslate;
			var m = true;
			var g = n.resistanceRatio;
			if (n.touchReleaseOnEdges) g = 0;
			if (h > 0 && a.currentTranslate > r.minTranslate()) {
				m = false;
				if (n.resistance) a.currentTranslate = r.minTranslate() - 1 + Math.pow(-r.minTranslate() + a.startTranslate + h, g);
			} else if (h < 0 && a.currentTranslate < r.maxTranslate()) {
				m = false;
				if (n.resistance) a.currentTranslate = r.maxTranslate() + 1 - Math.pow(r.maxTranslate() - a.startTranslate - h, g);
			}
			if (m) l.preventedByNestedSwiper = true;
			if (!r.allowSlideNext && r.swipeDirection === "next" && a.currentTranslate < a.startTranslate) a.currentTranslate = a.startTranslate;
			if (!r.allowSlidePrev && r.swipeDirection === "prev" && a.currentTranslate > a.startTranslate) a.currentTranslate = a.startTranslate;
			if (!r.allowSlidePrev && !r.allowSlideNext) a.currentTranslate = a.startTranslate;
			if (n.threshold > 0)
				if (Math.abs(h) > n.threshold || a.allowThresholdMove) {
					if (!a.allowThresholdMove) {
						a.allowThresholdMove = true;
						i.startX = i.currentX;
						i.startY = i.currentY;
						a.currentTranslate = a.startTranslate;
						i.diff = r.isHorizontal() ? i.currentX - i.startX : i.currentY - i.startY;
						return;
					}
				} else {
					a.currentTranslate = a.startTranslate;
					return;
				}
			if (!n.followFinger || n.cssMode) return;
			if ((n.freeMode && n.freeMode.enabled && r.freeMode) || n.watchSlidesProgress) {
				r.updateActiveIndex();
				r.updateSlidesClasses();
			}
			if (r.params.freeMode && n.freeMode.enabled && r.freeMode) r.freeMode.onTouchMove();
			r.updateProgress(a.currentTranslate);
			r.setTranslate(a.currentTranslate);
		}
		function Us(e) {
			var t = this;
			var r = t.touchEventsData;
			var a = t.params,
				n = t.touches,
				i = t.rtlTranslate,
				s = t.slidesGrid,
				o = t.enabled;
			if (!o) return;
			var l = e;
			if (l.originalEvent) l = l.originalEvent;
			if (r.allowTouchCallbacks) t.emit("touchEnd", l);
			r.allowTouchCallbacks = false;
			if (!r.isTouched) {
				if (r.isMoved && a.grabCursor) t.setGrabCursor(false);
				r.isMoved = false;
				r.startMoving = false;
				return;
			}
			if (a.grabCursor && r.isMoved && r.isTouched && (t.allowSlideNext === true || t.allowSlidePrev === true)) t.setGrabCursor(false);
			var f = Mi();
			var u = f - r.touchStartTime;
			if (t.allowClick) {
				var c = l.path || (l.composedPath && l.composedPath());
				t.updateClickedSlide((c && c[0]) || l.target);
				t.emit("tap click", l);
				if (u < 300 && f - r.lastClickTime < 300) t.emit("doubleTap doubleClick", l);
			}
			r.lastClickTime = Mi();
			Ci(function () {
				if (!t.destroyed) t.allowClick = true;
			});
			if (!r.isTouched || !r.isMoved || !t.swipeDirection || n.diff === 0 || r.currentTranslate === r.startTranslate) {
				r.isTouched = false;
				r.isMoved = false;
				r.startMoving = false;
				return;
			}
			r.isTouched = false;
			r.isMoved = false;
			r.startMoving = false;
			var d;
			if (a.followFinger) d = i ? t.translate : -t.translate;
			else d = -r.currentTranslate;
			if (a.cssMode) return;
			if (t.params.freeMode && a.freeMode.enabled) {
				t.freeMode.onTouchEnd({ currentPos: d });
				return;
			}
			var p = 0;
			var v = t.slidesSizesGrid[0];
			for (var h = 0; h < s.length; h += h < a.slidesPerGroupSkip ? 1 : a.slidesPerGroup) {
				var m = h < a.slidesPerGroupSkip - 1 ? 1 : a.slidesPerGroup;
				if (typeof s[h + m] !== "undefined") {
					if (d >= s[h] && d < s[h + m]) {
						p = h;
						v = s[h + m] - s[h];
					}
				} else if (d >= s[h]) {
					p = h;
					v = s[s.length - 1] - s[s.length - 2];
				}
			}
			var g = null;
			var y = null;
			if (a.rewind)
				if (t.isBeginning) y = t.params.virtual && t.params.virtual.enabled && t.virtual ? t.virtual.slides.length - 1 : t.slides.length - 1;
				else if (t.isEnd) g = 0;
			var b = (d - s[p]) / v;
			var w = p < a.slidesPerGroupSkip - 1 ? 1 : a.slidesPerGroup;
			if (u > a.longSwipesMs) {
				if (!a.longSwipes) {
					t.slideTo(t.activeIndex);
					return;
				}
				if (t.swipeDirection === "next")
					if (b >= a.longSwipesRatio) t.slideTo(a.rewind && t.isEnd ? g : p + w);
					else t.slideTo(p);
				if (t.swipeDirection === "prev")
					if (b > 1 - a.longSwipesRatio) t.slideTo(p + w);
					else if (y !== null && b < 0 && Math.abs(b) > a.longSwipesRatio) t.slideTo(y);
					else t.slideTo(p);
			} else {
				if (!a.shortSwipes) {
					t.slideTo(t.activeIndex);
					return;
				}
				var S = t.navigation && (l.target === t.navigation.nextEl || l.target === t.navigation.prevEl);
				if (!S) {
					if (t.swipeDirection === "next") t.slideTo(g !== null ? g : p + w);
					if (t.swipeDirection === "prev") t.slideTo(y !== null ? y : p);
				} else if (l.target === t.navigation.nextEl) t.slideTo(p + w);
				else t.slideTo(p);
			}
		}
		function Ks() {
			var e = this;
			var t = e.params,
				r = e.el;
			if (r && r.offsetWidth === 0) return;
			if (t.breakpoints) e.setBreakpoint();
			var a = e.allowSlideNext,
				n = e.allowSlidePrev,
				i = e.snapGrid;
			e.allowSlideNext = true;
			e.allowSlidePrev = true;
			e.updateSize();
			e.updateSlides();
			e.updateSlidesClasses();
			if ((t.slidesPerView === "auto" || t.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides) e.slideTo(e.slides.length - 1, 0, false, true);
			else e.slideTo(e.activeIndex, 0, false, true);
			if (e.autoplay && e.autoplay.running && e.autoplay.paused) e.autoplay.run();
			e.allowSlidePrev = n;
			e.allowSlideNext = a;
			if (e.params.watchOverflow && i !== e.snapGrid) e.checkOverflow();
		}
		function Zs(e) {
			var t = this;
			if (!t.enabled) return;
			if (!t.allowClick) {
				if (t.params.preventClicks) e.preventDefault();
				if (t.params.preventClicksPropagation && t.animating) {
					e.stopPropagation();
					e.stopImmediatePropagation();
				}
			}
		}
		function Qs() {
			var e = this;
			var t = e.wrapperEl,
				r = e.rtlTranslate,
				a = e.enabled;
			if (!a) return;
			e.previousTranslate = e.translate;
			if (e.isHorizontal()) e.translate = -t.scrollLeft;
			else e.translate = -t.scrollTop;
			if (e.translate === 0) e.translate = 0;
			e.updateActiveIndex();
			e.updateSlidesClasses();
			var n;
			var i = e.maxTranslate() - e.minTranslate();
			if (i === 0) n = 0;
			else n = (e.translate - e.minTranslate()) / i;
			if (n !== e.progress) e.updateProgress(r ? -e.translate : e.translate);
			e.emit("setTranslate", e.translate, false);
		}
		var Js = false;
		function eo() {}
		var to = function e(t, r) {
			var a = ia();
			var n = t.params,
				i = t.touchEvents,
				s = t.el,
				o = t.wrapperEl,
				l = t.device,
				f = t.support;
			var u = !!n.nested;
			var c = r === "on" ? "addEventListener" : "removeEventListener";
			var d = r;
			if (!f.touch) {
				s[c](i.start, t.onTouchStart, false);
				a[c](i.move, t.onTouchMove, u);
				a[c](i.end, t.onTouchEnd, false);
			} else {
				var p = i.start === "touchstart" && f.passiveListener && n.passiveListeners ? { passive: true, capture: false } : false;
				s[c](i.start, t.onTouchStart, p);
				s[c](i.move, t.onTouchMove, f.passiveListener ? { passive: false, capture: u } : u);
				s[c](i.end, t.onTouchEnd, p);
				if (i.cancel) s[c](i.cancel, t.onTouchEnd, p);
			}
			if (n.preventClicks || n.preventClicksPropagation) s[c]("click", t.onClick, true);
			if (n.cssMode) o[c]("scroll", t.onScroll);
			if (n.updateOnWindowResize) t[d](l.ios || l.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", Ks, true);
			else t[d]("observerUpdate", Ks, true);
		};
		function ro() {
			var e = this;
			var t = ia();
			var r = e.params,
				a = e.support;
			e.onTouchStart = Fs.bind(e);
			e.onTouchMove = Ys.bind(e);
			e.onTouchEnd = Us.bind(e);
			if (r.cssMode) e.onScroll = Qs.bind(e);
			e.onClick = Zs.bind(e);
			if (a.touch && !Js) {
				t.addEventListener("touchstart", eo);
				Js = true;
			}
			to(e, "on");
		}
		function ao() {
			var e = this;
			to(e, "off");
		}
		const no = { attachEvents: ro, detachEvents: ao };
		var io = function e(t, r) {
			return t.grid && r.grid && r.grid.rows > 1;
		};
		function so() {
			var e = this;
			var t = e.activeIndex,
				r = e.initialized,
				a = e.loopedSlides,
				n = a === void 0 ? 0 : a,
				i = e.params,
				s = e.$el;
			var o = i.breakpoints;
			if (!o || (o && Object.keys(o).length === 0)) return;
			var l = e.getBreakpoint(o, e.params.breakpointsBase, e.el);
			if (!l || e.currentBreakpoint === l) return;
			var f = l in o ? o[l] : void 0;
			var u = f || e.originalParams;
			var c = io(e, i);
			var d = io(e, u);
			var p = i.enabled;
			if (c && !d) {
				s.removeClass("".concat(i.containerModifierClass, "grid ").concat(i.containerModifierClass, "grid-column"));
				e.emitContainerClasses();
			} else if (!c && d) {
				s.addClass("".concat(i.containerModifierClass, "grid"));
				if ((u.grid.fill && u.grid.fill === "column") || (!u.grid.fill && i.grid.fill === "column")) s.addClass("".concat(i.containerModifierClass, "grid-column"));
				e.emitContainerClasses();
			}
			[
				"navigation",
				"pagination",
				"scrollbar",
			].forEach(function (t) {
				var r = i[t] && i[t].enabled;
				var a = u[t] && u[t].enabled;
				if (r && !a) e[t].disable();
				if (!r && a) e[t].enable();
			});
			var v = u.direction && u.direction !== i.direction;
			var h = i.loop && (u.slidesPerView !== i.slidesPerView || v);
			if (v && r) e.changeDirection();
			Ai(e.params, u);
			var m = e.params.enabled;
			Object.assign(e, { allowTouchMove: e.params.allowTouchMove, allowSlideNext: e.params.allowSlideNext, allowSlidePrev: e.params.allowSlidePrev });
			if (p && !m) e.disable();
			else if (!p && m) e.enable();
			e.currentBreakpoint = l;
			e.emit("_beforeBreakpoint", u);
			if (h && r) {
				e.loopDestroy();
				e.loopCreate();
				e.updateSlides();
				e.slideTo(t - n + e.loopedSlides, 0, false);
			}
			e.emit("breakpoint", u);
		}
		function oo(e) {
			var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "window";
			var r = arguments.length > 2 ? arguments[2] : void 0;
			if (!e || (t === "container" && !r)) return;
			var a = false;
			var n = oa();
			var i = t === "window" ? n.innerHeight : r.clientHeight;
			var s = Object.keys(e).map(function (e) {
				if (typeof e === "string" && e.indexOf("@") === 0) {
					var t = parseFloat(e.substr(1));
					var r = i * t;
					return { value: r, point: e };
				}
				return { value: e, point: e };
			});
			s.sort(function (e, t) {
				return parseInt(e.value, 10) - parseInt(t.value, 10);
			});
			for (var o = 0; o < s.length; o += 1) {
				var l = s[o],
					f = l.point,
					u = l.value;
				if (t === "window") {
					if (n.matchMedia("(min-width: ".concat(u, "px)")).matches) a = f;
				} else if (u <= r.clientWidth) a = f;
			}
			return a || "max";
		}
		const lo = { setBreakpoint: so, getBreakpoint: oo };
		function fo(e) {
			return vo(e) || po(e) || co(e) || uo();
		}
		function uo() {
			throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
		}
		function co(e, t) {
			if (e) {
				if ("string" == typeof e) return ho(e, t);
				var r = {}.toString.call(e).slice(8, -1);
				return ("Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? ho(e, t) : void 0);
			}
		}
		function po(e) {
			if (("undefined" != typeof Symbol && null != e[Symbol.iterator]) || null != e["@@iterator"]) return Array.from(e);
		}
		function vo(e) {
			if (Array.isArray(e)) return ho(e);
		}
		function ho(e, t) {
			(null == t || t > e.length) && (t = e.length);
			for (var r = 0, a = Array(t); r < t; r++) a[r] = e[r];
			return a;
		}
		function mo(e) {
			"@babel/helpers - typeof";
			return (
				(mo =
					"function" == typeof Symbol && "symbol" == typeof Symbol.iterator
						? function (e) {
								return typeof e;
							}
						: function (e) {
								return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
							}),
				mo(e)
			);
		}
		function go(e, t) {
			var r = [];
			e.forEach(function (e) {
				if (mo(e) === "object")
					Object.keys(e).forEach(function (a) {
						if (e[a]) r.push(t + a);
					});
				else if (typeof e === "string") r.push(t + e);
			});
			return r;
		}
		function yo() {
			var e = this;
			var t = e.classNames,
				r = e.params,
				a = e.rtl,
				n = e.$el,
				i = e.device,
				s = e.support;
			var o = go(
				[
					"initialized",
					r.direction,
					{ "pointer-events": !s.touch },
					{ "free-mode": e.params.freeMode && r.freeMode.enabled },
					{ autoheight: r.autoHeight },
					{ rtl: a },
					{ grid: r.grid && r.grid.rows > 1 },
					{ "grid-column": r.grid && r.grid.rows > 1 && r.grid.fill === "column" },
					{ android: i.android },
					{ ios: i.ios },
					{ "css-mode": r.cssMode },
					{ centered: r.cssMode && r.centeredSlides },
					{ "watch-progress": r.watchSlidesProgress },
				],
				r.containerModifierClass,
			);
			t.push.apply(t, fo(o));
			n.addClass(fo(t).join(" "));
			e.emitContainerClasses();
		}
		function bo() {
			var e = this;
			var t = e.$el,
				r = e.classNames;
			t.removeClass(r.join(" "));
			e.emitContainerClasses();
		}
		const wo = { addClasses: yo, removeClasses: bo };
		function So(e, t, r, a, n, i) {
			var s = oa();
			var o;
			function l() {
				if (i) i();
			}
			var f = bi(e).parent("picture")[0];
			if (!f && (!e.complete || !n))
				if (t) {
					o = new s.Image();
					o.onload = l;
					o.onerror = l;
					if (a) o.sizes = a;
					if (r) o.srcset = r;
					if (t) o.src = t;
				} else l();
			else l();
		}
		function Eo() {
			var e = this;
			e.imagesToLoad = e.$el.find("img");
			function t() {
				if (typeof e === "undefined" || e === null || !e || e.destroyed) return;
				if (e.imagesLoaded !== void 0) e.imagesLoaded += 1;
				if (e.imagesLoaded === e.imagesToLoad.length) {
					if (e.params.updateOnImagesReady) e.update();
					e.emit("imagesReady");
				}
			}
			for (var r = 0; r < e.imagesToLoad.length; r += 1) {
				var a = e.imagesToLoad[r];
				e.loadImage(a, a.currentSrc || a.getAttribute("src"), a.srcset || a.getAttribute("srcset"), a.sizes || a.getAttribute("sizes"), true, t);
			}
		}
		const xo = { loadImage: So, preloadImages: Eo };
		function To() {
			var e = this;
			var t = e.isLocked,
				r = e.params;
			var a = r.slidesOffsetBefore;
			if (a) {
				var n = e.slides.length - 1;
				var i = e.slidesGrid[n] + e.slidesSizesGrid[n] + a * 2;
				e.isLocked = e.size > i;
			} else e.isLocked = e.snapGrid.length === 1;
			if (r.allowSlideNext === true) e.allowSlideNext = !e.isLocked;
			if (r.allowSlidePrev === true) e.allowSlidePrev = !e.isLocked;
			if (t && t !== e.isLocked) e.isEnd = false;
			if (t !== e.isLocked) e.emit(e.isLocked ? "lock" : "unlock");
		}
		const Co = { checkOverflow: To };
		const Mo = {
			init: true,
			direction: "horizontal",
			touchEventsTarget: "wrapper",
			initialSlide: 0,
			speed: 300,
			cssMode: false,
			updateOnWindowResize: true,
			resizeObserver: true,
			nested: false,
			createElements: false,
			enabled: true,
			focusableElements: "input, select, option, textarea, button, video, label",
			width: null,
			height: null,
			preventInteractionOnTransition: false,
			userAgent: null,
			url: null,
			edgeSwipeDetection: false,
			edgeSwipeThreshold: 20,
			autoHeight: false,
			setWrapperSize: false,
			virtualTranslate: false,
			effect: "slide",
			breakpoints: void 0,
			breakpointsBase: "window",
			spaceBetween: 0,
			slidesPerView: 1,
			slidesPerGroup: 1,
			slidesPerGroupSkip: 0,
			slidesPerGroupAuto: false,
			centeredSlides: false,
			centeredSlidesBounds: false,
			slidesOffsetBefore: 0,
			slidesOffsetAfter: 0,
			normalizeSlideIndex: true,
			centerInsufficientSlides: false,
			watchOverflow: true,
			roundLengths: false,
			touchRatio: 1,
			touchAngle: 45,
			simulateTouch: true,
			shortSwipes: true,
			longSwipes: true,
			longSwipesRatio: 0.5,
			longSwipesMs: 300,
			followFinger: true,
			allowTouchMove: true,
			threshold: 0,
			touchMoveStopPropagation: false,
			touchStartPreventDefault: true,
			touchStartForcePreventDefault: false,
			touchReleaseOnEdges: false,
			uniqueNavElements: true,
			resistance: true,
			resistanceRatio: 0.85,
			watchSlidesProgress: false,
			grabCursor: false,
			preventClicks: true,
			preventClicksPropagation: true,
			slideToClickedSlide: false,
			preloadImages: true,
			updateOnImagesReady: true,
			loop: false,
			loopAdditionalSlides: 0,
			loopedSlides: null,
			loopedSlidesLimit: true,
			loopFillGroupWithBlank: false,
			loopPreventsSlide: true,
			rewind: false,
			allowSlidePrev: true,
			allowSlideNext: true,
			swipeHandler: null,
			noSwiping: true,
			noSwipingClass: "swiper-no-swiping",
			noSwipingSelector: null,
			passiveListeners: true,
			maxBackfaceHiddenSlides: 10,
			containerModifierClass: "swiper-",
			slideClass: "swiper-slide",
			slideBlankClass: "swiper-slide-invisible-blank",
			slideActiveClass: "swiper-slide-active",
			slideDuplicateActiveClass: "swiper-slide-duplicate-active",
			slideVisibleClass: "swiper-slide-visible",
			slideDuplicateClass: "swiper-slide-duplicate",
			slideNextClass: "swiper-slide-next",
			slideDuplicateNextClass: "swiper-slide-duplicate-next",
			slidePrevClass: "swiper-slide-prev",
			slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
			wrapperClass: "swiper-wrapper",
			runCallbacksOnInit: true,
			_emitClasses: false,
		};
		function Po(e) {
			"@babel/helpers - typeof";
			return (
				(Po =
					"function" == typeof Symbol && "symbol" == typeof Symbol.iterator
						? function (e) {
								return typeof e;
							}
						: function (e) {
								return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
							}),
				Po(e)
			);
		}
		function Oo(e, t) {
			return function r() {
				var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
				var n = Object.keys(a)[0];
				var i = a[n];
				if (Po(i) !== "object" || i === null) {
					Ai(t, a);
					return;
				}
				if (
					[
						"navigation",
						"pagination",
						"scrollbar",
					].indexOf(n) >= 0 &&
					e[n] === true
				)
					e[n] = { auto: true };
				if (!(n in e && "enabled" in i)) {
					Ai(t, a);
					return;
				}
				if (e[n] === true) e[n] = { enabled: true };
				if (Po(e[n]) === "object" && !("enabled" in e[n])) e[n].enabled = true;
				if (!e[n]) e[n] = { enabled: false };
				Ai(t, a);
			};
		}
		function ko(e) {
			"@babel/helpers - typeof";
			return (
				(ko =
					"function" == typeof Symbol && "symbol" == typeof Symbol.iterator
						? function (e) {
								return typeof e;
							}
						: function (e) {
								return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
							}),
				ko(e)
			);
		}
		function $o(e) {
			return Lo(e) || zo(e) || Io(e) || Ao();
		}
		function Ao() {
			throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
		}
		function Io(e, t) {
			if (e) {
				if ("string" == typeof e) return Do(e, t);
				var r = {}.toString.call(e).slice(8, -1);
				return ("Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Do(e, t) : void 0);
			}
		}
		function zo(e) {
			if (("undefined" != typeof Symbol && null != e[Symbol.iterator]) || null != e["@@iterator"]) return Array.from(e);
		}
		function Lo(e) {
			if (Array.isArray(e)) return Do(e);
		}
		function Do(e, t) {
			(null == t || t > e.length) && (t = e.length);
			for (var r = 0, a = Array(t); r < t; r++) a[r] = e[r];
			return a;
		}
		function jo(e, t) {
			if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
		}
		function _o(e, t) {
			for (var r = 0; r < t.length; r++) {
				var a = t[r];
				((a.enumerable = a.enumerable || !1), (a.configurable = !0), "value" in a && (a.writable = !0), Object.defineProperty(e, Bo(a.key), a));
			}
		}
		function No(e, t, r) {
			return (t && _o(e.prototype, t), r && _o(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e);
		}
		function Bo(e) {
			var t = Ho(e, "string");
			return "symbol" == ko(t) ? t : t + "";
		}
		function Ho(e, t) {
			if ("object" != ko(e) || !e) return e;
			var r = e[Symbol.toPrimitive];
			if (void 0 !== r) {
				var a = r.call(e, t || "default");
				if ("object" != ko(a)) return a;
				throw new TypeError("@@toPrimitive must return a primitive value.");
			}
			return ("string" === t ? String : Number)(e);
		}
		var Wo = { eventsEmitter: Zi, update: cs, translate: Ss, transition: Ms, slide: Ns, loop: Rs, grabCursor: Vs, events: no, breakpoints: lo, checkOverflow: Co, classes: wo, images: xo };
		var Ro = {};
		var Go = (function () {
			function e() {
				jo(this, e);
				var t;
				var r;
				for (var a = arguments.length, n = new Array(a), i = 0; i < a; i++) n[i] = arguments[i];
				if (n.length === 1 && n[0].constructor && Object.prototype.toString.call(n[0]).slice(8, -1) === "Object") r = n[0];
				else {
					t = n[0];
					r = n[1];
				}
				if (!r) r = {};
				r = Ai({}, r);
				if (t && !r.el) r.el = t;
				if (r.el && bi(r.el).length > 1) {
					var s = [];
					bi(r.el).each(function (t) {
						var a = Ai({}, r, { el: t });
						s.push(new e(a));
					});
					return s;
				}
				var o = this;
				o.__swiper__ = true;
				o.support = ji();
				o.device = Bi({ userAgent: r.userAgent });
				o.browser = Ri();
				o.eventsListeners = {};
				o.eventsAnyListeners = [];
				o.modules = $o(o.__modules__);
				if (r.modules && Array.isArray(r.modules)) {
					var l;
					(l = o.modules).push.apply(l, $o(r.modules));
				}
				var f = {};
				o.modules.forEach(function (e) {
					e({ swiper: o, extendParams: Oo(r, f), on: o.on.bind(o), once: o.once.bind(o), off: o.off.bind(o), emit: o.emit.bind(o) });
				});
				var u = Ai({}, Mo, f);
				o.params = Ai({}, u, Ro, r);
				o.originalParams = Ai({}, o.params);
				o.passedParams = Ai({}, r);
				if (o.params && o.params.on)
					Object.keys(o.params.on).forEach(function (e) {
						o.on(e, o.params.on[e]);
					});
				if (o.params && o.params.onAny) o.onAny(o.params.onAny);
				o.$ = bi;
				Object.assign(o, {
					enabled: o.params.enabled,
					el: t,
					classNames: [],
					slides: bi(),
					slidesGrid: [],
					snapGrid: [],
					slidesSizesGrid: [],
					isHorizontal: function e() {
						return o.params.direction === "horizontal";
					},
					isVertical: function e() {
						return o.params.direction === "vertical";
					},
					activeIndex: 0,
					realIndex: 0,
					isBeginning: true,
					isEnd: false,
					translate: 0,
					previousTranslate: 0,
					progress: 0,
					velocity: 0,
					animating: false,
					allowSlideNext: o.params.allowSlideNext,
					allowSlidePrev: o.params.allowSlidePrev,
					touchEvents: (function e() {
						var t = [
							"touchstart",
							"touchmove",
							"touchend",
							"touchcancel",
						];
						var r = [
							"pointerdown",
							"pointermove",
							"pointerup",
						];
						o.touchEventsTouch = { start: t[0], move: t[1], end: t[2], cancel: t[3] };
						o.touchEventsDesktop = { start: r[0], move: r[1], end: r[2] };
						return o.support.touch || !o.params.simulateTouch ? o.touchEventsTouch : o.touchEventsDesktop;
					})(),
					touchEventsData: { isTouched: void 0, isMoved: void 0, allowTouchCallbacks: void 0, touchStartTime: void 0, isScrolling: void 0, currentTranslate: void 0, startTranslate: void 0, allowThresholdMove: void 0, focusableElements: o.params.focusableElements, lastClickTime: Mi(), clickTimeout: void 0, velocities: [], allowMomentumBounce: void 0, isTouchEvent: void 0, startMoving: void 0 },
					allowClick: true,
					allowTouchMove: o.params.allowTouchMove,
					touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 },
					imagesToLoad: [],
					imagesLoaded: 0,
				});
				o.emit("_swiper");
				if (o.params.init) o.init();
				return o;
			}
			return No(
				e,
				[
					{
						key: "enable",
						value: function e() {
							var t = this;
							if (t.enabled) return;
							t.enabled = true;
							if (t.params.grabCursor) t.setGrabCursor();
							t.emit("enable");
						},
					},
					{
						key: "disable",
						value: function e() {
							var t = this;
							if (!t.enabled) return;
							t.enabled = false;
							if (t.params.grabCursor) t.unsetGrabCursor();
							t.emit("disable");
						},
					},
					{
						key: "setProgress",
						value: function e(t, r) {
							var a = this;
							t = Math.min(Math.max(t, 0), 1);
							var n = a.minTranslate();
							var i = a.maxTranslate();
							var s = (i - n) * t + n;
							a.translateTo(s, typeof r === "undefined" ? 0 : r);
							a.updateActiveIndex();
							a.updateSlidesClasses();
						},
					},
					{
						key: "emitContainerClasses",
						value: function e() {
							var t = this;
							if (!t.params._emitClasses || !t.el) return;
							var r = t.el.className.split(" ").filter(function (e) {
								return e.indexOf("swiper") === 0 || e.indexOf(t.params.containerModifierClass) === 0;
							});
							t.emit("_containerClasses", r.join(" "));
						},
					},
					{
						key: "getSlideClasses",
						value: function e(t) {
							var r = this;
							if (r.destroyed) return "";
							return t.className
								.split(" ")
								.filter(function (e) {
									return e.indexOf("swiper-slide") === 0 || e.indexOf(r.params.slideClass) === 0;
								})
								.join(" ");
						},
					},
					{
						key: "emitSlidesClasses",
						value: function e() {
							var t = this;
							if (!t.params._emitClasses || !t.el) return;
							var r = [];
							t.slides.each(function (e) {
								var a = t.getSlideClasses(e);
								r.push({ slideEl: e, classNames: a });
								t.emit("_slideClass", e, a);
							});
							t.emit("_slideClasses", r);
						},
					},
					{
						key: "slidesPerViewDynamic",
						value: function e() {
							var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "current";
							var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
							var a = this;
							var n = a.params,
								i = a.slides,
								s = a.slidesGrid,
								o = a.slidesSizesGrid,
								l = a.size,
								f = a.activeIndex;
							var u = 1;
							if (n.centeredSlides) {
								var c = i[f].swiperSlideSize;
								var d;
								for (var p = f + 1; p < i.length; p += 1)
									if (i[p] && !d) {
										c += i[p].swiperSlideSize;
										u += 1;
										if (c > l) d = true;
									}
								for (var v = f - 1; v >= 0; v -= 1)
									if (i[v] && !d) {
										c += i[v].swiperSlideSize;
										u += 1;
										if (c > l) d = true;
									}
							} else if (t === "current")
								for (var h = f + 1; h < i.length; h += 1) {
									var m = r ? s[h] + o[h] - s[f] < l : s[h] - s[f] < l;
									if (m) u += 1;
								}
							else
								for (var g = f - 1; g >= 0; g -= 1) {
									var y = s[f] - s[g] < l;
									if (y) u += 1;
								}
							return u;
						},
					},
					{
						key: "update",
						value: function e() {
							var t = this;
							if (!t || t.destroyed) return;
							var r = t.snapGrid,
								a = t.params;
							if (a.breakpoints) t.setBreakpoint();
							t.updateSize();
							t.updateSlides();
							t.updateProgress();
							t.updateSlidesClasses();
							function n() {
								var e = t.rtlTranslate ? t.translate * -1 : t.translate;
								var r = Math.min(Math.max(e, t.maxTranslate()), t.minTranslate());
								t.setTranslate(r);
								t.updateActiveIndex();
								t.updateSlidesClasses();
							}
							var i;
							if (t.params.freeMode && t.params.freeMode.enabled) {
								n();
								if (t.params.autoHeight) t.updateAutoHeight();
							} else {
								if ((t.params.slidesPerView === "auto" || t.params.slidesPerView > 1) && t.isEnd && !t.params.centeredSlides) i = t.slideTo(t.slides.length - 1, 0, false, true);
								else i = t.slideTo(t.activeIndex, 0, false, true);
								if (!i) n();
							}
							if (a.watchOverflow && r !== t.snapGrid) t.checkOverflow();
							t.emit("update");
						},
					},
					{
						key: "changeDirection",
						value: function e(t) {
							var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
							var a = this;
							var n = a.params.direction;
							if (!t) t = n === "horizontal" ? "vertical" : "horizontal";
							if (t === n || (t !== "horizontal" && t !== "vertical")) return a;
							a.$el.removeClass("".concat(a.params.containerModifierClass).concat(n)).addClass("".concat(a.params.containerModifierClass).concat(t));
							a.emitContainerClasses();
							a.params.direction = t;
							a.slides.each(function (e) {
								if (t === "vertical") e.style.width = "";
								else e.style.height = "";
							});
							a.emit("changeDirection");
							if (r) a.update();
							return a;
						},
					},
					{
						key: "changeLanguageDirection",
						value: function e(t) {
							var r = this;
							if ((r.rtl && t === "rtl") || (!r.rtl && t === "ltr")) return;
							r.rtl = t === "rtl";
							r.rtlTranslate = r.params.direction === "horizontal" && r.rtl;
							if (r.rtl) {
								r.$el.addClass("".concat(r.params.containerModifierClass, "rtl"));
								r.el.dir = "rtl";
							} else {
								r.$el.removeClass("".concat(r.params.containerModifierClass, "rtl"));
								r.el.dir = "ltr";
							}
							r.update();
						},
					},
					{
						key: "mount",
						value: function e(t) {
							var r = this;
							if (r.mounted) return true;
							var a = bi(t || r.params.el);
							t = a[0];
							if (!t) return false;
							t.swiper = r;
							var n = function e() {
								return ".".concat((r.params.wrapperClass || "").trim().split(" ").join("."));
							};
							var i = function e() {
								if (t && t.shadowRoot && t.shadowRoot.querySelector) {
									var r = bi(t.shadowRoot.querySelector(n()));
									r.children = function (e) {
										return a.children(e);
									};
									return r;
								}
								if (!a.children) return bi(a).children(n());
								return a.children(n());
							};
							var s = i();
							if (s.length === 0 && r.params.createElements) {
								var o = ia();
								var l = o.createElement("div");
								s = bi(l);
								l.className = r.params.wrapperClass;
								a.append(l);
								a.children(".".concat(r.params.slideClass)).each(function (e) {
									s.append(e);
								});
							}
							Object.assign(r, { $el: a, el: t, $wrapperEl: s, wrapperEl: s[0], mounted: true, rtl: t.dir.toLowerCase() === "rtl" || a.css("direction") === "rtl", rtlTranslate: r.params.direction === "horizontal" && (t.dir.toLowerCase() === "rtl" || a.css("direction") === "rtl"), wrongRTL: s.css("display") === "-webkit-box" });
							return true;
						},
					},
					{
						key: "init",
						value: function e(t) {
							var r = this;
							if (r.initialized) return r;
							var a = r.mount(t);
							if (a === false) return r;
							r.emit("beforeInit");
							if (r.params.breakpoints) r.setBreakpoint();
							r.addClasses();
							if (r.params.loop) r.loopCreate();
							r.updateSize();
							r.updateSlides();
							if (r.params.watchOverflow) r.checkOverflow();
							if (r.params.grabCursor && r.enabled) r.setGrabCursor();
							if (r.params.preloadImages) r.preloadImages();
							if (r.params.loop) r.slideTo(r.params.initialSlide + r.loopedSlides, 0, r.params.runCallbacksOnInit, false, true);
							else r.slideTo(r.params.initialSlide, 0, r.params.runCallbacksOnInit, false, true);
							r.attachEvents();
							r.initialized = true;
							r.emit("init");
							r.emit("afterInit");
							return r;
						},
					},
					{
						key: "destroy",
						value: function e() {
							var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
							var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
							var a = this;
							var n = a.params,
								i = a.$el,
								s = a.$wrapperEl,
								o = a.slides;
							if (typeof a.params === "undefined" || a.destroyed) return null;
							a.emit("beforeDestroy");
							a.initialized = false;
							a.detachEvents();
							if (n.loop) a.loopDestroy();
							if (r) {
								a.removeClasses();
								i.removeAttr("style");
								s.removeAttr("style");
								if (o && o.length)
									o.removeClass(
										[
											n.slideVisibleClass,
											n.slideActiveClass,
											n.slideNextClass,
											n.slidePrevClass,
										].join(" "),
									)
										.removeAttr("style")
										.removeAttr("data-swiper-slide-index");
							}
							a.emit("destroy");
							Object.keys(a.eventsListeners).forEach(function (e) {
								a.off(e);
							});
							if (t !== false) {
								a.$el[0].swiper = null;
								Ti(a);
							}
							a.destroyed = true;
							return null;
						},
					},
				],
				[
					{
						key: "extendDefaults",
						value: function e(t) {
							Ai(Ro, t);
						},
					},
					{
						key: "extendedDefaults",
						get: function e() {
							return Ro;
						},
					},
					{
						key: "defaults",
						get: function e() {
							return Mo;
						},
					},
					{
						key: "installModule",
						value: function t(r) {
							if (!e.prototype.__modules__) e.prototype.__modules__ = [];
							var a = e.prototype.__modules__;
							if (typeof r === "function" && a.indexOf(r) < 0) a.push(r);
						},
					},
					{
						key: "use",
						value: function t(r) {
							if (Array.isArray(r)) {
								r.forEach(function (t) {
									return e.installModule(t);
								});
								return e;
							}
							e.installModule(r);
							return e;
						},
					},
				],
			);
		})();
		Object.keys(Wo).forEach(function (e) {
			Object.keys(Wo[e]).forEach(function (t) {
				Go.prototype[t] = Wo[e][t];
			});
		});
		Go.use([
			Gi,
			qi,
		]);
		const qo = Go;
		function Vo(e) {
			"@babel/helpers - typeof";
			return (
				(Vo =
					"function" == typeof Symbol && "symbol" == typeof Symbol.iterator
						? function (e) {
								return typeof e;
							}
						: function (e) {
								return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
							}),
				Vo(e)
			);
		}
		function Xo(e) {
			var t = e.swiper,
				r = e.extendParams,
				a = e.on,
				n = e.emit;
			r({ virtual: { enabled: false, slides: [], cache: true, renderSlide: null, renderExternal: null, renderExternalUpdate: true, addSlidesBefore: 0, addSlidesAfter: 0 } });
			var i;
			t.virtual = { cache: {}, from: void 0, to: void 0, slides: [], offset: 0, slidesGrid: [] };
			function s(e, r) {
				var a = t.params.virtual;
				if (a.cache && t.virtual.cache[r]) return t.virtual.cache[r];
				var n = a.renderSlide ? $(a.renderSlide.call(t, e, r)) : $('<div class="'.concat(t.params.slideClass, '" data-swiper-slide-index="').concat(r, '">').concat(e, "</div>"));
				if (!n.attr("data-swiper-slide-index")) n.attr("data-swiper-slide-index", r);
				if (a.cache) t.virtual.cache[r] = n;
				return n;
			}
			function o(e) {
				var r = t.params,
					a = r.slidesPerView,
					i = r.slidesPerGroup,
					o = r.centeredSlides;
				var l = t.params.virtual,
					f = l.addSlidesBefore,
					u = l.addSlidesAfter;
				var c = t.virtual,
					d = c.from,
					p = c.to,
					v = c.slides,
					h = c.slidesGrid,
					m = c.offset;
				if (!t.params.cssMode) t.updateActiveIndex();
				var g = t.activeIndex || 0;
				var y;
				if (t.rtlTranslate) y = "right";
				else y = t.isHorizontal() ? "left" : "top";
				var b;
				var w;
				if (o) {
					b = Math.floor(a / 2) + i + u;
					w = Math.floor(a / 2) + i + f;
				} else {
					b = a + (i - 1) + u;
					w = i + f;
				}
				var S = Math.max((g || 0) - w, 0);
				var E = Math.min((g || 0) + b, v.length - 1);
				var x = (t.slidesGrid[S] || 0) - (t.slidesGrid[0] || 0);
				Object.assign(t.virtual, { from: S, to: E, offset: x, slidesGrid: t.slidesGrid });
				function T() {
					t.updateSlides();
					t.updateProgress();
					t.updateSlidesClasses();
					if (t.lazy && t.params.lazy.enabled) t.lazy.load();
					n("virtualUpdate");
				}
				if (d === S && p === E && !e) {
					if (t.slidesGrid !== h && x !== m) t.slides.css(y, "".concat(x, "px"));
					t.updateProgress();
					n("virtualUpdate");
					return;
				}
				if (t.params.virtual.renderExternal) {
					t.params.virtual.renderExternal.call(t, {
						offset: x,
						from: S,
						to: E,
						slides: (function e() {
							var t = [];
							for (var r = S; r <= E; r += 1) t.push(v[r]);
							return t;
						})(),
					});
					if (t.params.virtual.renderExternalUpdate) T();
					else n("virtualUpdate");
					return;
				}
				var C = [];
				var M = [];
				if (e) t.$wrapperEl.find(".".concat(t.params.slideClass)).remove();
				else for (var P = d; P <= p; P += 1) if (P < S || P > E) t.$wrapperEl.find(".".concat(t.params.slideClass, '[data-swiper-slide-index="').concat(P, '"]')).remove();
				for (var O = 0; O < v.length; O += 1)
					if (O >= S && O <= E)
						if (typeof p === "undefined" || e) M.push(O);
						else {
							if (O > p) M.push(O);
							if (O < d) C.push(O);
						}
				M.forEach(function (e) {
					t.$wrapperEl.append(s(v[e], e));
				});
				C.sort(function (e, t) {
					return t - e;
				}).forEach(function (e) {
					t.$wrapperEl.prepend(s(v[e], e));
				});
				t.$wrapperEl.children(".swiper-slide").css(y, "".concat(x, "px"));
				T();
			}
			function l(e) {
				if (Vo(e) === "object" && "length" in e) {
					for (var r = 0; r < e.length; r += 1) if (e[r]) t.virtual.slides.push(e[r]);
				} else t.virtual.slides.push(e);
				o(true);
			}
			function f(e) {
				var r = t.activeIndex;
				var a = r + 1;
				var n = 1;
				if (Array.isArray(e)) {
					for (var i = 0; i < e.length; i += 1) if (e[i]) t.virtual.slides.unshift(e[i]);
					a = r + e.length;
					n = e.length;
				} else t.virtual.slides.unshift(e);
				if (t.params.virtual.cache) {
					var s = t.virtual.cache;
					var l = {};
					Object.keys(s).forEach(function (e) {
						var t = s[e];
						var r = t.attr("data-swiper-slide-index");
						if (r) t.attr("data-swiper-slide-index", parseInt(r, 10) + n);
						l[parseInt(e, 10) + n] = t;
					});
					t.virtual.cache = l;
				}
				o(true);
				t.slideTo(a, 0);
			}
			function u(e) {
				if (typeof e === "undefined" || e === null) return;
				var r = t.activeIndex;
				if (Array.isArray(e))
					for (var a = e.length - 1; a >= 0; a -= 1) {
						t.virtual.slides.splice(e[a], 1);
						if (t.params.virtual.cache) delete t.virtual.cache[e[a]];
						if (e[a] < r) r -= 1;
						r = Math.max(r, 0);
					}
				else {
					t.virtual.slides.splice(e, 1);
					if (t.params.virtual.cache) delete t.virtual.cache[e];
					if (e < r) r -= 1;
					r = Math.max(r, 0);
				}
				o(true);
				t.slideTo(r, 0);
			}
			function c() {
				t.virtual.slides = [];
				if (t.params.virtual.cache) t.virtual.cache = {};
				o(true);
				t.slideTo(0, 0);
			}
			a("beforeInit", function () {
				if (!t.params.virtual.enabled) return;
				t.virtual.slides = t.params.virtual.slides;
				t.classNames.push("".concat(t.params.containerModifierClass, "virtual"));
				t.params.watchSlidesProgress = true;
				t.originalParams.watchSlidesProgress = true;
				if (!t.params.initialSlide) o();
			});
			a("setTranslate", function () {
				if (!t.params.virtual.enabled) return;
				if (t.params.cssMode && !t._immediateVirtual) {
					clearTimeout(i);
					i = setTimeout(function () {
						o();
					}, 100);
				} else o();
			});
			a("init update resize", function () {
				if (!t.params.virtual.enabled) return;
				if (t.params.cssMode) setCSSProperty(t.wrapperEl, "--swiper-virtual-size", "".concat(t.virtualSize, "px"));
			});
			Object.assign(t.virtual, { appendSlide: l, prependSlide: f, removeSlide: u, removeAllSlides: c, update: o });
		}
		function Fo(e) {
			var t = e.swiper,
				r = e.extendParams,
				a = e.on,
				n = e.emit;
			var i = getDocument();
			var s = getWindow();
			t.keyboard = { enabled: false };
			r({ keyboard: { enabled: false, onlyInViewport: true, pageUpDown: true } });
			function o(e) {
				if (!t.enabled) return;
				var r = t.rtlTranslate;
				var a = e;
				if (a.originalEvent) a = a.originalEvent;
				var o = a.keyCode || a.charCode;
				var l = t.params.keyboard.pageUpDown;
				var f = l && o === 33;
				var u = l && o === 34;
				var c = o === 37;
				var d = o === 39;
				var p = o === 38;
				var v = o === 40;
				if (!t.allowSlideNext && ((t.isHorizontal() && d) || (t.isVertical() && v) || u)) return false;
				if (!t.allowSlidePrev && ((t.isHorizontal() && c) || (t.isVertical() && p) || f)) return false;
				if (a.shiftKey || a.altKey || a.ctrlKey || a.metaKey) return;
				if (i.activeElement && i.activeElement.nodeName && (i.activeElement.nodeName.toLowerCase() === "input" || i.activeElement.nodeName.toLowerCase() === "textarea")) return;
				if (t.params.keyboard.onlyInViewport && (f || u || c || d || p || v)) {
					var h = false;
					if (t.$el.parents(".".concat(t.params.slideClass)).length > 0 && t.$el.parents(".".concat(t.params.slideActiveClass)).length === 0) return;
					var m = t.$el;
					var g = m[0].clientWidth;
					var y = m[0].clientHeight;
					var b = s.innerWidth;
					var w = s.innerHeight;
					var S = t.$el.offset();
					if (r) S.left -= t.$el[0].scrollLeft;
					var E = [
						[
							S.left,
							S.top,
						],
						[
							S.left + g,
							S.top,
						],
						[
							S.left,
							S.top + y,
						],
						[
							S.left + g,
							S.top + y,
						],
					];
					for (var x = 0; x < E.length; x += 1) {
						var T = E[x];
						if (T[0] >= 0 && T[0] <= b && T[1] >= 0 && T[1] <= w) {
							if (T[0] === 0 && T[1] === 0) continue;
							h = true;
						}
					}
					if (!h) return;
				}
				if (t.isHorizontal()) {
					if (f || u || c || d)
						if (a.preventDefault) a.preventDefault();
						else a.returnValue = false;
					if (((u || d) && !r) || ((f || c) && r)) t.slideNext();
					if (((f || c) && !r) || ((u || d) && r)) t.slidePrev();
				} else {
					if (f || u || p || v)
						if (a.preventDefault) a.preventDefault();
						else a.returnValue = false;
					if (u || v) t.slideNext();
					if (f || p) t.slidePrev();
				}
				n("keyPress", o);
				return;
			}
			function l() {
				if (t.keyboard.enabled) return;
				$(i).on("keydown", o);
				t.keyboard.enabled = true;
			}
			function f() {
				if (!t.keyboard.enabled) return;
				$(i).off("keydown", o);
				t.keyboard.enabled = false;
			}
			a("init", function () {
				if (t.params.keyboard.enabled) l();
			});
			a("destroy", function () {
				if (t.keyboard.enabled) f();
			});
			Object.assign(t.keyboard, { enable: l, disable: f });
		}
		function Yo(e) {
			var t = e.swiper,
				r = e.extendParams,
				a = e.on,
				n = e.emit;
			var i = oa();
			r({ mousewheel: { enabled: false, releaseOnEdges: false, invert: false, forceToAxis: false, sensitivity: 1, eventsTarget: "container", thresholdDelta: null, thresholdTime: null } });
			t.mousewheel = { enabled: false };
			var s;
			var o = Mi();
			var l;
			var f = [];
			function u(e) {
				var t = 10;
				var r = 40;
				var a = 800;
				var n = 0;
				var i = 0;
				var s = 0;
				var o = 0;
				if ("detail" in e) i = e.detail;
				if ("wheelDelta" in e) i = -e.wheelDelta / 120;
				if ("wheelDeltaY" in e) i = -e.wheelDeltaY / 120;
				if ("wheelDeltaX" in e) n = -e.wheelDeltaX / 120;
				if ("axis" in e && e.axis === e.HORIZONTAL_AXIS) {
					n = i;
					i = 0;
				}
				s = n * t;
				o = i * t;
				if ("deltaY" in e) o = e.deltaY;
				if ("deltaX" in e) s = e.deltaX;
				if (e.shiftKey && !s) {
					s = o;
					o = 0;
				}
				if ((s || o) && e.deltaMode)
					if (e.deltaMode === 1) {
						s *= r;
						o *= r;
					} else {
						s *= a;
						o *= a;
					}
				if (s && !n) n = s < 1 ? -1 : 1;
				if (o && !i) i = o < 1 ? -1 : 1;
				return { spinX: n, spinY: i, pixelX: s, pixelY: o };
			}
			function c() {
				if (!t.enabled) return;
				t.mouseEntered = true;
			}
			function d() {
				if (!t.enabled) return;
				t.mouseEntered = false;
			}
			function p(e) {
				if (t.params.mousewheel.thresholdDelta && e.delta < t.params.mousewheel.thresholdDelta) return false;
				if (t.params.mousewheel.thresholdTime && Mi() - o < t.params.mousewheel.thresholdTime) return false;
				if (e.delta >= 6 && Mi() - o < 60) return true;
				if (e.direction < 0) {
					if ((!t.isEnd || t.params.loop) && !t.animating) {
						t.slideNext();
						n("scroll", e.raw);
					}
				} else if ((!t.isBeginning || t.params.loop) && !t.animating) {
					t.slidePrev();
					n("scroll", e.raw);
				}
				o = new i.Date().getTime();
				return false;
			}
			function v(e) {
				var r = t.params.mousewheel;
				if (e.direction < 0) {
					if (t.isEnd && !t.params.loop && r.releaseOnEdges) return true;
				} else if (t.isBeginning && !t.params.loop && r.releaseOnEdges) return true;
				return false;
			}
			function h(e) {
				var r = e;
				var a = true;
				if (!t.enabled) return;
				var i = t.params.mousewheel;
				if (t.params.cssMode) r.preventDefault();
				var o = t.$el;
				if (t.params.mousewheel.eventsTarget !== "container") o = bi(t.params.mousewheel.eventsTarget);
				if (!t.mouseEntered && !o[0].contains(r.target) && !i.releaseOnEdges) return true;
				if (r.originalEvent) r = r.originalEvent;
				var c = 0;
				var d = t.rtlTranslate ? -1 : 1;
				var h = u(r);
				if (i.forceToAxis)
					if (t.isHorizontal())
						if (Math.abs(h.pixelX) > Math.abs(h.pixelY)) c = -h.pixelX * d;
						else return true;
					else if (Math.abs(h.pixelY) > Math.abs(h.pixelX)) c = -h.pixelY;
					else return true;
				else c = Math.abs(h.pixelX) > Math.abs(h.pixelY) ? -h.pixelX * d : -h.pixelY;
				if (c === 0) return true;
				if (i.invert) c = -c;
				var m = t.getTranslate() + c * i.sensitivity;
				if (m >= t.minTranslate()) m = t.minTranslate();
				if (m <= t.maxTranslate()) m = t.maxTranslate();
				a = t.params.loop ? true : !(m === t.minTranslate() || m === t.maxTranslate());
				if (a && t.params.nested) r.stopPropagation();
				if (!t.params.freeMode || !t.params.freeMode.enabled) {
					var g = { time: Mi(), delta: Math.abs(c), direction: Math.sign(c), raw: e };
					if (f.length >= 2) f.shift();
					var y = f.length ? f[f.length - 1] : void 0;
					f.push(g);
					if (y) {
						if (g.direction !== y.direction || g.delta > y.delta || g.time > y.time + 150) p(g);
					} else p(g);
					if (v(g)) return true;
				} else {
					var b = { time: Mi(), delta: Math.abs(c), direction: Math.sign(c) };
					var w = l && b.time < l.time + 500 && b.delta <= l.delta && b.direction === l.direction;
					if (!w) {
						l = void 0;
						if (t.params.loop) t.loopFix();
						var S = t.getTranslate() + c * i.sensitivity;
						var E = t.isBeginning;
						var x = t.isEnd;
						if (S >= t.minTranslate()) S = t.minTranslate();
						if (S <= t.maxTranslate()) S = t.maxTranslate();
						t.setTransition(0);
						t.setTranslate(S);
						t.updateProgress();
						t.updateActiveIndex();
						t.updateSlidesClasses();
						if ((!E && t.isBeginning) || (!x && t.isEnd)) t.updateSlidesClasses();
						if (t.params.freeMode.sticky) {
							clearTimeout(s);
							s = void 0;
							if (f.length >= 15) f.shift();
							var T = f.length ? f[f.length - 1] : void 0;
							var C = f[0];
							f.push(b);
							if (T && (b.delta > T.delta || b.direction !== T.direction)) f.splice(0);
							else if (f.length >= 15 && b.time - C.time < 500 && C.delta - b.delta >= 1 && b.delta <= 6) {
								var M = c > 0 ? 0.8 : 0.2;
								l = b;
								f.splice(0);
								s = Ci(function () {
									t.slideToClosest(t.params.speed, true, void 0, M);
								}, 0);
							}
							if (!s)
								s = Ci(function () {
									var e = 0.5;
									l = b;
									f.splice(0);
									t.slideToClosest(t.params.speed, true, void 0, e);
								}, 500);
						}
						if (!w) n("scroll", r);
						if (t.params.autoplay && t.params.autoplayDisableOnInteraction) t.autoplay.stop();
						if (S === t.minTranslate() || S === t.maxTranslate()) return true;
					}
				}
				if (r.preventDefault) r.preventDefault();
				else r.returnValue = false;
				return false;
			}
			function m(e) {
				var r = t.$el;
				if (t.params.mousewheel.eventsTarget !== "container") r = bi(t.params.mousewheel.eventsTarget);
				r[e]("mouseenter", c);
				r[e]("mouseleave", d);
				r[e]("wheel", h);
			}
			function g() {
				if (t.params.cssMode) {
					t.wrapperEl.removeEventListener("wheel", h);
					return true;
				}
				if (t.mousewheel.enabled) return false;
				m("on");
				t.mousewheel.enabled = true;
				return true;
			}
			function y() {
				if (t.params.cssMode) {
					t.wrapperEl.addEventListener(event, h);
					return true;
				}
				if (!t.mousewheel.enabled) return false;
				m("off");
				t.mousewheel.enabled = false;
				return true;
			}
			a("init", function () {
				if (!t.params.mousewheel.enabled && t.params.cssMode) y();
				if (t.params.mousewheel.enabled) g();
			});
			a("destroy", function () {
				if (t.params.cssMode) g();
				if (t.mousewheel.enabled) y();
			});
			Object.assign(t.mousewheel, { enable: g, disable: y });
		}
		function Uo(e, t, r, a) {
			var n = ia();
			if (e.params.createElements)
				Object.keys(a).forEach(function (i) {
					if (!r[i] && r.auto === true) {
						var s = e.$el.children(".".concat(a[i]))[0];
						if (!s) {
							s = n.createElement("div");
							s.className = a[i];
							e.$el.append(s);
						}
						r[i] = s;
						t[i] = s;
					}
				});
			return r;
		}
		function Ko(e) {
			var t = e.swiper,
				r = e.extendParams,
				a = e.on,
				n = e.emit;
			r({ navigation: { nextEl: null, prevEl: null, hideOnClick: false, disabledClass: "swiper-button-disabled", hiddenClass: "swiper-button-hidden", lockClass: "swiper-button-lock", navigationDisabledClass: "swiper-navigation-disabled" } });
			t.navigation = { nextEl: null, $nextEl: null, prevEl: null, $prevEl: null };
			function i(e) {
				var r;
				if (e) {
					r = bi(e);
					if (t.params.uniqueNavElements && typeof e === "string" && r.length > 1 && t.$el.find(e).length === 1) r = t.$el.find(e);
				}
				return r;
			}
			function s(e, r) {
				var a = t.params.navigation;
				if (e && e.length > 0) {
					e[r ? "addClass" : "removeClass"](a.disabledClass);
					if (e[0] && e[0].tagName === "BUTTON") e[0].disabled = r;
					if (t.params.watchOverflow && t.enabled) e[t.isLocked ? "addClass" : "removeClass"](a.lockClass);
				}
			}
			function o() {
				if (t.params.loop) return;
				var e = t.navigation,
					r = e.$nextEl,
					a = e.$prevEl;
				s(a, t.isBeginning && !t.params.rewind);
				s(r, t.isEnd && !t.params.rewind);
			}
			function l(e) {
				e.preventDefault();
				if (t.isBeginning && !t.params.loop && !t.params.rewind) return;
				t.slidePrev();
				n("navigationPrev");
			}
			function f(e) {
				e.preventDefault();
				if (t.isEnd && !t.params.loop && !t.params.rewind) return;
				t.slideNext();
				n("navigationNext");
			}
			function u() {
				var e = t.params.navigation;
				t.params.navigation = Uo(t, t.originalParams.navigation, t.params.navigation, { nextEl: "swiper-button-next", prevEl: "swiper-button-prev" });
				if (!(e.nextEl || e.prevEl)) return;
				var r = i(e.nextEl);
				var a = i(e.prevEl);
				if (r && r.length > 0) r.on("click", f);
				if (a && a.length > 0) a.on("click", l);
				Object.assign(t.navigation, { $nextEl: r, nextEl: r && r[0], $prevEl: a, prevEl: a && a[0] });
				if (!t.enabled) {
					if (r) r.addClass(e.lockClass);
					if (a) a.addClass(e.lockClass);
				}
			}
			function c() {
				var e = t.navigation,
					r = e.$nextEl,
					a = e.$prevEl;
				if (r && r.length) {
					r.off("click", f);
					r.removeClass(t.params.navigation.disabledClass);
				}
				if (a && a.length) {
					a.off("click", l);
					a.removeClass(t.params.navigation.disabledClass);
				}
			}
			a("init", function () {
				if (t.params.navigation.enabled === false) p();
				else {
					u();
					o();
				}
			});
			a("toEdge fromEdge lock unlock", function () {
				o();
			});
			a("destroy", function () {
				c();
			});
			a("enable disable", function () {
				var e = t.navigation,
					r = e.$nextEl,
					a = e.$prevEl;
				if (r) r[t.enabled ? "removeClass" : "addClass"](t.params.navigation.lockClass);
				if (a) a[t.enabled ? "removeClass" : "addClass"](t.params.navigation.lockClass);
			});
			a("click", function (e, r) {
				var a = t.navigation,
					i = a.$nextEl,
					s = a.$prevEl;
				var o = r.target;
				if (t.params.navigation.hideOnClick && !bi(o).is(s) && !bi(o).is(i)) {
					if (t.pagination && t.params.pagination && t.params.pagination.clickable && (t.pagination.el === o || t.pagination.el.contains(o))) return;
					var l;
					if (i) l = i.hasClass(t.params.navigation.hiddenClass);
					else if (s) l = s.hasClass(t.params.navigation.hiddenClass);
					if (l === true) n("navigationShow");
					else n("navigationHide");
					if (i) i.toggleClass(t.params.navigation.hiddenClass);
					if (s) s.toggleClass(t.params.navigation.hiddenClass);
				}
			});
			var d = function e() {
				t.$el.removeClass(t.params.navigation.navigationDisabledClass);
				u();
				o();
			};
			var p = function e() {
				t.$el.addClass(t.params.navigation.navigationDisabledClass);
				c();
			};
			Object.assign(t.navigation, { enable: d, disable: p, update: o, init: u, destroy: c });
		}
		function Zo() {
			var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
			return ".".concat(
				e
					.trim()
					.replace(/([\.:!\/])/g, "\\$1")
					.replace(/ /g, "."),
			);
		}
		function Qo(e) {
			var t = e.swiper,
				r = e.extendParams,
				a = e.on,
				n = e.emit;
			var i = "swiper-pagination";
			r({
				pagination: {
					el: null,
					bulletElement: "span",
					clickable: false,
					hideOnClick: false,
					renderBullet: null,
					renderProgressbar: null,
					renderFraction: null,
					renderCustom: null,
					progressbarOpposite: false,
					type: "bullets",
					dynamicBullets: false,
					dynamicMainBullets: 1,
					formatFractionCurrent: function e(t) {
						return t;
					},
					formatFractionTotal: function e(t) {
						return t;
					},
					bulletClass: "".concat(i, "-bullet"),
					bulletActiveClass: "".concat(i, "-bullet-active"),
					modifierClass: "".concat(i, "-"),
					currentClass: "".concat(i, "-current"),
					totalClass: "".concat(i, "-total"),
					hiddenClass: "".concat(i, "-hidden"),
					progressbarFillClass: "".concat(i, "-progressbar-fill"),
					progressbarOppositeClass: "".concat(i, "-progressbar-opposite"),
					clickableClass: "".concat(i, "-clickable"),
					lockClass: "".concat(i, "-lock"),
					horizontalClass: "".concat(i, "-horizontal"),
					verticalClass: "".concat(i, "-vertical"),
					paginationDisabledClass: "".concat(i, "-disabled"),
				},
			});
			t.pagination = { el: null, $el: null, bullets: [] };
			var s;
			var o = 0;
			function l() {
				return !t.params.pagination.el || !t.pagination.el || !t.pagination.$el || t.pagination.$el.length === 0;
			}
			function f(e, r) {
				var a = t.params.pagination.bulletActiveClass;
				e[r]().addClass("".concat(a, "-").concat(r))[r]().addClass("".concat(a, "-").concat(r, "-").concat(r));
			}
			function u() {
				var e = t.rtl;
				var r = t.params.pagination;
				if (l()) return;
				var a = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.slides.length;
				var i = t.pagination.$el;
				var u;
				var c = t.params.loop ? Math.ceil((a - t.loopedSlides * 2) / t.params.slidesPerGroup) : t.snapGrid.length;
				if (t.params.loop) {
					u = Math.ceil((t.activeIndex - t.loopedSlides) / t.params.slidesPerGroup);
					if (u > a - 1 - t.loopedSlides * 2) u -= a - t.loopedSlides * 2;
					if (u > c - 1) u -= c;
					if (u < 0 && t.params.paginationType !== "bullets") u = c + u;
				} else if (typeof t.snapIndex !== "undefined") u = t.snapIndex;
				else u = t.activeIndex || 0;
				if (r.type === "bullets" && t.pagination.bullets && t.pagination.bullets.length > 0) {
					var d = t.pagination.bullets;
					var p;
					var v;
					var h;
					if (r.dynamicBullets) {
						s = d.eq(0)[t.isHorizontal() ? "outerWidth" : "outerHeight"](true);
						i.css(t.isHorizontal() ? "width" : "height", "".concat(s * (r.dynamicMainBullets + 4), "px"));
						if (r.dynamicMainBullets > 1 && t.previousIndex !== void 0) {
							o += u - (t.previousIndex - t.loopedSlides || 0);
							if (o > r.dynamicMainBullets - 1) o = r.dynamicMainBullets - 1;
							else if (o < 0) o = 0;
						}
						p = Math.max(u - o, 0);
						v = p + (Math.min(d.length, r.dynamicMainBullets) - 1);
						h = (v + p) / 2;
					}
					d.removeClass(
						[
							"",
							"-next",
							"-next-next",
							"-prev",
							"-prev-prev",
							"-main",
						]
							.map(function (e) {
								return "".concat(r.bulletActiveClass).concat(e);
							})
							.join(" "),
					);
					if (i.length > 1)
						d.each(function (e) {
							var t = bi(e);
							var a = t.index();
							if (a === u) t.addClass(r.bulletActiveClass);
							if (r.dynamicBullets) {
								if (a >= p && a <= v) t.addClass("".concat(r.bulletActiveClass, "-main"));
								if (a === p) f(t, "prev");
								if (a === v) f(t, "next");
							}
						});
					else {
						var m = d.eq(u);
						var g = m.index();
						m.addClass(r.bulletActiveClass);
						if (r.dynamicBullets) {
							var y = d.eq(p);
							var b = d.eq(v);
							for (var w = p; w <= v; w += 1) d.eq(w).addClass("".concat(r.bulletActiveClass, "-main"));
							if (t.params.loop)
								if (g >= d.length) {
									for (var S = r.dynamicMainBullets; S >= 0; S -= 1) d.eq(d.length - S).addClass("".concat(r.bulletActiveClass, "-main"));
									d.eq(d.length - r.dynamicMainBullets - 1).addClass("".concat(r.bulletActiveClass, "-prev"));
								} else {
									f(y, "prev");
									f(b, "next");
								}
							else {
								f(y, "prev");
								f(b, "next");
							}
						}
					}
					if (r.dynamicBullets) {
						var E = Math.min(d.length, r.dynamicMainBullets + 4);
						var x = (s * E - s) / 2 - h * s;
						var T = e ? "right" : "left";
						d.css(t.isHorizontal() ? T : "top", "".concat(x, "px"));
					}
				}
				if (r.type === "fraction") {
					i.find(Zo(r.currentClass)).text(r.formatFractionCurrent(u + 1));
					i.find(Zo(r.totalClass)).text(r.formatFractionTotal(c));
				}
				if (r.type === "progressbar") {
					var C;
					if (r.progressbarOpposite) C = t.isHorizontal() ? "vertical" : "horizontal";
					else C = t.isHorizontal() ? "horizontal" : "vertical";
					var M = (u + 1) / c;
					var P = 1;
					var O = 1;
					if (C === "horizontal") P = M;
					else O = M;
					i.find(Zo(r.progressbarFillClass)).transform("translate3d(0,0,0) scaleX(".concat(P, ") scaleY(").concat(O, ")")).transition(t.params.speed);
				}
				if (r.type === "custom" && r.renderCustom) {
					i.html(r.renderCustom(t, u + 1, c));
					n("paginationRender", i[0]);
				} else n("paginationUpdate", i[0]);
				if (t.params.watchOverflow && t.enabled) i[t.isLocked ? "addClass" : "removeClass"](r.lockClass);
			}
			function c() {
				var e = t.params.pagination;
				if (l()) return;
				var r = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.slides.length;
				var a = t.pagination.$el;
				var i = "";
				if (e.type === "bullets") {
					var s = t.params.loop ? Math.ceil((r - t.loopedSlides * 2) / t.params.slidesPerGroup) : t.snapGrid.length;
					if (t.params.freeMode && t.params.freeMode.enabled && !t.params.loop && s > r) s = r;
					for (var o = 0; o < s; o += 1)
						if (e.renderBullet) i += e.renderBullet.call(t, o, e.bulletClass);
						else i += "<".concat(e.bulletElement, ' class="').concat(e.bulletClass, '"></').concat(e.bulletElement, ">");
					a.html(i);
					t.pagination.bullets = a.find(Zo(e.bulletClass));
				}
				if (e.type === "fraction") {
					if (e.renderFraction) i = e.renderFraction.call(t, e.currentClass, e.totalClass);
					else i = '<span class="'.concat(e.currentClass, '"></span>') + " / " + '<span class="'.concat(e.totalClass, '"></span>');
					a.html(i);
				}
				if (e.type === "progressbar") {
					if (e.renderProgressbar) i = e.renderProgressbar.call(t, e.progressbarFillClass);
					else i = '<span class="'.concat(e.progressbarFillClass, '"></span>');
					a.html(i);
				}
				if (e.type !== "custom") n("paginationRender", t.pagination.$el[0]);
			}
			function d() {
				t.params.pagination = Uo(t, t.originalParams.pagination, t.params.pagination, { el: "swiper-pagination" });
				var e = t.params.pagination;
				if (!e.el) return;
				var r = bi(e.el);
				if (r.length === 0) return;
				if (t.params.uniqueNavElements && typeof e.el === "string" && r.length > 1) {
					r = t.$el.find(e.el);
					if (r.length > 1)
						r = r.filter(function (e) {
							if (bi(e).parents(".swiper")[0] !== t.el) return false;
							return true;
						});
				}
				if (e.type === "bullets" && e.clickable) r.addClass(e.clickableClass);
				r.addClass(e.modifierClass + e.type);
				r.addClass(t.isHorizontal() ? e.horizontalClass : e.verticalClass);
				if (e.type === "bullets" && e.dynamicBullets) {
					r.addClass("".concat(e.modifierClass).concat(e.type, "-dynamic"));
					o = 0;
					if (e.dynamicMainBullets < 1) e.dynamicMainBullets = 1;
				}
				if (e.type === "progressbar" && e.progressbarOpposite) r.addClass(e.progressbarOppositeClass);
				if (e.clickable)
					r.on("click", Zo(e.bulletClass), function e(r) {
						r.preventDefault();
						var a = bi(this).index() * t.params.slidesPerGroup;
						if (t.params.loop) a += t.loopedSlides;
						t.slideTo(a);
					});
				Object.assign(t.pagination, { $el: r, el: r[0] });
				if (!t.enabled) r.addClass(e.lockClass);
			}
			function p() {
				var e = t.params.pagination;
				if (l()) return;
				var r = t.pagination.$el;
				r.removeClass(e.hiddenClass);
				r.removeClass(e.modifierClass + e.type);
				r.removeClass(t.isHorizontal() ? e.horizontalClass : e.verticalClass);
				if (t.pagination.bullets && t.pagination.bullets.removeClass) t.pagination.bullets.removeClass(e.bulletActiveClass);
				if (e.clickable) r.off("click", Zo(e.bulletClass));
			}
			a("init", function () {
				if (t.params.pagination.enabled === false) h();
				else {
					d();
					c();
					u();
				}
			});
			a("activeIndexChange", function () {
				if (t.params.loop) u();
				else if (typeof t.snapIndex === "undefined") u();
			});
			a("snapIndexChange", function () {
				if (!t.params.loop) u();
			});
			a("slidesLengthChange", function () {
				if (t.params.loop) {
					c();
					u();
				}
			});
			a("snapGridLengthChange", function () {
				if (!t.params.loop) {
					c();
					u();
				}
			});
			a("destroy", function () {
				p();
			});
			a("enable disable", function () {
				var e = t.pagination.$el;
				if (e) e[t.enabled ? "removeClass" : "addClass"](t.params.pagination.lockClass);
			});
			a("lock unlock", function () {
				u();
			});
			a("click", function (e, r) {
				var a = r.target;
				var i = t.pagination.$el;
				if (t.params.pagination.el && t.params.pagination.hideOnClick && i && i.length > 0 && !bi(a).hasClass(t.params.pagination.bulletClass)) {
					if (t.navigation && ((t.navigation.nextEl && a === t.navigation.nextEl) || (t.navigation.prevEl && a === t.navigation.prevEl))) return;
					var s = i.hasClass(t.params.pagination.hiddenClass);
					if (s === true) n("paginationShow");
					else n("paginationHide");
					i.toggleClass(t.params.pagination.hiddenClass);
				}
			});
			var v = function e() {
				t.$el.removeClass(t.params.pagination.paginationDisabledClass);
				if (t.pagination.$el) t.pagination.$el.removeClass(t.params.pagination.paginationDisabledClass);
				d();
				c();
				u();
			};
			var h = function e() {
				t.$el.addClass(t.params.pagination.paginationDisabledClass);
				if (t.pagination.$el) t.pagination.$el.addClass(t.params.pagination.paginationDisabledClass);
				p();
			};
			Object.assign(t.pagination, { enable: v, disable: h, render: c, update: u, init: d, destroy: p });
		}
		function Jo(e) {
			var t = e.swiper,
				r = e.extendParams,
				a = e.on,
				n = e.emit;
			var i = getDocument();
			var s = false;
			var o = null;
			var l = null;
			var f;
			var u;
			var c;
			var d;
			r({ scrollbar: { el: null, dragSize: "auto", hide: false, draggable: false, snapOnRelease: true, lockClass: "swiper-scrollbar-lock", dragClass: "swiper-scrollbar-drag", scrollbarDisabledClass: "swiper-scrollbar-disabled", horizontalClass: "swiper-scrollbar-horizontal", verticalClass: "swiper-scrollbar-vertical" } });
			t.scrollbar = { el: null, dragEl: null, $el: null, $dragEl: null };
			function p() {
				if (!t.params.scrollbar.el || !t.scrollbar.el) return;
				var e = t.scrollbar,
					r = t.rtlTranslate,
					a = t.progress;
				var n = e.$dragEl,
					i = e.$el;
				var s = t.params.scrollbar;
				var l = u;
				var f = (c - u) * a;
				if (r) {
					f = -f;
					if (f > 0) {
						l = u - f;
						f = 0;
					} else if (-f + u > c) l = c + f;
				} else if (f < 0) {
					l = u + f;
					f = 0;
				} else if (f + u > c) l = c - f;
				if (t.isHorizontal()) {
					n.transform("translate3d(".concat(f, "px, 0, 0)"));
					n[0].style.width = "".concat(l, "px");
				} else {
					n.transform("translate3d(0px, ".concat(f, "px, 0)"));
					n[0].style.height = "".concat(l, "px");
				}
				if (s.hide) {
					clearTimeout(o);
					i[0].style.opacity = 1;
					o = setTimeout(function () {
						i[0].style.opacity = 0;
						i.transition(400);
					}, 1e3);
				}
			}
			function v(e) {
				if (!t.params.scrollbar.el || !t.scrollbar.el) return;
				t.scrollbar.$dragEl.transition(e);
			}
			function h() {
				if (!t.params.scrollbar.el || !t.scrollbar.el) return;
				var e = t.scrollbar;
				var r = e.$dragEl,
					a = e.$el;
				r[0].style.width = "";
				r[0].style.height = "";
				c = t.isHorizontal() ? a[0].offsetWidth : a[0].offsetHeight;
				d = t.size / (t.virtualSize + t.params.slidesOffsetBefore - (t.params.centeredSlides ? t.snapGrid[0] : 0));
				if (t.params.scrollbar.dragSize === "auto") u = c * d;
				else u = parseInt(t.params.scrollbar.dragSize, 10);
				if (t.isHorizontal()) r[0].style.width = "".concat(u, "px");
				else r[0].style.height = "".concat(u, "px");
				if (d >= 1) a[0].style.display = "none";
				else a[0].style.display = "";
				if (t.params.scrollbar.hide) a[0].style.opacity = 0;
				if (t.params.watchOverflow && t.enabled) e.$el[t.isLocked ? "addClass" : "removeClass"](t.params.scrollbar.lockClass);
			}
			function m(e) {
				if (t.isHorizontal()) return e.type === "touchstart" || e.type === "touchmove" ? e.targetTouches[0].clientX : e.clientX;
				return e.type === "touchstart" || e.type === "touchmove" ? e.targetTouches[0].clientY : e.clientY;
			}
			function g(e) {
				var r = t.scrollbar,
					a = t.rtlTranslate;
				var n = r.$el;
				var i;
				i = (m(e) - n.offset()[t.isHorizontal() ? "left" : "top"] - (f !== null ? f : u / 2)) / (c - u);
				i = Math.max(Math.min(i, 1), 0);
				if (a) i = 1 - i;
				var s = t.minTranslate() + (t.maxTranslate() - t.minTranslate()) * i;
				t.updateProgress(s);
				t.setTranslate(s);
				t.updateActiveIndex();
				t.updateSlidesClasses();
			}
			function y(e) {
				var r = t.params.scrollbar;
				var a = t.scrollbar,
					i = t.$wrapperEl;
				var o = a.$el,
					u = a.$dragEl;
				s = true;
				f = e.target === u[0] || e.target === u ? m(e) - e.target.getBoundingClientRect()[t.isHorizontal() ? "left" : "top"] : null;
				e.preventDefault();
				e.stopPropagation();
				i.transition(100);
				u.transition(100);
				g(e);
				clearTimeout(l);
				o.transition(0);
				if (r.hide) o.css("opacity", 1);
				if (t.params.cssMode) t.$wrapperEl.css("scroll-snap-type", "none");
				n("scrollbarDragStart", e);
			}
			function b(e) {
				var r = t.scrollbar,
					a = t.$wrapperEl;
				var i = r.$el,
					o = r.$dragEl;
				if (!s) return;
				if (e.preventDefault) e.preventDefault();
				else e.returnValue = false;
				g(e);
				a.transition(0);
				i.transition(0);
				o.transition(0);
				n("scrollbarDragMove", e);
			}
			function w(e) {
				var r = t.params.scrollbar;
				var a = t.scrollbar,
					i = t.$wrapperEl;
				var o = a.$el;
				if (!s) return;
				s = false;
				if (t.params.cssMode) {
					t.$wrapperEl.css("scroll-snap-type", "");
					i.transition("");
				}
				if (r.hide) {
					clearTimeout(l);
					l = nextTick(function () {
						o.css("opacity", 0);
						o.transition(400);
					}, 1e3);
				}
				n("scrollbarDragEnd", e);
				if (r.snapOnRelease) t.slideToClosest();
			}
			function S(e) {
				var r = t.scrollbar,
					a = t.touchEventsTouch,
					n = t.touchEventsDesktop,
					s = t.params,
					o = t.support;
				var l = r.$el;
				if (!l) return;
				var f = l[0];
				var u = o.passiveListener && s.passiveListeners ? { passive: false, capture: false } : false;
				var c = o.passiveListener && s.passiveListeners ? { passive: true, capture: false } : false;
				if (!f) return;
				var d = e === "on" ? "addEventListener" : "removeEventListener";
				if (!o.touch) {
					f[d](n.start, y, u);
					i[d](n.move, b, u);
					i[d](n.end, w, c);
				} else {
					f[d](a.start, y, u);
					f[d](a.move, b, u);
					f[d](a.end, w, c);
				}
			}
			function E() {
				if (!t.params.scrollbar.el || !t.scrollbar.el) return;
				S("on");
			}
			function x() {
				if (!t.params.scrollbar.el || !t.scrollbar.el) return;
				S("off");
			}
			function T() {
				var e = t.scrollbar,
					r = t.$el;
				t.params.scrollbar = createElementIfNotDefined(t, t.originalParams.scrollbar, t.params.scrollbar, { el: "swiper-scrollbar" });
				var a = t.params.scrollbar;
				if (!a.el) return;
				var n = $(a.el);
				if (t.params.uniqueNavElements && typeof a.el === "string" && n.length > 1 && r.find(a.el).length === 1) n = r.find(a.el);
				n.addClass(t.isHorizontal() ? a.horizontalClass : a.verticalClass);
				var i = n.find(".".concat(t.params.scrollbar.dragClass));
				if (i.length === 0) {
					i = $('<div class="'.concat(t.params.scrollbar.dragClass, '"></div>'));
					n.append(i);
				}
				Object.assign(e, { $el: n, el: n[0], $dragEl: i, dragEl: i[0] });
				if (a.draggable) E();
				if (n) n[t.enabled ? "removeClass" : "addClass"](t.params.scrollbar.lockClass);
			}
			function C() {
				var e = t.params.scrollbar;
				var r = t.scrollbar.$el;
				if (r) r.removeClass(t.isHorizontal() ? e.horizontalClass : e.verticalClass);
				x();
			}
			a("init", function () {
				if (t.params.scrollbar.enabled === false) P();
				else {
					T();
					h();
					p();
				}
			});
			a("update resize observerUpdate lock unlock", function () {
				h();
			});
			a("setTranslate", function () {
				p();
			});
			a("setTransition", function (e, t) {
				v(t);
			});
			a("enable disable", function () {
				var e = t.scrollbar.$el;
				if (e) e[t.enabled ? "removeClass" : "addClass"](t.params.scrollbar.lockClass);
			});
			a("destroy", function () {
				C();
			});
			var M = function e() {
				t.$el.removeClass(t.params.scrollbar.scrollbarDisabledClass);
				if (t.scrollbar.$el) t.scrollbar.$el.removeClass(t.params.scrollbar.scrollbarDisabledClass);
				T();
				h();
				p();
			};
			var P = function e() {
				t.$el.addClass(t.params.scrollbar.scrollbarDisabledClass);
				if (t.scrollbar.$el) t.scrollbar.$el.addClass(t.params.scrollbar.scrollbarDisabledClass);
				C();
			};
			Object.assign(t.scrollbar, { enable: M, disable: P, updateSize: h, setTranslate: p, init: T, destroy: C });
		}
		function el(e) {
			var t = e.swiper,
				r = e.extendParams,
				a = e.on;
			r({ parallax: { enabled: false } });
			var n = function e(r, a) {
				var n = t.rtl;
				var i = $(r);
				var s = n ? -1 : 1;
				var o = i.attr("data-swiper-parallax") || "0";
				var l = i.attr("data-swiper-parallax-x");
				var f = i.attr("data-swiper-parallax-y");
				var u = i.attr("data-swiper-parallax-scale");
				var c = i.attr("data-swiper-parallax-opacity");
				if (l || f) {
					l = l || "0";
					f = f || "0";
				} else if (t.isHorizontal()) {
					l = o;
					f = "0";
				} else {
					f = o;
					l = "0";
				}
				if (l.indexOf("%") >= 0) l = "".concat(parseInt(l, 10) * a * s, "%");
				else l = "".concat(l * a * s, "px");
				if (f.indexOf("%") >= 0) f = "".concat(parseInt(f, 10) * a, "%");
				else f = "".concat(f * a, "px");
				if (typeof c !== "undefined" && c !== null) {
					var d = c - (c - 1) * (1 - Math.abs(a));
					i[0].style.opacity = d;
				}
				if (typeof u === "undefined" || u === null) i.transform("translate3d(".concat(l, ", ").concat(f, ", 0px)"));
				else {
					var p = u - (u - 1) * (1 - Math.abs(a));
					i.transform("translate3d(".concat(l, ", ").concat(f, ", 0px) scale(").concat(p, ")"));
				}
			};
			var i = function e() {
				var r = t.$el,
					a = t.slides,
					i = t.progress,
					s = t.snapGrid;
				r.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each(function (e) {
					n(e, i);
				});
				a.each(function (e, r) {
					var a = e.progress;
					if (t.params.slidesPerGroup > 1 && t.params.slidesPerView !== "auto") a += Math.ceil(r / 2) - i * (s.length - 1);
					a = Math.min(Math.max(a, -1), 1);
					$(e)
						.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]")
						.each(function (e) {
							n(e, a);
						});
				});
			};
			var s = function e() {
				var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : t.params.speed;
				var a = t.$el;
				a.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each(function (e) {
					var t = $(e);
					var a = parseInt(t.attr("data-swiper-parallax-duration"), 10) || r;
					if (r === 0) a = 0;
					t.transition(a);
				});
			};
			a("beforeInit", function () {
				if (!t.params.parallax.enabled) return;
				t.params.watchSlidesProgress = true;
				t.originalParams.watchSlidesProgress = true;
			});
			a("init", function () {
				if (!t.params.parallax.enabled) return;
				i();
			});
			a("setTranslate", function () {
				if (!t.params.parallax.enabled) return;
				i();
			});
			a("setTransition", function (e, r) {
				if (!t.params.parallax.enabled) return;
				s(r);
			});
		}
		function tl(e) {
			var t = e.swiper,
				r = e.extendParams,
				a = e.on,
				n = e.emit;
			var i = getWindow();
			r({ zoom: { enabled: false, maxRatio: 3, minRatio: 1, toggle: true, containerClass: "swiper-zoom-container", zoomedSlideClass: "swiper-slide-zoomed" } });
			t.zoom = { enabled: false };
			var s = 1;
			var o = false;
			var l;
			var f;
			var u;
			var c = { $slideEl: void 0, slideWidth: void 0, slideHeight: void 0, $imageEl: void 0, $imageWrapEl: void 0, maxRatio: 3 };
			var d = { isTouched: void 0, isMoved: void 0, currentX: void 0, currentY: void 0, minX: void 0, minY: void 0, maxX: void 0, maxY: void 0, width: void 0, height: void 0, startX: void 0, startY: void 0, touchesStart: {}, touchesCurrent: {} };
			var p = { x: void 0, y: void 0, prevPositionX: void 0, prevPositionY: void 0, prevTime: void 0 };
			var v = 1;
			Object.defineProperty(t.zoom, "scale", {
				get: function e() {
					return v;
				},
				set: function e(t) {
					if (v !== t) {
						var r = c.$imageEl ? c.$imageEl[0] : void 0;
						var a = c.$slideEl ? c.$slideEl[0] : void 0;
						n("zoomChange", t, r, a);
					}
					v = t;
				},
			});
			function h(e) {
				if (e.targetTouches.length < 2) return 1;
				var t = e.targetTouches[0].pageX;
				var r = e.targetTouches[0].pageY;
				var a = e.targetTouches[1].pageX;
				var n = e.targetTouches[1].pageY;
				var i = Math.sqrt(Math.pow(a - t, 2) + Math.pow(n - r, 2));
				return i;
			}
			function m(e) {
				var r = t.support;
				var a = t.params.zoom;
				f = false;
				u = false;
				if (!r.gestures) {
					if (e.type !== "touchstart" || (e.type === "touchstart" && e.targetTouches.length < 2)) return;
					f = true;
					c.scaleStart = h(e);
				}
				if (!c.$slideEl || !c.$slideEl.length) {
					c.$slideEl = $(e.target).closest(".".concat(t.params.slideClass));
					if (c.$slideEl.length === 0) c.$slideEl = t.slides.eq(t.activeIndex);
					c.$imageEl = c.$slideEl.find(".".concat(a.containerClass)).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0);
					c.$imageWrapEl = c.$imageEl.parent(".".concat(a.containerClass));
					c.maxRatio = c.$imageWrapEl.attr("data-swiper-zoom") || a.maxRatio;
					if (c.$imageWrapEl.length === 0) {
						c.$imageEl = void 0;
						return;
					}
				}
				if (c.$imageEl) c.$imageEl.transition(0);
				o = true;
			}
			function g(e) {
				var r = t.support;
				var a = t.params.zoom;
				var n = t.zoom;
				if (!r.gestures) {
					if (e.type !== "touchmove" || (e.type === "touchmove" && e.targetTouches.length < 2)) return;
					u = true;
					c.scaleMove = h(e);
				}
				if (!c.$imageEl || c.$imageEl.length === 0) {
					if (e.type === "gesturechange") m(e);
					return;
				}
				if (r.gestures) n.scale = e.scale * s;
				else n.scale = (c.scaleMove / c.scaleStart) * s;
				if (n.scale > c.maxRatio) n.scale = c.maxRatio - 1 + Math.pow(n.scale - c.maxRatio + 1, 0.5);
				if (n.scale < a.minRatio) n.scale = a.minRatio + 1 - Math.pow(a.minRatio - n.scale + 1, 0.5);
				c.$imageEl.transform("translate3d(0,0,0) scale(".concat(n.scale, ")"));
			}
			function y(e) {
				var r = t.device;
				var a = t.support;
				var n = t.params.zoom;
				var i = t.zoom;
				if (!a.gestures) {
					if (!f || !u) return;
					if (e.type !== "touchend" || (e.type === "touchend" && e.changedTouches.length < 2 && !r.android)) return;
					f = false;
					u = false;
				}
				if (!c.$imageEl || c.$imageEl.length === 0) return;
				i.scale = Math.max(Math.min(i.scale, c.maxRatio), n.minRatio);
				c.$imageEl.transition(t.params.speed).transform("translate3d(0,0,0) scale(".concat(i.scale, ")"));
				s = i.scale;
				o = false;
				if (i.scale === 1) c.$slideEl = void 0;
			}
			function b(e) {
				var r = t.device;
				if (!c.$imageEl || c.$imageEl.length === 0) return;
				if (d.isTouched) return;
				if (r.android && e.cancelable) e.preventDefault();
				d.isTouched = true;
				d.touchesStart.x = e.type === "touchstart" ? e.targetTouches[0].pageX : e.pageX;
				d.touchesStart.y = e.type === "touchstart" ? e.targetTouches[0].pageY : e.pageY;
			}
			function w(e) {
				var r = t.zoom;
				if (!c.$imageEl || c.$imageEl.length === 0) return;
				t.allowClick = false;
				if (!d.isTouched || !c.$slideEl) return;
				if (!d.isMoved) {
					d.width = c.$imageEl[0].offsetWidth;
					d.height = c.$imageEl[0].offsetHeight;
					d.startX = getTranslate(c.$imageWrapEl[0], "x") || 0;
					d.startY = getTranslate(c.$imageWrapEl[0], "y") || 0;
					c.slideWidth = c.$slideEl[0].offsetWidth;
					c.slideHeight = c.$slideEl[0].offsetHeight;
					c.$imageWrapEl.transition(0);
				}
				var a = d.width * r.scale;
				var n = d.height * r.scale;
				if (a < c.slideWidth && n < c.slideHeight) return;
				d.minX = Math.min(c.slideWidth / 2 - a / 2, 0);
				d.maxX = -d.minX;
				d.minY = Math.min(c.slideHeight / 2 - n / 2, 0);
				d.maxY = -d.minY;
				d.touchesCurrent.x = e.type === "touchmove" ? e.targetTouches[0].pageX : e.pageX;
				d.touchesCurrent.y = e.type === "touchmove" ? e.targetTouches[0].pageY : e.pageY;
				if (!d.isMoved && !o) {
					if (t.isHorizontal() && ((Math.floor(d.minX) === Math.floor(d.startX) && d.touchesCurrent.x < d.touchesStart.x) || (Math.floor(d.maxX) === Math.floor(d.startX) && d.touchesCurrent.x > d.touchesStart.x))) {
						d.isTouched = false;
						return;
					}
					if (!t.isHorizontal() && ((Math.floor(d.minY) === Math.floor(d.startY) && d.touchesCurrent.y < d.touchesStart.y) || (Math.floor(d.maxY) === Math.floor(d.startY) && d.touchesCurrent.y > d.touchesStart.y))) {
						d.isTouched = false;
						return;
					}
				}
				if (e.cancelable) e.preventDefault();
				e.stopPropagation();
				d.isMoved = true;
				d.currentX = d.touchesCurrent.x - d.touchesStart.x + d.startX;
				d.currentY = d.touchesCurrent.y - d.touchesStart.y + d.startY;
				if (d.currentX < d.minX) d.currentX = d.minX + 1 - Math.pow(d.minX - d.currentX + 1, 0.8);
				if (d.currentX > d.maxX) d.currentX = d.maxX - 1 + Math.pow(d.currentX - d.maxX + 1, 0.8);
				if (d.currentY < d.minY) d.currentY = d.minY + 1 - Math.pow(d.minY - d.currentY + 1, 0.8);
				if (d.currentY > d.maxY) d.currentY = d.maxY - 1 + Math.pow(d.currentY - d.maxY + 1, 0.8);
				if (!p.prevPositionX) p.prevPositionX = d.touchesCurrent.x;
				if (!p.prevPositionY) p.prevPositionY = d.touchesCurrent.y;
				if (!p.prevTime) p.prevTime = Date.now();
				p.x = (d.touchesCurrent.x - p.prevPositionX) / (Date.now() - p.prevTime) / 2;
				p.y = (d.touchesCurrent.y - p.prevPositionY) / (Date.now() - p.prevTime) / 2;
				if (Math.abs(d.touchesCurrent.x - p.prevPositionX) < 2) p.x = 0;
				if (Math.abs(d.touchesCurrent.y - p.prevPositionY) < 2) p.y = 0;
				p.prevPositionX = d.touchesCurrent.x;
				p.prevPositionY = d.touchesCurrent.y;
				p.prevTime = Date.now();
				c.$imageWrapEl.transform("translate3d(".concat(d.currentX, "px, ").concat(d.currentY, "px,0)"));
			}
			function S() {
				var e = t.zoom;
				if (!c.$imageEl || c.$imageEl.length === 0) return;
				if (!d.isTouched || !d.isMoved) {
					d.isTouched = false;
					d.isMoved = false;
					return;
				}
				d.isTouched = false;
				d.isMoved = false;
				var r = 300;
				var a = 300;
				var n = p.x * r;
				var i = d.currentX + n;
				var s = p.y * a;
				var o = d.currentY + s;
				if (p.x !== 0) r = Math.abs((i - d.currentX) / p.x);
				if (p.y !== 0) a = Math.abs((o - d.currentY) / p.y);
				var l = Math.max(r, a);
				d.currentX = i;
				d.currentY = o;
				var f = d.width * e.scale;
				var u = d.height * e.scale;
				d.minX = Math.min(c.slideWidth / 2 - f / 2, 0);
				d.maxX = -d.minX;
				d.minY = Math.min(c.slideHeight / 2 - u / 2, 0);
				d.maxY = -d.minY;
				d.currentX = Math.max(Math.min(d.currentX, d.maxX), d.minX);
				d.currentY = Math.max(Math.min(d.currentY, d.maxY), d.minY);
				c.$imageWrapEl.transition(l).transform("translate3d(".concat(d.currentX, "px, ").concat(d.currentY, "px,0)"));
			}
			function E() {
				var e = t.zoom;
				if (c.$slideEl && t.previousIndex !== t.activeIndex) {
					if (c.$imageEl) c.$imageEl.transform("translate3d(0,0,0) scale(1)");
					if (c.$imageWrapEl) c.$imageWrapEl.transform("translate3d(0,0,0)");
					e.scale = 1;
					s = 1;
					c.$slideEl = void 0;
					c.$imageEl = void 0;
					c.$imageWrapEl = void 0;
				}
			}
			function x(e) {
				var r = t.zoom;
				var a = t.params.zoom;
				if (!c.$slideEl) {
					if (e && e.target) c.$slideEl = $(e.target).closest(".".concat(t.params.slideClass));
					if (!c.$slideEl)
						if (t.params.virtual && t.params.virtual.enabled && t.virtual) c.$slideEl = t.$wrapperEl.children(".".concat(t.params.slideActiveClass));
						else c.$slideEl = t.slides.eq(t.activeIndex);
					c.$imageEl = c.$slideEl.find(".".concat(a.containerClass)).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0);
					c.$imageWrapEl = c.$imageEl.parent(".".concat(a.containerClass));
				}
				if (!c.$imageEl || c.$imageEl.length === 0 || !c.$imageWrapEl || c.$imageWrapEl.length === 0) return;
				if (t.params.cssMode) {
					t.wrapperEl.style.overflow = "hidden";
					t.wrapperEl.style.touchAction = "none";
				}
				c.$slideEl.addClass("".concat(a.zoomedSlideClass));
				var n;
				var o;
				var l;
				var f;
				var u;
				var p;
				var v;
				var h;
				var m;
				var g;
				var y;
				var b;
				var w;
				var S;
				var E;
				var x;
				var T;
				var C;
				if (typeof d.touchesStart.x === "undefined" && e) {
					n = e.type === "touchend" ? e.changedTouches[0].pageX : e.pageX;
					o = e.type === "touchend" ? e.changedTouches[0].pageY : e.pageY;
				} else {
					n = d.touchesStart.x;
					o = d.touchesStart.y;
				}
				r.scale = c.$imageWrapEl.attr("data-swiper-zoom") || a.maxRatio;
				s = c.$imageWrapEl.attr("data-swiper-zoom") || a.maxRatio;
				if (e) {
					T = c.$slideEl[0].offsetWidth;
					C = c.$slideEl[0].offsetHeight;
					l = c.$slideEl.offset().left + i.scrollX;
					f = c.$slideEl.offset().top + i.scrollY;
					u = l + T / 2 - n;
					p = f + C / 2 - o;
					m = c.$imageEl[0].offsetWidth;
					g = c.$imageEl[0].offsetHeight;
					y = m * r.scale;
					b = g * r.scale;
					w = Math.min(T / 2 - y / 2, 0);
					S = Math.min(C / 2 - b / 2, 0);
					E = -w;
					x = -S;
					v = u * r.scale;
					h = p * r.scale;
					if (v < w) v = w;
					if (v > E) v = E;
					if (h < S) h = S;
					if (h > x) h = x;
				} else {
					v = 0;
					h = 0;
				}
				c.$imageWrapEl.transition(300).transform("translate3d(".concat(v, "px, ").concat(h, "px,0)"));
				c.$imageEl.transition(300).transform("translate3d(0,0,0) scale(".concat(r.scale, ")"));
			}
			function T() {
				var e = t.zoom;
				var r = t.params.zoom;
				if (!c.$slideEl) {
					if (t.params.virtual && t.params.virtual.enabled && t.virtual) c.$slideEl = t.$wrapperEl.children(".".concat(t.params.slideActiveClass));
					else c.$slideEl = t.slides.eq(t.activeIndex);
					c.$imageEl = c.$slideEl.find(".".concat(r.containerClass)).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0);
					c.$imageWrapEl = c.$imageEl.parent(".".concat(r.containerClass));
				}
				if (!c.$imageEl || c.$imageEl.length === 0 || !c.$imageWrapEl || c.$imageWrapEl.length === 0) return;
				if (t.params.cssMode) {
					t.wrapperEl.style.overflow = "";
					t.wrapperEl.style.touchAction = "";
				}
				e.scale = 1;
				s = 1;
				c.$imageWrapEl.transition(300).transform("translate3d(0,0,0)");
				c.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)");
				c.$slideEl.removeClass("".concat(r.zoomedSlideClass));
				c.$slideEl = void 0;
			}
			function C(e) {
				var r = t.zoom;
				if (r.scale && r.scale !== 1) T();
				else x(e);
			}
			function M() {
				var e = t.support;
				var r = t.touchEvents.start === "touchstart" && e.passiveListener && t.params.passiveListeners ? { passive: true, capture: false } : false;
				var a = e.passiveListener ? { passive: false, capture: true } : true;
				return { passiveListener: r, activeListenerWithCapture: a };
			}
			function P() {
				return ".".concat(t.params.slideClass);
			}
			function O(e) {
				var r = M(),
					a = r.passiveListener;
				var n = P();
				t.$wrapperEl[e]("gesturestart", n, m, a);
				t.$wrapperEl[e]("gesturechange", n, g, a);
				t.$wrapperEl[e]("gestureend", n, y, a);
			}
			function k() {
				if (l) return;
				l = true;
				O("on");
			}
			function A() {
				if (!l) return;
				l = false;
				O("off");
			}
			function I() {
				var e = t.zoom;
				if (e.enabled) return;
				e.enabled = true;
				var r = t.support;
				var a = M(),
					n = a.passiveListener,
					i = a.activeListenerWithCapture;
				var s = P();
				if (r.gestures) {
					t.$wrapperEl.on(t.touchEvents.start, k, n);
					t.$wrapperEl.on(t.touchEvents.end, A, n);
				} else if (t.touchEvents.start === "touchstart") {
					t.$wrapperEl.on(t.touchEvents.start, s, m, n);
					t.$wrapperEl.on(t.touchEvents.move, s, g, i);
					t.$wrapperEl.on(t.touchEvents.end, s, y, n);
					if (t.touchEvents.cancel) t.$wrapperEl.on(t.touchEvents.cancel, s, y, n);
				}
				t.$wrapperEl.on(t.touchEvents.move, ".".concat(t.params.zoom.containerClass), w, i);
			}
			function z() {
				var e = t.zoom;
				if (!e.enabled) return;
				var r = t.support;
				e.enabled = false;
				var a = M(),
					n = a.passiveListener,
					i = a.activeListenerWithCapture;
				var s = P();
				if (r.gestures) {
					t.$wrapperEl.off(t.touchEvents.start, k, n);
					t.$wrapperEl.off(t.touchEvents.end, A, n);
				} else if (t.touchEvents.start === "touchstart") {
					t.$wrapperEl.off(t.touchEvents.start, s, m, n);
					t.$wrapperEl.off(t.touchEvents.move, s, g, i);
					t.$wrapperEl.off(t.touchEvents.end, s, y, n);
					if (t.touchEvents.cancel) t.$wrapperEl.off(t.touchEvents.cancel, s, y, n);
				}
				t.$wrapperEl.off(t.touchEvents.move, ".".concat(t.params.zoom.containerClass), w, i);
			}
			a("init", function () {
				if (t.params.zoom.enabled) I();
			});
			a("destroy", function () {
				z();
			});
			a("touchStart", function (e, r) {
				if (!t.zoom.enabled) return;
				b(r);
			});
			a("touchEnd", function (e, r) {
				if (!t.zoom.enabled) return;
				S(r);
			});
			a("doubleTap", function (e, r) {
				if (!t.animating && t.params.zoom.enabled && t.zoom.enabled && t.params.zoom.toggle) C(r);
			});
			a("transitionEnd", function () {
				if (t.zoom.enabled && t.params.zoom.enabled) E();
			});
			a("slideChange", function () {
				if (t.zoom.enabled && t.params.zoom.enabled && t.params.cssMode) E();
			});
			Object.assign(t.zoom, { enable: I, disable: z, in: x, out: T, toggle: C });
		}
		function rl(e) {
			var t = e.swiper,
				r = e.extendParams,
				a = e.on,
				n = e.emit;
			r({ lazy: { checkInView: false, enabled: false, loadPrevNext: false, loadPrevNextAmount: 1, loadOnTransitionStart: false, scrollingElement: "", elementClass: "swiper-lazy", loadingClass: "swiper-lazy-loading", loadedClass: "swiper-lazy-loaded", preloaderClass: "swiper-lazy-preloader" } });
			t.lazy = {};
			var i = false;
			var s = false;
			function o(e) {
				var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
				var a = t.params.lazy;
				if (typeof e === "undefined") return;
				if (t.slides.length === 0) return;
				var i = t.virtual && t.params.virtual.enabled;
				var s = i ? t.$wrapperEl.children(".".concat(t.params.slideClass, '[data-swiper-slide-index="').concat(e, '"]')) : t.slides.eq(e);
				var l = s.find(".".concat(a.elementClass, ":not(.").concat(a.loadedClass, "):not(.").concat(a.loadingClass, ")"));
				if (s.hasClass(a.elementClass) && !s.hasClass(a.loadedClass) && !s.hasClass(a.loadingClass)) l.push(s[0]);
				if (l.length === 0) return;
				l.each(function (e) {
					var i = $(e);
					i.addClass(a.loadingClass);
					var l = i.attr("data-background");
					var f = i.attr("data-src");
					var u = i.attr("data-srcset");
					var c = i.attr("data-sizes");
					var d = i.parent("picture");
					t.loadImage(i[0], f || l, u, c, false, function () {
						if (typeof t === "undefined" || t === null || !t || (t && !t.params) || t.destroyed) return;
						if (l) {
							i.css("background-image", 'url("'.concat(l, '")'));
							i.removeAttr("data-background");
						} else {
							if (u) {
								i.attr("srcset", u);
								i.removeAttr("data-srcset");
							}
							if (c) {
								i.attr("sizes", c);
								i.removeAttr("data-sizes");
							}
							if (d.length)
								d.children("source").each(function (e) {
									var t = $(e);
									if (t.attr("data-srcset")) {
										t.attr("srcset", t.attr("data-srcset"));
										t.removeAttr("data-srcset");
									}
								});
							if (f) {
								i.attr("src", f);
								i.removeAttr("data-src");
							}
						}
						i.addClass(a.loadedClass).removeClass(a.loadingClass);
						s.find(".".concat(a.preloaderClass)).remove();
						if (t.params.loop && r) {
							var e = s.attr("data-swiper-slide-index");
							if (s.hasClass(t.params.slideDuplicateClass)) {
								var p = t.$wrapperEl.children('[data-swiper-slide-index="'.concat(e, '"]:not(.').concat(t.params.slideDuplicateClass, ")"));
								o(p.index(), false);
							} else {
								var v = t.$wrapperEl.children(".".concat(t.params.slideDuplicateClass, '[data-swiper-slide-index="').concat(e, '"]'));
								o(v.index(), false);
							}
						}
						n("lazyImageReady", s[0], i[0]);
						if (t.params.autoHeight) t.updateAutoHeight();
					});
					n("lazyImageLoad", s[0], i[0]);
				});
			}
			function l() {
				var e = t.$wrapperEl,
					r = t.params,
					a = t.slides,
					n = t.activeIndex;
				var i = t.virtual && r.virtual.enabled;
				var l = r.lazy;
				var f = r.slidesPerView;
				if (f === "auto") f = 0;
				function u(t) {
					if (i) {
						if (e.children(".".concat(r.slideClass, '[data-swiper-slide-index="').concat(t, '"]')).length) return true;
					} else if (a[t]) return true;
					return false;
				}
				function c(e) {
					if (i) return $(e).attr("data-swiper-slide-index");
					return $(e).index();
				}
				if (!s) s = true;
				if (t.params.watchSlidesProgress)
					e.children(".".concat(r.slideVisibleClass)).each(function (e) {
						var t = i ? $(e).attr("data-swiper-slide-index") : $(e).index();
						o(t);
					});
				else if (f > 1) {
					for (var d = n; d < n + f; d += 1) if (u(d)) o(d);
				} else o(n);
				if (l.loadPrevNext)
					if (f > 1 || (l.loadPrevNextAmount && l.loadPrevNextAmount > 1)) {
						var p = l.loadPrevNextAmount;
						var v = Math.ceil(f);
						var h = Math.min(n + v + Math.max(p, v), a.length);
						var m = Math.max(n - Math.max(v, p), 0);
						for (var g = n + v; g < h; g += 1) if (u(g)) o(g);
						for (var y = m; y < n; y += 1) if (u(y)) o(y);
					} else {
						var b = e.children(".".concat(r.slideNextClass));
						if (b.length > 0) o(c(b));
						var w = e.children(".".concat(r.slidePrevClass));
						if (w.length > 0) o(c(w));
					}
			}
			function f() {
				var e = getWindow();
				if (!t || t.destroyed) return;
				var r = t.params.lazy.scrollingElement ? $(t.params.lazy.scrollingElement) : $(e);
				var a = r[0] === e;
				var n = a ? e.innerWidth : r[0].offsetWidth;
				var s = a ? e.innerHeight : r[0].offsetHeight;
				var o = t.$el.offset();
				var u = t.rtlTranslate;
				var c = false;
				if (u) o.left -= t.$el[0].scrollLeft;
				var d = [
					[
						o.left,
						o.top,
					],
					[
						o.left + t.width,
						o.top,
					],
					[
						o.left,
						o.top + t.height,
					],
					[
						o.left + t.width,
						o.top + t.height,
					],
				];
				for (var p = 0; p < d.length; p += 1) {
					var v = d[p];
					if (v[0] >= 0 && v[0] <= n && v[1] >= 0 && v[1] <= s) {
						if (v[0] === 0 && v[1] === 0) continue;
						c = true;
					}
				}
				var h = t.touchEvents.start === "touchstart" && t.support.passiveListener && t.params.passiveListeners ? { passive: true, capture: false } : false;
				if (c) {
					l();
					r.off("scroll", f, h);
				} else if (!i) {
					i = true;
					r.on("scroll", f, h);
				}
			}
			a("beforeInit", function () {
				if (t.params.lazy.enabled && t.params.preloadImages) t.params.preloadImages = false;
			});
			a("init", function () {
				if (t.params.lazy.enabled)
					if (t.params.lazy.checkInView) f();
					else l();
			});
			a("scroll", function () {
				if (t.params.freeMode && t.params.freeMode.enabled && !t.params.freeMode.sticky) l();
			});
			a("scrollbarDragMove resize _freeModeNoMomentumRelease", function () {
				if (t.params.lazy.enabled)
					if (t.params.lazy.checkInView) f();
					else l();
			});
			a("transitionStart", function () {
				if (t.params.lazy.enabled)
					if (t.params.lazy.loadOnTransitionStart || (!t.params.lazy.loadOnTransitionStart && !s))
						if (t.params.lazy.checkInView) f();
						else l();
			});
			a("transitionEnd", function () {
				if (t.params.lazy.enabled && !t.params.lazy.loadOnTransitionStart)
					if (t.params.lazy.checkInView) f();
					else l();
			});
			a("slideChange", function () {
				var e = t.params,
					r = e.lazy,
					a = e.cssMode,
					n = e.watchSlidesProgress,
					i = e.touchReleaseOnEdges,
					s = e.resistanceRatio;
				if (r.enabled && (a || (n && (i || s === 0)))) l();
			});
			a("destroy", function () {
				if (!t.$el) return;
				t.$el.find(".".concat(t.params.lazy.loadingClass)).removeClass(t.params.lazy.loadingClass);
			});
			Object.assign(t.lazy, { load: l, loadInSlide: o });
		}
		function al(e) {
			var t = e.swiper,
				r = e.extendParams,
				a = e.on;
			r({ controller: { control: void 0, inverse: false, by: "slide" } });
			t.controller = { control: void 0 };
			function n(e, t) {
				var r = (function e() {
					var t;
					var r;
					var a;
					return function (e, n) {
						r = -1;
						t = e.length;
						while (t - r > 1) {
							a = (t + r) >> 1;
							if (e[a] <= n) r = a;
							else t = a;
						}
						return t;
					};
				})();
				this.x = e;
				this.y = t;
				this.lastIndex = e.length - 1;
				var a;
				var n;
				this.interpolate = function e(t) {
					if (!t) return 0;
					n = r(this.x, t);
					a = n - 1;
					return ((t - this.x[a]) * (this.y[n] - this.y[a])) / (this.x[n] - this.x[a]) + this.y[a];
				};
				return this;
			}
			function i(e) {
				if (!t.controller.spline) t.controller.spline = t.params.loop ? new n(t.slidesGrid, e.slidesGrid) : new n(t.snapGrid, e.snapGrid);
			}
			function s(e, r) {
				var a = t.controller.control;
				var n;
				var s;
				var o = t.constructor;
				function l(e) {
					var r = t.rtlTranslate ? -t.translate : t.translate;
					if (t.params.controller.by === "slide") {
						i(e);
						s = -t.controller.spline.interpolate(-r);
					}
					if (!s || t.params.controller.by === "container") {
						n = (e.maxTranslate() - e.minTranslate()) / (t.maxTranslate() - t.minTranslate());
						s = (r - t.minTranslate()) * n + e.minTranslate();
					}
					if (t.params.controller.inverse) s = e.maxTranslate() - s;
					e.updateProgress(s);
					e.setTranslate(s, t);
					e.updateActiveIndex();
					e.updateSlidesClasses();
				}
				if (Array.isArray(a)) {
					for (var f = 0; f < a.length; f += 1) if (a[f] !== r && a[f] instanceof o) l(a[f]);
				} else if (a instanceof o && r !== a) l(a);
			}
			function o(e, r) {
				var a = t.constructor;
				var n = t.controller.control;
				var i;
				function s(r) {
					r.setTransition(e, t);
					if (e !== 0) {
						r.transitionStart();
						if (r.params.autoHeight)
							Ci(function () {
								r.updateAutoHeight();
							});
						r.$wrapperEl.transitionEnd(function () {
							if (!n) return;
							if (r.params.loop && t.params.controller.by === "slide") r.loopFix();
							r.transitionEnd();
						});
					}
				}
				if (Array.isArray(n)) {
					for (i = 0; i < n.length; i += 1) if (n[i] !== r && n[i] instanceof a) s(n[i]);
				} else if (n instanceof a && r !== n) s(n);
			}
			function l() {
				if (!t.controller.control) return;
				if (t.controller.spline) {
					t.controller.spline = void 0;
					delete t.controller.spline;
				}
			}
			a("beforeInit", function () {
				t.controller.control = t.params.controller.control;
			});
			a("update", function () {
				l();
			});
			a("resize", function () {
				l();
			});
			a("observerUpdate", function () {
				l();
			});
			a("setTranslate", function (e, r, a) {
				if (!t.controller.control) return;
				t.controller.setTranslate(r, a);
			});
			a("setTransition", function (e, r, a) {
				if (!t.controller.control) return;
				t.controller.setTransition(r, a);
			});
			Object.assign(t.controller, { setTranslate: s, setTransition: o });
		}
		function nl(e) {
			var t = e.swiper,
				r = e.extendParams,
				a = e.on;
			r({
				a11y: {
					enabled: true,
					notificationClass: "swiper-notification",
					prevSlideMessage: "Previous slide",
					nextSlideMessage: "Next slide",
					firstSlideMessage: "This is the first slide",
					lastSlideMessage: "This is the last slide",
					paginationBulletMessage: "Go to slide {{index}}",
					slideLabelMessage: "{{index}} / {{slidesLength}}",
					containerMessage: null,
					containerRoleDescriptionMessage: null,
					itemRoleDescriptionMessage: null,
					slideRole: "group",
					id: null,
				},
			});
			t.a11y = { clicked: false };
			var n = null;
			function i(e) {
				var t = n;
				if (t.length === 0) return;
				t.html("");
				t.html(e);
			}
			function s() {
				var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 16;
				var t = function e() {
					return Math.round(16 * Math.random()).toString(16);
				};
				return "x".repeat(e).replace(/x/g, t);
			}
			function o(e) {
				e.attr("tabIndex", "0");
			}
			function l(e) {
				e.attr("tabIndex", "-1");
			}
			function f(e, t) {
				e.attr("role", t);
			}
			function u(e, t) {
				e.attr("aria-roledescription", t);
			}
			function c(e, t) {
				e.attr("aria-controls", t);
			}
			function d(e, t) {
				e.attr("aria-label", t);
			}
			function p(e, t) {
				e.attr("id", t);
			}
			function v(e, t) {
				e.attr("aria-live", t);
			}
			function h(e) {
				e.attr("aria-disabled", true);
			}
			function m(e) {
				e.attr("aria-disabled", false);
			}
			function g(e) {
				if (e.keyCode !== 13 && e.keyCode !== 32) return;
				var r = t.params.a11y;
				var a = bi(e.target);
				if (t.navigation && t.navigation.$nextEl && a.is(t.navigation.$nextEl)) {
					if (!(t.isEnd && !t.params.loop)) t.slideNext();
					if (t.isEnd) i(r.lastSlideMessage);
					else i(r.nextSlideMessage);
				}
				if (t.navigation && t.navigation.$prevEl && a.is(t.navigation.$prevEl)) {
					if (!(t.isBeginning && !t.params.loop)) t.slidePrev();
					if (t.isBeginning) i(r.firstSlideMessage);
					else i(r.prevSlideMessage);
				}
				if (t.pagination && a.is(Zo(t.params.pagination.bulletClass))) a[0].click();
			}
			function y() {
				if (t.params.loop || t.params.rewind || !t.navigation) return;
				var e = t.navigation,
					r = e.$nextEl,
					a = e.$prevEl;
				if (a && a.length > 0)
					if (t.isBeginning) {
						h(a);
						l(a);
					} else {
						m(a);
						o(a);
					}
				if (r && r.length > 0)
					if (t.isEnd) {
						h(r);
						l(r);
					} else {
						m(r);
						o(r);
					}
			}
			function b() {
				return t.pagination && t.pagination.bullets && t.pagination.bullets.length;
			}
			function w() {
				return b() && t.params.pagination.clickable;
			}
			function S() {
				var e = t.params.a11y;
				if (!b()) return;
				t.pagination.bullets.each(function (r) {
					var a = bi(r);
					if (t.params.pagination.clickable) {
						o(a);
						if (!t.params.pagination.renderBullet) {
							f(a, "button");
							d(a, e.paginationBulletMessage.replace(/\{\{index\}\}/, a.index() + 1));
						}
					}
					if (a.is(".".concat(t.params.pagination.bulletActiveClass))) a.attr("aria-current", "true");
					else a.removeAttr("aria-current");
				});
			}
			var E = function e(t, r, a) {
				o(t);
				if (t[0].tagName !== "BUTTON") {
					f(t, "button");
					t.on("keydown", g);
				}
				d(t, a);
				c(t, r);
			};
			var x = function e() {
				t.a11y.clicked = true;
			};
			var T = function e() {
				requestAnimationFrame(function () {
					requestAnimationFrame(function () {
						if (!t.destroyed) t.a11y.clicked = false;
					});
				});
			};
			var C = function e(r) {
				if (t.a11y.clicked) return;
				var a = r.target.closest(".".concat(t.params.slideClass));
				if (!a || !t.slides.includes(a)) return;
				var n = t.slides.indexOf(a) === t.activeIndex;
				var i = t.params.watchSlidesProgress && t.visibleSlides && t.visibleSlides.includes(a);
				if (n || i) return;
				if (r.sourceCapabilities && r.sourceCapabilities.firesTouchEvents) return;
				if (t.isHorizontal()) t.el.scrollLeft = 0;
				else t.el.scrollTop = 0;
				t.slideTo(t.slides.indexOf(a), 0);
			};
			var M = function e() {
				var r = t.params.a11y;
				if (r.itemRoleDescriptionMessage) u(bi(t.slides), r.itemRoleDescriptionMessage);
				if (r.slideRole) f(bi(t.slides), r.slideRole);
				var a = t.params.loop
					? t.slides.filter(function (e) {
							return !e.classList.contains(t.params.slideDuplicateClass);
						}).length
					: t.slides.length;
				if (r.slideLabelMessage)
					t.slides.each(function (e, n) {
						var i = bi(e);
						var s = t.params.loop ? parseInt(i.attr("data-swiper-slide-index"), 10) : n;
						var o = r.slideLabelMessage.replace(/\{\{index\}\}/, s + 1).replace(/\{\{slidesLength\}\}/, a);
						d(i, o);
					});
			};
			var P = function e() {
				var r = t.params.a11y;
				t.$el.append(n);
				var a = t.$el;
				if (r.containerRoleDescriptionMessage) u(a, r.containerRoleDescriptionMessage);
				if (r.containerMessage) d(a, r.containerMessage);
				var i = t.$wrapperEl;
				var o = r.id || i.attr("id") || "swiper-wrapper-".concat(s(16));
				var l = t.params.autoplay && t.params.autoplay.enabled ? "off" : "polite";
				p(i, o);
				v(i, l);
				M();
				var f;
				var c;
				if (t.navigation && t.navigation.$nextEl) f = t.navigation.$nextEl;
				if (t.navigation && t.navigation.$prevEl) c = t.navigation.$prevEl;
				if (f && f.length) E(f, o, r.nextSlideMessage);
				if (c && c.length) E(c, o, r.prevSlideMessage);
				if (w()) t.pagination.$el.on("keydown", Zo(t.params.pagination.bulletClass), g);
				t.$el.on("focus", C, true);
				t.$el.on("pointerdown", x, true);
				t.$el.on("pointerup", T, true);
			};
			function O() {
				if (n && n.length > 0) n.remove();
				var e;
				var r;
				if (t.navigation && t.navigation.$nextEl) e = t.navigation.$nextEl;
				if (t.navigation && t.navigation.$prevEl) r = t.navigation.$prevEl;
				if (e) e.off("keydown", g);
				if (r) r.off("keydown", g);
				if (w()) t.pagination.$el.off("keydown", Zo(t.params.pagination.bulletClass), g);
				t.$el.off("focus", C, true);
				t.$el.off("pointerdown", x, true);
				t.$el.off("pointerup", T, true);
			}
			a("beforeInit", function () {
				n = bi('<span class="'.concat(t.params.a11y.notificationClass, '" aria-live="assertive" aria-atomic="true"></span>'));
			});
			a("afterInit", function () {
				if (!t.params.a11y.enabled) return;
				P();
			});
			a("slidesLengthChange snapGridLengthChange slidesGridLengthChange", function () {
				if (!t.params.a11y.enabled) return;
				M();
			});
			a("fromEdge toEdge afterInit lock unlock", function () {
				if (!t.params.a11y.enabled) return;
				y();
			});
			a("paginationUpdate", function () {
				if (!t.params.a11y.enabled) return;
				S();
			});
			a("destroy", function () {
				if (!t.params.a11y.enabled) return;
				O();
			});
		}
		function il(e) {
			var t = e.swiper,
				r = e.extendParams,
				a = e.on;
			r({ history: { enabled: false, root: "", replaceState: false, key: "slides", keepQuery: false } });
			var n = false;
			var i = {};
			var s = function e(t) {
				return t
					.toString()
					.replace(/\s+/g, "-")
					.replace(/[^\w-]+/g, "")
					.replace(/--+/g, "-")
					.replace(/^-+/, "")
					.replace(/-+$/, "");
			};
			var o = function e(t) {
				var r = getWindow();
				var a;
				if (t) a = new URL(t);
				else a = r.location;
				var n = a.pathname
					.slice(1)
					.split("/")
					.filter(function (e) {
						return e !== "";
					});
				var i = n.length;
				var s = n[i - 2];
				var o = n[i - 1];
				return { key: s, value: o };
			};
			var l = function e(r, a) {
				var i = getWindow();
				if (!n || !t.params.history.enabled) return;
				var o;
				if (t.params.url) o = new URL(t.params.url);
				else o = i.location;
				var l = t.slides.eq(a);
				var f = s(l.attr("data-history"));
				if (t.params.history.root.length > 0) {
					var u = t.params.history.root;
					if (u[u.length - 1] === "/") u = u.slice(0, u.length - 1);
					f = "".concat(u, "/").concat(r, "/").concat(f);
				} else if (!o.pathname.includes(r)) f = "".concat(r, "/").concat(f);
				if (t.params.history.keepQuery) f += o.search;
				var c = i.history.state;
				if (c && c.value === f) return;
				if (t.params.history.replaceState) i.history.replaceState({ value: f }, null, f);
				else i.history.pushState({ value: f }, null, f);
			};
			var f = function e(r, a, n) {
				if (a)
					for (var i = 0, o = t.slides.length; i < o; i += 1) {
						var l = t.slides.eq(i);
						var f = s(l.attr("data-history"));
						if (f === a && !l.hasClass(t.params.slideDuplicateClass)) {
							var u = l.index();
							t.slideTo(u, r, n);
						}
					}
				else t.slideTo(0, r, n);
			};
			var u = function e() {
				i = o(t.params.url);
				f(t.params.speed, i.value, false);
			};
			var c = function e() {
				var r = getWindow();
				if (!t.params.history) return;
				if (!r.history || !r.history.pushState) {
					t.params.history.enabled = false;
					t.params.hashNavigation.enabled = true;
					return;
				}
				n = true;
				i = o(t.params.url);
				if (!i.key && !i.value) return;
				f(0, i.value, t.params.runCallbacksOnInit);
				if (!t.params.history.replaceState) r.addEventListener("popstate", u);
			};
			var d = function e() {
				var r = getWindow();
				if (!t.params.history.replaceState) r.removeEventListener("popstate", u);
			};
			a("init", function () {
				if (t.params.history.enabled) c();
			});
			a("destroy", function () {
				if (t.params.history.enabled) d();
			});
			a("transitionEnd _freeModeNoMomentumRelease", function () {
				if (n) l(t.params.history.key, t.activeIndex);
			});
			a("slideChange", function () {
				if (n && t.params.cssMode) l(t.params.history.key, t.activeIndex);
			});
		}
		function sl(e) {
			var t = e.swiper,
				r = e.extendParams,
				a = e.emit,
				n = e.on;
			var i = false;
			var s = getDocument();
			var o = getWindow();
			r({ hashNavigation: { enabled: false, replaceState: false, watchState: false } });
			var l = function e() {
				a("hashChange");
				var r = s.location.hash.replace("#", "");
				var n = t.slides.eq(t.activeIndex).attr("data-hash");
				if (r !== n) {
					var i = t.$wrapperEl.children(".".concat(t.params.slideClass, '[data-hash="').concat(r, '"]')).index();
					if (typeof i === "undefined") return;
					t.slideTo(i);
				}
			};
			var f = function e() {
				if (!i || !t.params.hashNavigation.enabled) return;
				if (t.params.hashNavigation.replaceState && o.history && o.history.replaceState) {
					o.history.replaceState(null, null, "#".concat(t.slides.eq(t.activeIndex).attr("data-hash")) || 0);
					a("hashSet");
				} else {
					var r = t.slides.eq(t.activeIndex);
					var n = r.attr("data-hash") || r.attr("data-history");
					s.location.hash = n || "";
					a("hashSet");
				}
			};
			var u = function e() {
				if (!t.params.hashNavigation.enabled || (t.params.history && t.params.history.enabled)) return;
				i = true;
				var r = s.location.hash.replace("#", "");
				if (r) {
					var a = 0;
					for (var n = 0, f = t.slides.length; n < f; n += 1) {
						var u = t.slides.eq(n);
						var c = u.attr("data-hash") || u.attr("data-history");
						if (c === r && !u.hasClass(t.params.slideDuplicateClass)) {
							var d = u.index();
							t.slideTo(d, a, t.params.runCallbacksOnInit, true);
						}
					}
				}
				if (t.params.hashNavigation.watchState) $(o).on("hashchange", l);
			};
			var c = function e() {
				if (t.params.hashNavigation.watchState) $(o).off("hashchange", l);
			};
			n("init", function () {
				if (t.params.hashNavigation.enabled) u();
			});
			n("destroy", function () {
				if (t.params.hashNavigation.enabled) c();
			});
			n("transitionEnd _freeModeNoMomentumRelease", function () {
				if (i) f();
			});
			n("slideChange", function () {
				if (i && t.params.cssMode) f();
			});
		}
		function ol(e) {
			var t = e.swiper,
				r = e.extendParams,
				a = e.on,
				n = e.emit;
			var i;
			t.autoplay = { running: false, paused: false };
			r({ autoplay: { enabled: false, delay: 3e3, waitForTransition: true, disableOnInteraction: true, stopOnLastSlide: false, reverseDirection: false, pauseOnMouseEnter: false } });
			function s() {
				if (!t.size) {
					t.autoplay.running = false;
					t.autoplay.paused = false;
					return;
				}
				var e = t.slides.eq(t.activeIndex);
				var r = t.params.autoplay.delay;
				if (e.attr("data-swiper-autoplay")) r = e.attr("data-swiper-autoplay") || t.params.autoplay.delay;
				clearTimeout(i);
				i = Ci(function () {
					var e;
					if (t.params.autoplay.reverseDirection)
						if (t.params.loop) {
							t.loopFix();
							e = t.slidePrev(t.params.speed, true, true);
							n("autoplay");
						} else if (!t.isBeginning) {
							e = t.slidePrev(t.params.speed, true, true);
							n("autoplay");
						} else if (!t.params.autoplay.stopOnLastSlide) {
							e = t.slideTo(t.slides.length - 1, t.params.speed, true, true);
							n("autoplay");
						} else l();
					else if (t.params.loop) {
						t.loopFix();
						e = t.slideNext(t.params.speed, true, true);
						n("autoplay");
					} else if (!t.isEnd) {
						e = t.slideNext(t.params.speed, true, true);
						n("autoplay");
					} else if (!t.params.autoplay.stopOnLastSlide) {
						e = t.slideTo(0, t.params.speed, true, true);
						n("autoplay");
					} else l();
					if (t.params.cssMode && t.autoplay.running) s();
					else if (e === false) s();
				}, r);
			}
			function o() {
				if (typeof i !== "undefined") return false;
				if (t.autoplay.running) return false;
				t.autoplay.running = true;
				n("autoplayStart");
				s();
				return true;
			}
			function l() {
				if (!t.autoplay.running) return false;
				if (typeof i === "undefined") return false;
				if (i) {
					clearTimeout(i);
					i = void 0;
				}
				t.autoplay.running = false;
				n("autoplayStop");
				return true;
			}
			function f(e) {
				if (!t.autoplay.running) return;
				if (t.autoplay.paused) return;
				if (i) clearTimeout(i);
				t.autoplay.paused = true;
				if (e === 0 || !t.params.autoplay.waitForTransition) {
					t.autoplay.paused = false;
					s();
				} else
					[
						"transitionend",
						"webkitTransitionEnd",
					].forEach(function (e) {
						t.$wrapperEl[0].addEventListener(e, c);
					});
			}
			function u() {
				var e = ia();
				if (e.visibilityState === "hidden" && t.autoplay.running) f();
				if (e.visibilityState === "visible" && t.autoplay.paused) {
					s();
					t.autoplay.paused = false;
				}
			}
			function c(e) {
				if (!t || t.destroyed || !t.$wrapperEl) return;
				if (e.target !== t.$wrapperEl[0]) return;
				[
					"transitionend",
					"webkitTransitionEnd",
				].forEach(function (e) {
					t.$wrapperEl[0].removeEventListener(e, c);
				});
				t.autoplay.paused = false;
				if (!t.autoplay.running) l();
				else s();
			}
			function d() {
				if (t.params.autoplay.disableOnInteraction) l();
				else {
					n("autoplayPause");
					f();
				}
				[
					"transitionend",
					"webkitTransitionEnd",
				].forEach(function (e) {
					t.$wrapperEl[0].removeEventListener(e, c);
				});
			}
			function p() {
				if (t.params.autoplay.disableOnInteraction) return;
				t.autoplay.paused = false;
				n("autoplayResume");
				s();
			}
			function v() {
				if (t.params.autoplay.pauseOnMouseEnter) {
					t.$el.on("mouseenter", d);
					t.$el.on("mouseleave", p);
				}
			}
			function h() {
				t.$el.off("mouseenter", d);
				t.$el.off("mouseleave", p);
			}
			a("init", function () {
				if (t.params.autoplay.enabled) {
					o();
					var e = ia();
					e.addEventListener("visibilitychange", u);
					v();
				}
			});
			a("beforeTransitionStart", function (e, r, a) {
				if (t.autoplay.running)
					if (a || !t.params.autoplay.disableOnInteraction) t.autoplay.pause(r);
					else l();
			});
			a("sliderFirstMove", function () {
				if (t.autoplay.running)
					if (t.params.autoplay.disableOnInteraction) l();
					else f();
			});
			a("touchEnd", function () {
				if (t.params.cssMode && t.autoplay.paused && !t.params.autoplay.disableOnInteraction) s();
			});
			a("destroy", function () {
				h();
				if (t.autoplay.running) l();
				var e = ia();
				e.removeEventListener("visibilitychange", u);
			});
			Object.assign(t.autoplay, { pause: f, run: s, start: o, stop: l });
		}
		function ll(e) {
			var t = e.swiper,
				r = e.extendParams,
				a = e.on;
			r({ thumbs: { swiper: null, multipleActiveThumbs: true, autoScrollOffset: 0, slideThumbActiveClass: "swiper-slide-thumb-active", thumbsContainerClass: "swiper-thumbs" } });
			var n = false;
			var i = false;
			t.thumbs = { swiper: null };
			function s() {
				var e = t.thumbs.swiper;
				if (!e || e.destroyed) return;
				var r = e.clickedIndex;
				var a = e.clickedSlide;
				if (a && bi(a).hasClass(t.params.thumbs.slideThumbActiveClass)) return;
				if (typeof r === "undefined" || r === null) return;
				var n;
				if (e.params.loop) n = parseInt(bi(e.clickedSlide).attr("data-swiper-slide-index"), 10);
				else n = r;
				if (t.params.loop) {
					var i = t.activeIndex;
					if (t.slides.eq(i).hasClass(t.params.slideDuplicateClass)) {
						t.loopFix();
						t._clientLeft = t.$wrapperEl[0].clientLeft;
						i = t.activeIndex;
					}
					var s = t.slides.eq(i).prevAll('[data-swiper-slide-index="'.concat(n, '"]')).eq(0).index();
					var o = t.slides.eq(i).nextAll('[data-swiper-slide-index="'.concat(n, '"]')).eq(0).index();
					if (typeof s === "undefined") n = o;
					else if (typeof o === "undefined") n = s;
					else if (o - i < i - s) n = o;
					else n = s;
				}
				t.slideTo(n);
			}
			function o() {
				var e = t.params.thumbs;
				if (n) return false;
				n = true;
				var r = t.constructor;
				if (e.swiper instanceof r) {
					t.thumbs.swiper = e.swiper;
					Object.assign(t.thumbs.swiper.originalParams, { watchSlidesProgress: true, slideToClickedSlide: false });
					Object.assign(t.thumbs.swiper.params, { watchSlidesProgress: true, slideToClickedSlide: false });
				} else if (ki(e.swiper)) {
					var a = Object.assign({}, e.swiper);
					Object.assign(a, { watchSlidesProgress: true, slideToClickedSlide: false });
					t.thumbs.swiper = new r(a);
					i = true;
				}
				t.thumbs.swiper.$el.addClass(t.params.thumbs.thumbsContainerClass);
				t.thumbs.swiper.on("tap", s);
				return true;
			}
			function l(e) {
				var r = t.thumbs.swiper;
				if (!r || r.destroyed) return;
				var a = r.params.slidesPerView === "auto" ? r.slidesPerViewDynamic() : r.params.slidesPerView;
				var n = 1;
				var i = t.params.thumbs.slideThumbActiveClass;
				if (t.params.slidesPerView > 1 && !t.params.centeredSlides) n = t.params.slidesPerView;
				if (!t.params.thumbs.multipleActiveThumbs) n = 1;
				n = Math.floor(n);
				r.slides.removeClass(i);
				if (r.params.loop || (r.params.virtual && r.params.virtual.enabled)) for (var s = 0; s < n; s += 1) r.$wrapperEl.children('[data-swiper-slide-index="'.concat(t.realIndex + s, '"]')).addClass(i);
				else for (var o = 0; o < n; o += 1) r.slides.eq(t.realIndex + o).addClass(i);
				var l = t.params.thumbs.autoScrollOffset;
				var f = l && !r.params.loop;
				if (t.realIndex !== r.realIndex || f) {
					var u = r.activeIndex;
					var c;
					var d;
					if (r.params.loop) {
						if (r.slides.eq(u).hasClass(r.params.slideDuplicateClass)) {
							r.loopFix();
							r._clientLeft = r.$wrapperEl[0].clientLeft;
							u = r.activeIndex;
						}
						var p = r.slides.eq(u).prevAll('[data-swiper-slide-index="'.concat(t.realIndex, '"]')).eq(0).index();
						var v = r.slides.eq(u).nextAll('[data-swiper-slide-index="'.concat(t.realIndex, '"]')).eq(0).index();
						if (typeof p === "undefined") c = v;
						else if (typeof v === "undefined") c = p;
						else if (v - u === u - p) c = r.params.slidesPerGroup > 1 ? v : u;
						else if (v - u < u - p) c = v;
						else c = p;
						d = t.activeIndex > t.previousIndex ? "next" : "prev";
					} else {
						c = t.realIndex;
						d = c > t.previousIndex ? "next" : "prev";
					}
					if (f) c += d === "next" ? l : -1 * l;
					if (r.visibleSlidesIndexes && r.visibleSlidesIndexes.indexOf(c) < 0) {
						if (r.params.centeredSlides)
							if (c > u) c = c - Math.floor(a / 2) + 1;
							else c = c + Math.floor(a / 2) - 1;
						else if (c > u && r.params.slidesPerGroup === 1);
						r.slideTo(c, e ? 0 : void 0);
					}
				}
			}
			a("beforeInit", function () {
				var e = t.params.thumbs;
				if (!e || !e.swiper) return;
				o();
				l(true);
			});
			a("slideChange update resize observerUpdate", function () {
				l();
			});
			a("setTransition", function (e, r) {
				var a = t.thumbs.swiper;
				if (!a || a.destroyed) return;
				a.setTransition(r);
			});
			a("beforeDestroy", function () {
				var e = t.thumbs.swiper;
				if (!e || e.destroyed) return;
				if (i) e.destroy();
			});
			Object.assign(t.thumbs, { init: o, update: l });
		}
		function fl(e) {
			var t = e.swiper,
				r = e.extendParams,
				a = e.emit,
				n = e.once;
			r({ freeMode: { enabled: false, momentum: true, momentumRatio: 1, momentumBounce: true, momentumBounceRatio: 1, momentumVelocityRatio: 1, sticky: false, minimumVelocity: 0.02 } });
			function i() {
				var e = t.getTranslate();
				t.setTranslate(e);
				t.setTransition(0);
				t.touchEventsData.velocities.length = 0;
				t.freeMode.onTouchEnd({ currentPos: t.rtl ? t.translate : -t.translate });
			}
			function s() {
				var e = t.touchEventsData,
					r = t.touches;
				if (e.velocities.length === 0) e.velocities.push({ position: r[t.isHorizontal() ? "startX" : "startY"], time: e.touchStartTime });
				e.velocities.push({ position: r[t.isHorizontal() ? "currentX" : "currentY"], time: now() });
			}
			function o(e) {
				var r = e.currentPos;
				var i = t.params,
					s = t.$wrapperEl,
					o = t.rtlTranslate,
					l = t.snapGrid,
					f = t.touchEventsData;
				var u = now();
				var c = u - f.touchStartTime;
				if (r < -t.minTranslate()) {
					t.slideTo(t.activeIndex);
					return;
				}
				if (r > -t.maxTranslate()) {
					if (t.slides.length < l.length) t.slideTo(l.length - 1);
					else t.slideTo(t.slides.length - 1);
					return;
				}
				if (i.freeMode.momentum) {
					if (f.velocities.length > 1) {
						var d = f.velocities.pop();
						var p = f.velocities.pop();
						var v = d.position - p.position;
						var h = d.time - p.time;
						t.velocity = v / h;
						t.velocity /= 2;
						if (Math.abs(t.velocity) < i.freeMode.minimumVelocity) t.velocity = 0;
						if (h > 150 || now() - d.time > 300) t.velocity = 0;
					} else t.velocity = 0;
					t.velocity *= i.freeMode.momentumVelocityRatio;
					f.velocities.length = 0;
					var m = 1e3 * i.freeMode.momentumRatio;
					var g = t.velocity * m;
					var y = t.translate + g;
					if (o) y = -y;
					var b = false;
					var w;
					var S = Math.abs(t.velocity) * 20 * i.freeMode.momentumBounceRatio;
					var E;
					if (y < t.maxTranslate()) {
						if (i.freeMode.momentumBounce) {
							if (y + t.maxTranslate() < -S) y = t.maxTranslate() - S;
							w = t.maxTranslate();
							b = true;
							f.allowMomentumBounce = true;
						} else y = t.maxTranslate();
						if (i.loop && i.centeredSlides) E = true;
					} else if (y > t.minTranslate()) {
						if (i.freeMode.momentumBounce) {
							if (y - t.minTranslate() > S) y = t.minTranslate() + S;
							w = t.minTranslate();
							b = true;
							f.allowMomentumBounce = true;
						} else y = t.minTranslate();
						if (i.loop && i.centeredSlides) E = true;
					} else if (i.freeMode.sticky) {
						var x;
						for (var T = 0; T < l.length; T += 1)
							if (l[T] > -y) {
								x = T;
								break;
							}
						if (Math.abs(l[x] - y) < Math.abs(l[x - 1] - y) || t.swipeDirection === "next") y = l[x];
						else y = l[x - 1];
						y = -y;
					}
					if (E)
						n("transitionEnd", function () {
							t.loopFix();
						});
					if (t.velocity !== 0) {
						if (o) m = Math.abs((-y - t.translate) / t.velocity);
						else m = Math.abs((y - t.translate) / t.velocity);
						if (i.freeMode.sticky) {
							var C = Math.abs((o ? -y : y) - t.translate);
							var M = t.slidesSizesGrid[t.activeIndex];
							if (C < M) m = i.speed;
							else if (C < 2 * M) m = i.speed * 1.5;
							else m = i.speed * 2.5;
						}
					} else if (i.freeMode.sticky) {
						t.slideToClosest();
						return;
					}
					if (i.freeMode.momentumBounce && b) {
						t.updateProgress(w);
						t.setTransition(m);
						t.setTranslate(y);
						t.transitionStart(true, t.swipeDirection);
						t.animating = true;
						s.transitionEnd(function () {
							if (!t || t.destroyed || !f.allowMomentumBounce) return;
							a("momentumBounce");
							t.setTransition(i.speed);
							setTimeout(function () {
								t.setTranslate(w);
								s.transitionEnd(function () {
									if (!t || t.destroyed) return;
									t.transitionEnd();
								});
							}, 0);
						});
					} else if (t.velocity) {
						a("_freeModeNoMomentumRelease");
						t.updateProgress(y);
						t.setTransition(m);
						t.setTranslate(y);
						t.transitionStart(true, t.swipeDirection);
						if (!t.animating) {
							t.animating = true;
							s.transitionEnd(function () {
								if (!t || t.destroyed) return;
								t.transitionEnd();
							});
						}
					} else t.updateProgress(y);
					t.updateActiveIndex();
					t.updateSlidesClasses();
				} else if (i.freeMode.sticky) {
					t.slideToClosest();
					return;
				} else if (i.freeMode) a("_freeModeNoMomentumRelease");
				if (!i.freeMode.momentum || c >= i.longSwipesMs) {
					t.updateProgress();
					t.updateActiveIndex();
					t.updateSlidesClasses();
				}
			}
			Object.assign(t, { freeMode: { onTouchStart: i, onTouchMove: s, onTouchEnd: o } });
		}
		function ul(e) {
			var t = e.effect,
				r = e.swiper,
				a = e.on,
				n = e.setTranslate,
				i = e.setTransition,
				s = e.overwriteParams,
				o = e.perspective,
				l = e.recreateShadows,
				f = e.getEffectParams;
			a("beforeInit", function () {
				if (r.params.effect !== t) return;
				r.classNames.push("".concat(r.params.containerModifierClass).concat(t));
				if (o && o()) r.classNames.push("".concat(r.params.containerModifierClass, "3d"));
				var e = s ? s() : {};
				Object.assign(r.params, e);
				Object.assign(r.originalParams, e);
			});
			a("setTranslate", function () {
				if (r.params.effect !== t) return;
				n();
			});
			a("setTransition", function (e, a) {
				if (r.params.effect !== t) return;
				i(a);
			});
			a("transitionEnd", function () {
				if (r.params.effect !== t) return;
				if (l) {
					if (!f || !f().slideShadows) return;
					r.slides.each(function (e) {
						var t = r.$(e);
						t.find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").remove();
					});
					l();
				}
			});
			var u;
			a("virtualUpdate", function () {
				if (r.params.effect !== t) return;
				if (!r.slides.length) u = true;
				requestAnimationFrame(function () {
					if (u && r.slides && r.slides.length) {
						n();
						u = false;
					}
				});
			});
		}
		function cl(e, t) {
			if (e.transformEl) return t.find(e.transformEl).css({ "backface-visibility": "hidden", "-webkit-backface-visibility": "hidden" });
			return t;
		}
		function dl(e) {
			var t = e.swiper,
				r = e.duration,
				a = e.transformEl,
				n = e.allSlides;
			var i = t.slides,
				s = t.activeIndex,
				o = t.$wrapperEl;
			if (t.params.virtualTranslate && r !== 0) {
				var l = false;
				var f;
				if (n) f = a ? i.find(a) : i;
				else f = a ? i.eq(s).find(a) : i.eq(s);
				f.transitionEnd(function () {
					if (l) return;
					if (!t || t.destroyed) return;
					l = true;
					t.animating = false;
					var e = [
						"webkitTransitionEnd",
						"transitionend",
					];
					for (var r = 0; r < e.length; r += 1) o.trigger(e[r]);
				});
			}
		}
		function pl(e) {
			var t = e.swiper,
				r = e.extendParams,
				a = e.on;
			r({ fadeEffect: { crossFade: false, transformEl: null } });
			var n = function e() {
				var r = t.slides;
				var a = t.params.fadeEffect;
				for (var n = 0; n < r.length; n += 1) {
					var i = t.slides.eq(n);
					var s = i[0].swiperSlideOffset;
					var o = -s;
					if (!t.params.virtualTranslate) o -= t.translate;
					var l = 0;
					if (!t.isHorizontal()) {
						l = o;
						o = 0;
					}
					var f = t.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(i[0].progress), 0) : 1 + Math.min(Math.max(i[0].progress, -1), 0);
					var u = cl(a, i);
					u.css({ opacity: f }).transform("translate3d(".concat(o, "px, ").concat(l, "px, 0px)"));
				}
			};
			var i = function e(r) {
				var a = t.params.fadeEffect.transformEl;
				var n = a ? t.slides.find(a) : t.slides;
				n.transition(r);
				dl({ swiper: t, duration: r, transformEl: a, allSlides: true });
			};
			ul({
				effect: "fade",
				swiper: t,
				on: a,
				setTranslate: n,
				setTransition: i,
				overwriteParams: function e() {
					return { slidesPerView: 1, slidesPerGroup: 1, watchSlidesProgress: true, spaceBetween: 0, virtualTranslate: !t.params.cssMode };
				},
			});
		}
		function vl(e) {
			var t = e.swiper,
				r = e.extendParams,
				a = e.on;
			r({ cubeEffect: { slideShadows: true, shadow: true, shadowOffset: 20, shadowScale: 0.94 } });
			var n = function e(t, r, a) {
				var n = a ? t.find(".swiper-slide-shadow-left") : t.find(".swiper-slide-shadow-top");
				var i = a ? t.find(".swiper-slide-shadow-right") : t.find(".swiper-slide-shadow-bottom");
				if (n.length === 0) {
					n = $('<div class="swiper-slide-shadow-'.concat(a ? "left" : "top", '"></div>'));
					t.append(n);
				}
				if (i.length === 0) {
					i = $('<div class="swiper-slide-shadow-'.concat(a ? "right" : "bottom", '"></div>'));
					t.append(i);
				}
				if (n.length) n[0].style.opacity = Math.max(-r, 0);
				if (i.length) i[0].style.opacity = Math.max(r, 0);
			};
			var i = function e() {
				var r = t.isHorizontal();
				t.slides.each(function (e) {
					var t = Math.max(Math.min(e.progress, 1), -1);
					n($(e), t, r);
				});
			};
			var s = function e() {
				var r = t.$el,
					a = t.$wrapperEl,
					i = t.slides,
					s = t.width,
					o = t.height,
					l = t.rtlTranslate,
					f = t.size,
					u = t.browser;
				var c = t.params.cubeEffect;
				var d = t.isHorizontal();
				var p = t.virtual && t.params.virtual.enabled;
				var v = 0;
				var h;
				if (c.shadow)
					if (d) {
						h = a.find(".swiper-cube-shadow");
						if (h.length === 0) {
							h = $('<div class="swiper-cube-shadow"></div>');
							a.append(h);
						}
						h.css({ height: "".concat(s, "px") });
					} else {
						h = r.find(".swiper-cube-shadow");
						if (h.length === 0) {
							h = $('<div class="swiper-cube-shadow"></div>');
							r.append(h);
						}
					}
				for (var m = 0; m < i.length; m += 1) {
					var g = i.eq(m);
					var y = m;
					if (p) y = parseInt(g.attr("data-swiper-slide-index"), 10);
					var b = y * 90;
					var w = Math.floor(b / 360);
					if (l) {
						b = -b;
						w = Math.floor(-b / 360);
					}
					var S = Math.max(Math.min(g[0].progress, 1), -1);
					var E = 0;
					var x = 0;
					var T = 0;
					if (y % 4 === 0) {
						E = -w * 4 * f;
						T = 0;
					} else if ((y - 1) % 4 === 0) {
						E = 0;
						T = -w * 4 * f;
					} else if ((y - 2) % 4 === 0) {
						E = f + w * 4 * f;
						T = f;
					} else if ((y - 3) % 4 === 0) {
						E = -f;
						T = 3 * f + f * 4 * w;
					}
					if (l) E = -E;
					if (!d) {
						x = E;
						E = 0;
					}
					var C = "rotateX("
						.concat(d ? 0 : -b, "deg) rotateY(")
						.concat(d ? b : 0, "deg) translate3d(")
						.concat(E, "px, ")
						.concat(x, "px, ")
						.concat(T, "px)");
					if (S <= 1 && S > -1) {
						v = y * 90 + S * 90;
						if (l) v = -y * 90 - S * 90;
					}
					g.transform(C);
					if (c.slideShadows) n(g, S, d);
				}
				a.css({ "-webkit-transform-origin": "50% 50% -".concat(f / 2, "px"), "transform-origin": "50% 50% -".concat(f / 2, "px") });
				if (c.shadow)
					if (d)
						h.transform(
							"translate3d(0px, "
								.concat(s / 2 + c.shadowOffset, "px, ")
								.concat(-s / 2, "px) rotateX(90deg) rotateZ(0deg) scale(")
								.concat(c.shadowScale, ")"),
						);
					else {
						var M = Math.abs(v) - Math.floor(Math.abs(v) / 90) * 90;
						var P = 1.5 - (Math.sin((M * 2 * Math.PI) / 360) / 2 + Math.cos((M * 2 * Math.PI) / 360) / 2);
						var O = c.shadowScale;
						var k = c.shadowScale / P;
						var A = c.shadowOffset;
						h.transform(
							"scale3d("
								.concat(O, ", 1, ")
								.concat(k, ") translate3d(0px, ")
								.concat(o / 2 + A, "px, ")
								.concat(-o / 2 / k, "px) rotateX(-90deg)"),
						);
					}
				var I = u.isSafari || u.isWebView ? -f / 2 : 0;
				a.transform(
					"translate3d(0px,0,"
						.concat(I, "px) rotateX(")
						.concat(t.isHorizontal() ? 0 : v, "deg) rotateY(")
						.concat(t.isHorizontal() ? -v : 0, "deg)"),
				);
				a[0].style.setProperty("--swiper-cube-translate-z", "".concat(I, "px"));
			};
			var o = function e(r) {
				var a = t.$el,
					n = t.slides;
				n.transition(r).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(r);
				if (t.params.cubeEffect.shadow && !t.isHorizontal()) a.find(".swiper-cube-shadow").transition(r);
			};
			effectInit({
				effect: "cube",
				swiper: t,
				on: a,
				setTranslate: s,
				setTransition: o,
				recreateShadows: i,
				getEffectParams: function e() {
					return t.params.cubeEffect;
				},
				perspective: function e() {
					return true;
				},
				overwriteParams: function e() {
					return { slidesPerView: 1, slidesPerGroup: 1, watchSlidesProgress: true, resistanceRatio: 0, spaceBetween: 0, centeredSlides: false, virtualTranslate: true };
				},
			});
		}
		function hl(e, t, r) {
			var a = "swiper-slide-shadow".concat(r ? "-".concat(r) : "");
			var n = e.transformEl ? t.find(e.transformEl) : t;
			var i = n.children(".".concat(a));
			if (!i.length) {
				i = $('<div class="swiper-slide-shadow'.concat(r ? "-".concat(r) : "", '"></div>'));
				n.append(i);
			}
			return i;
		}
		function ml(e) {
			var t = e.swiper,
				r = e.extendParams,
				a = e.on;
			r({ flipEffect: { slideShadows: true, limitRotation: true, transformEl: null } });
			var n = function e(r, a, n) {
				var i = t.isHorizontal() ? r.find(".swiper-slide-shadow-left") : r.find(".swiper-slide-shadow-top");
				var s = t.isHorizontal() ? r.find(".swiper-slide-shadow-right") : r.find(".swiper-slide-shadow-bottom");
				if (i.length === 0) i = createShadow(n, r, t.isHorizontal() ? "left" : "top");
				if (s.length === 0) s = createShadow(n, r, t.isHorizontal() ? "right" : "bottom");
				if (i.length) i[0].style.opacity = Math.max(-a, 0);
				if (s.length) s[0].style.opacity = Math.max(a, 0);
			};
			var i = function e() {
				var r = t.params.flipEffect;
				t.slides.each(function (e) {
					var a = $(e);
					var i = a[0].progress;
					if (t.params.flipEffect.limitRotation) i = Math.max(Math.min(e.progress, 1), -1);
					n(a, i, r);
				});
			};
			var s = function e() {
				var r = t.slides,
					a = t.rtlTranslate;
				var i = t.params.flipEffect;
				for (var s = 0; s < r.length; s += 1) {
					var o = r.eq(s);
					var l = o[0].progress;
					if (t.params.flipEffect.limitRotation) l = Math.max(Math.min(o[0].progress, 1), -1);
					var f = o[0].swiperSlideOffset;
					var u = -180 * l;
					var c = u;
					var d = 0;
					var p = t.params.cssMode ? -f - t.translate : -f;
					var v = 0;
					if (!t.isHorizontal()) {
						v = p;
						p = 0;
						d = -c;
						c = 0;
					} else if (a) c = -c;
					o[0].style.zIndex = -Math.abs(Math.round(l)) + r.length;
					if (i.slideShadows) n(o, l, i);
					var h = "translate3d(".concat(p, "px, ").concat(v, "px, 0px) rotateX(").concat(d, "deg) rotateY(").concat(c, "deg)");
					var m = effectTarget(i, o);
					m.transform(h);
				}
			};
			var o = function e(r) {
				var a = t.params.flipEffect.transformEl;
				var n = a ? t.slides.find(a) : t.slides;
				n.transition(r).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(r);
				effectVirtualTransitionEnd({ swiper: t, duration: r, transformEl: a });
			};
			effectInit({
				effect: "flip",
				swiper: t,
				on: a,
				setTranslate: s,
				setTransition: o,
				recreateShadows: i,
				getEffectParams: function e() {
					return t.params.flipEffect;
				},
				perspective: function e() {
					return true;
				},
				overwriteParams: function e() {
					return { slidesPerView: 1, slidesPerGroup: 1, watchSlidesProgress: true, spaceBetween: 0, virtualTranslate: !t.params.cssMode };
				},
			});
		}
		function gl(e) {
			var t = e.swiper,
				r = e.extendParams,
				a = e.on;
			r({ coverflowEffect: { rotate: 50, stretch: 0, depth: 100, scale: 1, modifier: 1, slideShadows: true, transformEl: null } });
			var n = function e() {
				var r = t.width,
					a = t.height,
					n = t.slides,
					i = t.slidesSizesGrid;
				var s = t.params.coverflowEffect;
				var o = t.isHorizontal();
				var l = t.translate;
				var f = o ? -l + r / 2 : -l + a / 2;
				var u = o ? s.rotate : -s.rotate;
				var c = s.depth;
				for (var d = 0, p = n.length; d < p; d += 1) {
					var v = n.eq(d);
					var h = i[d];
					var m = v[0].swiperSlideOffset;
					var g = (f - m - h / 2) / h;
					var y = typeof s.modifier === "function" ? s.modifier(g) : g * s.modifier;
					var b = o ? u * y : 0;
					var w = o ? 0 : u * y;
					var S = -c * Math.abs(y);
					var E = s.stretch;
					if (typeof E === "string" && E.indexOf("%") !== -1) E = (parseFloat(s.stretch) / 100) * h;
					var x = o ? 0 : E * y;
					var T = o ? E * y : 0;
					var C = 1 - (1 - s.scale) * Math.abs(y);
					if (Math.abs(T) < 0.001) T = 0;
					if (Math.abs(x) < 0.001) x = 0;
					if (Math.abs(S) < 0.001) S = 0;
					if (Math.abs(b) < 0.001) b = 0;
					if (Math.abs(w) < 0.001) w = 0;
					if (Math.abs(C) < 0.001) C = 0;
					var M = "translate3d(".concat(T, "px,").concat(x, "px,").concat(S, "px)  rotateX(").concat(w, "deg) rotateY(").concat(b, "deg) scale(").concat(C, ")");
					var P = effectTarget(s, v);
					P.transform(M);
					v[0].style.zIndex = -Math.abs(Math.round(y)) + 1;
					if (s.slideShadows) {
						var O = o ? v.find(".swiper-slide-shadow-left") : v.find(".swiper-slide-shadow-top");
						var k = o ? v.find(".swiper-slide-shadow-right") : v.find(".swiper-slide-shadow-bottom");
						if (O.length === 0) O = createShadow(s, v, o ? "left" : "top");
						if (k.length === 0) k = createShadow(s, v, o ? "right" : "bottom");
						if (O.length) O[0].style.opacity = y > 0 ? y : 0;
						if (k.length) k[0].style.opacity = -y > 0 ? -y : 0;
					}
				}
			};
			var i = function e(r) {
				var a = t.params.coverflowEffect.transformEl;
				var n = a ? t.slides.find(a) : t.slides;
				n.transition(r).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(r);
			};
			effectInit({
				effect: "coverflow",
				swiper: t,
				on: a,
				setTranslate: n,
				setTransition: i,
				perspective: function e() {
					return true;
				},
				overwriteParams: function e() {
					return { watchSlidesProgress: true };
				},
			});
		}
		function yl(e) {
			var t = e.swiper,
				r = e.extendParams,
				a = e.on;
			r({
				creativeEffect: {
					transformEl: null,
					limitProgress: 1,
					shadowPerProgress: false,
					progressMultiplier: 1,
					perspective: true,
					prev: {
						translate: [
							0,
							0,
							0,
						],
						rotate: [
							0,
							0,
							0,
						],
						opacity: 1,
						scale: 1,
					},
					next: {
						translate: [
							0,
							0,
							0,
						],
						rotate: [
							0,
							0,
							0,
						],
						opacity: 1,
						scale: 1,
					},
				},
			});
			var n = function e(t) {
				if (typeof t === "string") return t;
				return "".concat(t, "px");
			};
			var i = function e() {
				var r = t.slides,
					a = t.$wrapperEl,
					i = t.slidesSizesGrid;
				var s = t.params.creativeEffect;
				var o = s.progressMultiplier;
				var l = t.params.centeredSlides;
				if (l) {
					var f = i[0] / 2 - t.params.slidesOffsetBefore || 0;
					a.transform("translateX(calc(50% - ".concat(f, "px))"));
				}
				var u = function e() {
					var a = r.eq(c);
					var i = a[0].progress;
					var f = Math.min(Math.max(a[0].progress, -s.limitProgress), s.limitProgress);
					var u = f;
					if (!l) u = Math.min(Math.max(a[0].originalProgress, -s.limitProgress), s.limitProgress);
					var d = a[0].swiperSlideOffset;
					var p = [
						t.params.cssMode ? -d - t.translate : -d,
						0,
						0,
					];
					var v = [
						0,
						0,
						0,
					];
					var h = false;
					if (!t.isHorizontal()) {
						p[1] = p[0];
						p[0] = 0;
					}
					var m = {
						translate: [
							0,
							0,
							0,
						],
						rotate: [
							0,
							0,
							0,
						],
						scale: 1,
						opacity: 1,
					};
					if (f < 0) {
						m = s.next;
						h = true;
					} else if (f > 0) {
						m = s.prev;
						h = true;
					}
					p.forEach(function (e, t) {
						p[t] = "calc("
							.concat(e, "px + (")
							.concat(n(m.translate[t]), " * ")
							.concat(Math.abs(f * o), "))");
					});
					v.forEach(function (e, t) {
						v[t] = m.rotate[t] * Math.abs(f * o);
					});
					a[0].style.zIndex = -Math.abs(Math.round(i)) + r.length;
					var g = p.join(", ");
					var y = "rotateX(".concat(v[0], "deg) rotateY(").concat(v[1], "deg) rotateZ(").concat(v[2], "deg)");
					var b = u < 0 ? "scale(".concat(1 + (1 - m.scale) * u * o, ")") : "scale(".concat(1 - (1 - m.scale) * u * o, ")");
					var w = u < 0 ? 1 + (1 - m.opacity) * u * o : 1 - (1 - m.opacity) * u * o;
					var S = "translate3d(".concat(g, ") ").concat(y, " ").concat(b);
					if ((h && m.shadow) || !h) {
						var E = a.children(".swiper-slide-shadow");
						if (E.length === 0 && m.shadow) E = createShadow(s, a);
						if (E.length) {
							var x = s.shadowPerProgress ? f * (1 / s.limitProgress) : f;
							E[0].style.opacity = Math.min(Math.max(Math.abs(x), 0), 1);
						}
					}
					var T = effectTarget(s, a);
					T.transform(S).css({ opacity: w });
					if (m.origin) T.css("transform-origin", m.origin);
				};
				for (var c = 0; c < r.length; c += 1) u();
			};
			var s = function e(r) {
				var a = t.params.creativeEffect.transformEl;
				var n = a ? t.slides.find(a) : t.slides;
				n.transition(r).find(".swiper-slide-shadow").transition(r);
				effectVirtualTransitionEnd({ swiper: t, duration: r, transformEl: a, allSlides: true });
			};
			effectInit({
				effect: "creative",
				swiper: t,
				on: a,
				setTranslate: i,
				setTransition: s,
				perspective: function e() {
					return t.params.creativeEffect.perspective;
				},
				overwriteParams: function e() {
					return { watchSlidesProgress: true, virtualTranslate: !t.params.cssMode };
				},
			});
		}
		function bl(e) {
			var t = e.swiper,
				r = e.extendParams,
				a = e.on;
			r({ cardsEffect: { slideShadows: true, transformEl: null, rotate: true, perSlideRotate: 2, perSlideOffset: 8 } });
			var n = function e() {
				var r = t.slides,
					a = t.activeIndex;
				var n = t.params.cardsEffect;
				var i = t.touchEventsData,
					s = i.startTranslate,
					o = i.isTouched;
				var l = t.translate;
				for (var f = 0; f < r.length; f += 1) {
					var u = r.eq(f);
					var c = u[0].progress;
					var d = Math.min(Math.max(c, -4), 4);
					var p = u[0].swiperSlideOffset;
					if (t.params.centeredSlides && !t.params.cssMode) t.$wrapperEl.transform("translateX(".concat(t.minTranslate(), "px)"));
					if (t.params.centeredSlides && t.params.cssMode) p -= r[0].swiperSlideOffset;
					var v = t.params.cssMode ? -p - t.translate : -p;
					var h = 0;
					var m = -100 * Math.abs(d);
					var g = 1;
					var y = -n.perSlideRotate * d;
					var b = n.perSlideOffset - Math.abs(d) * 0.75;
					var w = t.virtual && t.params.virtual.enabled ? t.virtual.from + f : f;
					var S = (w === a || w === a - 1) && d > 0 && d < 1 && (o || t.params.cssMode) && l < s;
					var E = (w === a || w === a + 1) && d < 0 && d > -1 && (o || t.params.cssMode) && l > s;
					if (S || E) {
						var x = Math.pow(1 - Math.abs((Math.abs(d) - 0.5) / 0.5), 0.5);
						y += -28 * d * x;
						g += -0.5 * x;
						b += 96 * x;
						h = "".concat(-25 * x * Math.abs(d), "%");
					}
					if (d < 0) v = "calc(".concat(v, "px + (").concat(b * Math.abs(d), "%))");
					else if (d > 0) v = "calc(".concat(v, "px + (-").concat(b * Math.abs(d), "%))");
					else v = "".concat(v, "px");
					if (!t.isHorizontal()) {
						var T = h;
						h = v;
						v = T;
					}
					var C = d < 0 ? "".concat(1 + (1 - g) * d) : "".concat(1 - (1 - g) * d);
					var M = "\n        translate3d("
						.concat(v, ", ")
						.concat(h, ", ")
						.concat(m, "px)\n        rotateZ(")
						.concat(n.rotate ? y : 0, "deg)\n        scale(")
						.concat(C, ")\n      ");
					if (n.slideShadows) {
						var P = u.find(".swiper-slide-shadow");
						if (P.length === 0) P = createShadow(n, u);
						if (P.length) P[0].style.opacity = Math.min(Math.max((Math.abs(d) - 0.5) / 0.5, 0), 1);
					}
					u[0].style.zIndex = -Math.abs(Math.round(c)) + r.length;
					var O = effectTarget(n, u);
					O.transform(M);
				}
			};
			var i = function e(r) {
				var a = t.params.cardsEffect.transformEl;
				var n = a ? t.slides.find(a) : t.slides;
				n.transition(r).find(".swiper-slide-shadow").transition(r);
				effectVirtualTransitionEnd({ swiper: t, duration: r, transformEl: a });
			};
			effectInit({
				effect: "cards",
				swiper: t,
				on: a,
				setTranslate: n,
				setTransition: i,
				perspective: function e() {
					return true;
				},
				overwriteParams: function e() {
					return { watchSlidesProgress: true, virtualTranslate: !t.params.cssMode };
				},
			});
		}
		function wl(e) {
			"@babel/helpers - typeof";
			return (
				(wl =
					"function" == typeof Symbol && "symbol" == typeof Symbol.iterator
						? function (e) {
								return typeof e;
							}
						: function (e) {
								return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
							}),
				wl(e)
			);
		}
		function Sl(e, t) {
			if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
		}
		function El(e, t) {
			for (var r = 0; r < t.length; r++) {
				var a = t[r];
				((a.enumerable = a.enumerable || !1), (a.configurable = !0), "value" in a && (a.writable = !0), Object.defineProperty(e, Tl(a.key), a));
			}
		}
		function xl(e, t, r) {
			return (t && El(e.prototype, t), r && El(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e);
		}
		function Tl(e) {
			var t = Cl(e, "string");
			return "symbol" == wl(t) ? t : t + "";
		}
		function Cl(e, t) {
			if ("object" != wl(e) || !e) return e;
			var r = e[Symbol.toPrimitive];
			if (void 0 !== r) {
				var a = r.call(e, t || "default");
				if ("object" != wl(a)) return a;
				throw new TypeError("@@toPrimitive must return a primitive value.");
			}
			return ("string" === t ? String : Number)(e);
		}
		function Ml(e, t, r) {
			return ((t = Dl(t)), Pl(e, Il() ? Reflect.construct(t, r || [], Dl(e).constructor) : t.apply(e, r)));
		}
		function Pl(e, t) {
			if (t && ("object" == wl(t) || "function" == typeof t)) return t;
			if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
			return Ol(e);
		}
		function Ol(e) {
			if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
			return e;
		}
		function kl(e, t) {
			if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
			((e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } })), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ll(e, t));
		}
		function $l(e) {
			var t = "function" == typeof Map ? new Map() : void 0;
			return (
				($l = function e(r) {
					if (null === r || !zl(r)) return r;
					if ("function" != typeof r) throw new TypeError("Super expression must either be null or a function");
					if (void 0 !== t) {
						if (t.has(r)) return t.get(r);
						t.set(r, a);
					}
					function a() {
						return Al(r, arguments, Dl(this).constructor);
					}
					return ((a.prototype = Object.create(r.prototype, { constructor: { value: a, enumerable: !1, writable: !0, configurable: !0 } })), Ll(a, r));
				}),
				$l(e)
			);
		}
		function Al(e, t, r) {
			if (Il()) return Reflect.construct.apply(null, arguments);
			var a = [
				null,
			];
			a.push.apply(a, t);
			var n = new (e.bind.apply(e, a))();
			return (r && Ll(n, r.prototype), n);
		}
		function Il() {
			try {
				var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
			} catch (e) {}
			return (Il = function t() {
				return !!e;
			})();
		}
		function zl(e) {
			try {
				return -1 !== Function.toString.call(e).indexOf("[native code]");
			} catch (t) {
				return "function" == typeof e;
			}
		}
		function Ll(e, t) {
			return (
				(Ll = Object.setPrototypeOf
					? Object.setPrototypeOf.bind()
					: function (e, t) {
							return ((e.__proto__ = t), e);
						}),
				Ll(e, t)
			);
		}
		function Dl(e) {
			return (
				(Dl = Object.setPrototypeOf
					? Object.getPrototypeOf.bind()
					: function (e) {
							return e.__proto__ || Object.getPrototypeOf(e);
						}),
				Dl(e)
			);
		}
		window.FoxTheme = window.FoxTheme || {};
		window.FoxTheme.Motion = { animate: lt, inView: ut, timeline: or, stagger: rt, scroll: ea };
		window.FoxTheme.Swiper = { Navigation: Ko, Pagination: Qo, Thumbs: ll, Autoplay: ol, EffectFade: pl, Mousewheel: Yo, Controller: al, A11y: nl, Swiper: qo };
		var jl = (function (e) {
			function t() {
				var e;
				Sl(this, t);
				e = Ml(this, t);
				e.observer = null;
				return e;
			}
			kl(t, e);
			return xl(t, [
				{
					key: "connectedCallback",
					value: function e() {
						var t = this;
						this.wrapper = this.closest(".media-wrapper");
						if (!this.wrapper) return;
						if (!this.observer)
							this.observer = new MutationObserver(function (e) {
								e.forEach(function (e) {
									if (e.attributeName === "src" || e.attributeName === "srcset") t.handleLazyLoad();
								});
							});
						this.observer.observe(this, { attributes: true });
						this.handleLazyLoad();
						this._boundHandlePageShow = this.handlePageShow.bind(this);
						window.addEventListener("pageshow", this._boundHandlePageShow);
					},
				},
				{
					key: "disconnectedCallback",
					value: function e() {
						if (this.observer) {
							this.observer.disconnect();
							this.observer = null;
						}
						if (this._boundHandlePageShow) {
							window.removeEventListener("pageshow", this._boundHandlePageShow);
							this._boundHandlePageShow = null;
						}
					},
				},
				{
					key: "handleLazyLoad",
					value: function e() {
						var t,
							r = this;
						if (this.complete || this.classList.contains("loaded")) {
							var a, n;
							(a = this.wrapper) === null || a === void 0 || a.classList.add("loaded");
							(n = this.wrapper) === null || n === void 0 || n.classList.remove("loading");
							if (!this.classList.contains("loaded")) this.classList.add("loaded");
							return;
						}
						(t = this.wrapper) === null || t === void 0 || t.classList.add("loading");
						this.addEventListener(
							"load",
							function () {
								var e = function e() {
									var t, a;
									r.classList.add("loaded");
									(t = r.wrapper) === null || t === void 0 || t.classList.remove("loading");
									(a = r.wrapper) === null || a === void 0 || a.classList.add("loaded");
								};
								var t =
									window.requestIdleCallback ||
									function (e) {
										return setTimeout(e, 0);
									};
								t(e, { timeout: 150 });
							},
							{ once: true },
						);
						this.addEventListener(
							"error",
							function () {
								var e, t;
								(e = r.wrapper) === null || e === void 0 || e.classList.remove("loading");
								(t = r.wrapper) === null || t === void 0 || t.classList.add("error");
								void 0;
							},
							{ once: true },
						);
					},
				},
				{
					key: "handlePageShow",
					value: function e(t) {
						var r = this;
						if (!t.persisted) return;
						this.handleLazyLoad();
						if (!this.complete || this.naturalWidth === 0) {
							var a = this.getAttribute("src");
							if (a) {
								this.removeAttribute("src");
								requestAnimationFrame(function () {
									r.setAttribute("src", a);
								});
							}
						}
					},
				},
			]);
		})($l(HTMLImageElement));
		window.customElements.define("image-lazy", jl, { extends: "img" });
	})();
})();
